/** Authored Console UI copy. Interpolated content is never translated. */
export const englishMessages = Object.freeze({
  "实验": "Experimental",
  "实验 · 不受官方支持 · 可能违反供应商条款 · 风险由使用者自行承担。": "Experimental · Not officially supported · May violate the provider’s terms · Use at your own risk.",
  "未经 OpenAI 对第三方客户端的明确授权。": "No explicit authorization from OpenAI for third-party clients.",
  "管理模型用途": "Manage model purposes",
  "保存回执：{0}": "Save receipt: {0}",
  "正在应用已保存配置…": "Applying saved configuration…",
  "此文件版本与当前运行配置一致。": "This file version matches the active runtime configuration.",
  "配置应用校验失败；请修正配置后再应用。": "Application validation failed. Correct the configuration before applying it again.",
  "该次生效申请已被较新修订替代，请刷新当前文件状态。": "A newer revision superseded this application request. Refresh the current file status.",
  "文件已在别处更新，未提交应用；请先刷新。": "The file changed elsewhere. This application was not submitted; refresh first.",
  "应用结果未确认，请只读刷新核对；不要重复提交。": "The application outcome is unconfirmed. Refresh to verify; do not submit again.",
  "配置校验失败，本次未应用；请修正后刷新。": "Validation failed and this request was not applied. Correct the configuration and refresh.",
  "旧版本：{0}": "Previous version: {0}",
  "证据文件版本：{0}": "Evidence file version: {0}",
  "运行代：{0}": "Generation: {0}",
  "配置应用结果未确认，请只读刷新核对；不要重复提交。": "Configuration application is unconfirmed. Refresh to verify; do not submit it again.",
  "Host 未提供配置应用明细，保存不代表已经生效。": "This Host provides no application details. Saving does not confirm that configuration is active.",
  "运行证据属于其他文件版本，当前版本尚未确认生效。": "The runtime evidence belongs to another file version. The current version is not confirmed active.",
  "Host 尚未记录此文件版本的配置应用明细。": "The Host has not recorded application details for this file version.",
  "此应用结果已被后续变更替代，请刷新当前文件状态。": "Later changes superseded this result. Refresh the current file status.",
  "存在配置应用失败；请查看各项状态。": "Some configuration changes failed to apply. Check each item below.",
  "此文件版本的配置变更已生效。": "Configuration changes for this file version are active.",
  "部分配置已生效；其余待重启或等待依赖。": "Some changes are active; others require a restart or are waiting for dependencies.",
  "配置等待进程重启，当前运行仍使用旧值。": "These changes require a process restart. The runtime still uses the previous values.",
  "配置暂未生效，依赖条件尚未满足。": "These changes are not active yet because their dependencies are not ready.",
  "原地更新": "Update in place",
  "替换资源": "Replace resource",
  "账号重连": "Reconnect account",
  "插件重载": "Reload plugin",
  "进程重启": "Restart process",
  "未识别的更新方式": "Unrecognized update method",
  "已生效": "Active",
  "待重启": "Restart pending",
  "依赖阻塞": "Dependency blocked",
  "应用失败": "Application failed",
  "已被替代": "Superseded",
  "结果未确认": "Unconfirmed",
  "运行生效状态": "Runtime application status",
  "刷新运行状态": "Refresh runtime status",
  "以下是已保存版本的生效结果。": "Application results for the saved configuration.",
  "文件版本：{0}": "File version: {0}",
  "应用序号：{0}": "Application revision: {0}",
  "依赖：{0}": "Depends on: {0}",
  "原因代码：{0}": "Reason code: {0}",
  "Host 未提供可显示的原因代码": "The Host provided no displayable reason code",
  "配置已保存。": "Configuration saved.",
  "消息信息": "Message info",
  "消息内容": "Message text",
  "输入消息…": "Write a message…",
  "输入 Markdown 消息…": "Write a Markdown message…",
  "Enter 发送 · Shift+Enter 换行": "Enter to send · Shift+Enter for a new line",
  "会话列表": "Conversation list",
  "发送": "Send",
  "关闭会话列表": "Close conversation list",
  "等待登录": "Waiting for login",
  "连接中": "Connecting",
  "重连中": "Reconnecting",
  "记住此连接": "Remember this connection",
  "访问令牌仅保留在本次浏览器会话。": "Your access token is kept only for this browser session.",
  "连接你的机器人": "Connect to your bot",
  "连接运行 Zhin 的设备，管理会话、账号和任务。": "Connect to the device running Zhin to manage conversations, accounts, and tasks.",
  "令牌用于验证你的访问权限。": "Your token verifies your access to this Host.",
  "连接设置": "Connection settings",
  "Host 地址": "Host address",
  "填写机器人启动日志中的地址。": "Use the address shown in your bot's startup logs.",
  "访问令牌": "Access token",
  "隐藏令牌": "Hide token",
  "显示令牌": "Show token",
  "无法连接？": "Trouble connecting?",
  "最终尝试：输入 {0} / 输出 {1} tokens": "Final attempt: input {0} / output {1} tokens",
  "最终尝试耗时：{0} 秒": "Final attempt duration: {0} s",
  "部分完成（预算耗尽）": "Partially completed (budget exhausted)",
  "状态待核对": "Status needs verification",
  "其余投递结果未知": "Remaining delivery outcomes unknown",
  "运行信息": "Run information",
  "运行 ID": "Run ID",
  "触发来源": "Trigger source",
  "定时触发": "Scheduled",
  "手动触发": "Manual",
  "事件触发": "Event",
  "预演": "Preview",
  "计划执行时间": "Scheduled time",
  "结束时间": "Finished at",
  "创建者": "Created by",
  "投递会话": "Delivery conversation",
  "开始执行": "Execution started",
  "开始模型回合": "Model iteration started",
  "发起调用": "Call started",
  "已返回": "Returned",
  "调用失败": "Call failed",
  "调用已取消": "Call cancelled",
  "调用被拒绝": "Call denied",
  "部分执行记录未完整保存。": "Some execution records were not fully saved.",
  "执行记录响应与当前任务不匹配，或格式无效。": "The execution record does not match this task, or its format is invalid.",
  "需要当前 Host 的 full 权限才能查看执行记录。": "Full access to this Host is required to view execution history.",
  "执行记录不存在、已过期，或当前 Host 尚不支持执行记录。": "The execution record is missing, has expired, or is unsupported by this Host.",
  "执行记录存储暂不可用，请稍后重新读取。": "Execution history storage is unavailable. Read it again later.",
  "执行记录读取失败，请检查连接后重试。": "Could not read execution history. Check the connection and try again.",
  "执行已中断，结果未确认": "Interrupted; outcome unconfirmed",
  "状态未识别": "Unrecognized status",
  "无需投递": "No delivery requested",
  "未投递": "Not sent",
  "投递完成": "Delivered",
  "部分投递": "Partially delivered",
  "投递失败": "Delivery failed",
  "投递结果未知": "Delivery outcome unknown",
  "未记录投递结果": "Delivery outcome not recorded",
  "开始": "Started",
  "完成": "Completed",
  "等待中": "Pending",
  "已允许": "Allowed",
  "结果未知": "Outcome unknown",
  "未提交": "Not submitted",
  "已提交": "Submitted",
  "尚未记录最终结果。": "No final result has been recorded yet.",
  "未记录输出内容。": "No output was recorded.",
  "输入 {0} / 输出 {1} tokens": "Input {0} / output {1} tokens",
  "通知投递": "Notification delivery",
  "正在读取诊断轨迹…": "Loading diagnostic trace…",
  "终止状态：{0}": "Termination: {0}",
  "此轨迹没有保留模型或工具明细。": "This trace has no retained model or tool details.",
  "{0} 次尝试": "{0} attempts",
  "部分执行记录未能持久保存，以下记录可能不完整。": "Some execution records could not be saved. This history may be incomplete.",
  "进程中断前未记录最终结果，不能据此判断操作是否完成。": "No final result was recorded before the process stopped. The operation outcome is unconfirmed.",
  "执行详情": "Execution details",
  "最终结果": "Final result",
  "执行过程": "Process",
  "已入队": "Queued",
  "尝试 {0}": "Attempt {0}",
  "本次尝试已完成": "This attempt completed",
  "本次尝试已取消": "This attempt was cancelled",
  "本次尝试未完成": "This attempt did not complete",
  "尚未记录本次尝试结果。": "No result has been recorded for this attempt yet.",
  "继续重试：{0}": "Retrying: {0}",
  "停止重试：{0}": "Retries stopped: {0}",
  "收起诊断轨迹": "Hide diagnostic trace",
  "查看诊断轨迹": "View diagnostic trace",
  "任务已取消": "Task cancelled",
  "已达到尝试次数上限": "Attempt limit reached",
  "操作已提交，避免重复执行": "Operation submitted; avoiding duplicate execution",
  "操作结果未知，不能自动重放": "Operation outcome unknown; automatic replay blocked",
  "错误不支持重试": "The error is not retryable",
  "仅执行了只读操作": "Only read-only operations ran",
  "操作尚未提交": "Operation not submitted",
  "刷新记录": "Refresh history",
  "正在读取执行记录…": "Loading execution history…",
  "清理过期记录": "Clean up expired history",
  "已清理 {0} 条过期执行记录。": "Removed {0} expired execution records.",
  "清理结果尚未确认，请重新读取记录核实。": "The cleanup outcome is unconfirmed. Read the history again to verify.",
  "暂无可用执行记录。较早的执行可能未保存或已过期。": "No execution history is available. Earlier runs may not have been recorded or may have expired.",
  "记录不完整": "Incomplete history",
  "执行记录": "Execution history",
  "查看单次运行的结果与各次尝试过程。": "View the result of a run and the progress of its attempts.",
  "清理当前 Host 所有任务中超过一个自然月的非活动执行记录，正在运行的任务不受影响。": "Remove inactive execution records older than one calendar month for all tasks on this Host. Active runs are kept.",
  "清理中…": "Cleaning up…",
  "定时任务视图": "Scheduled task views",
  "跟随部署默认聊天": "Follow the deployment default chat model",
  "继承启动基线：{0}": "Inherit startup baseline: {0}",
  "部署模型目录": "Deployment model catalog",
  "管理部署模型目录和初始聊天模型。": "Manage deployment models and the initial chat model.",
  "运行时模型策略": "Runtime model policy",
  "按用途和作用域选择预设，下一轮生效。": "Select presets by purpose and scope, effective from the next operation.",
  "保存模型策略": "Save model policy",
  "下一轮生效；清空覆盖项可恢复继承。": "Applies to the next operation. Clear an override to inherit.",
  "正在读取模型策略…": "Loading model policy\u2026",
  "静态基线": "Startup baseline",
  "重新读取": "Read again",
  "提交结果尚未确认，请重新读取核实后再操作。": "The save result is unconfirmed. Read the current state before trying again.",
  "模型策略版本已变化，请重新读取后再保存。": "The model policy changed. Read the current version before saving.",
  "当前身份无权管理部署模型策略。": "Your identity cannot manage deployment model policies.",
  "模型策略无效，请检查预设引用和作用域。": "The model policy is invalid. Check its presets and scopes.",
  "模型策略暂时无法读取，请稍后重新读取。": "The model policy is unavailable. Read it again later.",
  "默认用途": "Default purposes",
  "聊天": "Chat",
  "识图": "Perception",
  "摘要": "Summary",
  "继承": "Inherit",
  "恢复继承": "Restore inheritance",
  "选择作用域": "Select scope",
  "添加作用域": "Add scope",
  "加载已记录会话": "Load recorded conversations",
  "作用域暂不可选": "Scope unavailable",
  "会话目录暂不可用。": "The conversation directory is unavailable.",
  "作用域目录暂不可用。": "The scope directory is unavailable.",
  "初始聊天模型": "Initial chat model",
  "选择模型预设": "Select model preset",
  "模型预设": "Model preset",
  "角色设置": "Role settings",
  "个人会话": "Personal session",
  "个人模型": "Personal models",
  "个人身份": "Personal identity",
  "请选择个人身份": "Select a personal identity",
  "管理自己的模型连接，为每个个人会话选择模型。": "Manage your model connections and choose a model for each personal session.",
  "我的模型连接": "My model connections",
  "新增连接": "Add connection",
  "API Key 只用于此个人身份，不会随会话记录导出。": "The API key is used only for this personal identity and is excluded from session exports.",
  "还没有个人模型连接。": "No personal model connections yet.",
  "新增模型连接": "Add model connection",
  "编辑模型连接": "Edit model connection",
  "协议": "Protocol",
  "请选择协议": "Select a protocol",
  "模型名称": "Model name",
  "个人连接仅支持公网 HTTPS 地址。": "Personal connections require a public HTTPS address.",
  "已保存密钥；留空保持现有密钥": "Key saved; leave blank to keep it",
  "输入 API Key": "Enter API key",
  "模型能力（可选）": "Model capabilities (optional)",
  "能力声明用于匹配模型，不授予工具权限。": "Capability declarations match models to requests; they do not grant tool permissions.",
  "支持的输入": "Supported inputs",
  "流式输出": "Streaming output",
  "工具调用能力": "Tool calling",
  "推理能力": "Reasoning",
  "支持": "Supported",
  "保存模型连接": "Save model connection",
  "模型连接已保存。": "Model connection saved.",
  "我的会话": "My sessions",
  "只显示此个人身份自己的会话。": "Only sessions owned by this personal identity are shown.",
  "加载我的会话": "Load my sessions",
  "还没有个人会话。": "No personal sessions yet.",
  "选择个人会话": "Choose a personal session",
  "请选择会话": "Select a session",
  "打开个人会话": "Open personal session",
  "此会话的模型": "Model for this session",
  "继承会话模型设置": "Inherit session model settings",
  "部署模型": "Host model",
  "保存模型选择": "Save model selection",
  "模型选择已保存。": "Model selection saved.",
  "当前预设不可用": "Current preset unavailable",
  "会话身份无法确认，未切换模型。": "The session identity could not be verified. No model was selected.",
  "个人会话目录读取失败。": "Could not load your personal session directory.",
  "在此个人身份下未找到该会话。": "This session was not found for the selected personal identity.",
  "请先登录个人账号。": "Sign in with your personal account first.",
  "当前账号尚未绑定此个人身份，请联系管理员。": "Your account is not bound to this personal identity. Contact your administrator.",
  "配置已被修改，请刷新后重试。": "The configuration has changed. Refresh before trying again.",
  "个人模型存储尚未就绪，请联系管理员。": "Personal model storage is unavailable. Contact your administrator.",
  "所选模型预设不存在，未切换模型。": "The selected model preset does not exist. No model was selected.",
  "所选模型不支持此用途，未切换模型。": "The selected model does not support this use. No model was selected.",
  "个人模型请求失败，请检查输入后重试。": "The personal model request failed. Check your input and try again.",
  "提交结果尚未确认，请刷新查看后再操作。": "The submission result is unconfirmed. Refresh to check it before taking another action.",
  "正在加载…": "Loading…",
  "Host 工具审批": "Host tool approvals",
  "刷新工具审批": "Refresh tool approvals",
  "Demo 只读": "Read-only demo",
  "连接 Host 后读取工具审批": "Connect to a Host to read tool approvals",
  "正在读取工具审批…": "Loading tool approvals…",
  "当前 Agent 未提供工具审批队列": "The current Agent has no tool approval queue",
  "当前没有待审批的工具请求": "No tool requests await approval",
  "有效期至 {0}": "Expires {0}",
  "发起会话：": "Triggering conversation: ",
  "发起人：": "Requested by: ",
  "批准一次": "Approve once",
  "确认批准本次工具请求": "Approve this tool request?",
  "确认拒绝本次工具请求": "Reject this tool request?",
  "审批回执与本次请求不一致": "The approval response does not match this request",
  "审批结果尚未确认，请重新读取后核对。": "The approval outcome is unconfirmed. Refresh to check it.",
  "自我变更审批": "Self-change approvals",
  "刷新自我变更": "Refresh self-changes",
  "连接 Host 后读取自我变更": "Connect to a Host to read self-changes",
  "正在读取自我变更…": "Loading self-changes…",
  "当前 Agent 未启用自我变更": "The current Agent does not run self-changes",
  "当前没有待审批的自我变更": "No self-changes await approval",
  "暂存区占用：{0}": "Staging usage: {0}",
  "急停待处理": "Emergency stops to handle",
  "最近的变更": "Recent changes",
  "详情": "Details",
  "状态：": "Status: ",
  "变更：": "Change: ",
  "试跑跳过：": "Skipped trial checks: ",
  "查看完整 diff": "View full diff",
  "批准变更": "Approve change",
  "驳回变更": "Reject change",
  "变更详情与所选变更不一致": "The change detail does not match the selected change",
  "查看完整 diff 需要 ops:approve 权限（{0}）": "Viewing the full diff requires the ops:approve permission ({0})",
  "确认批准这个自我变更": "Approve this self-change?",
  "确认驳回这个自我变更": "Reject this self-change?",
  "确认已处理这个急停变更": "Mark this emergency-stopped change as handled?",
  "内容摘要：": "Content hash: ",
  "你还没有查看这个变更的完整 diff，请先查看再批准，不要盲批。": "You have not viewed this change's full diff. Review it before approving — do not approve blind.",
  "批准只对这一版内容有效；批准后会写入生产目录并按影响面热重载或受控重启。": "Approval covers this exact content only. Once approved it is written to production and hot reloaded or restarted as its impact requires.",
  "变更详情": "Change details",
  "正在读取变更详情…": "Loading change details…",
  "正文已按保留规则清理，无法展示 diff": "Staged contents were cleaned up under the retention rules; no diff is available",
  "改动前：回滚快照": "Before: rollback snapshot",
  "改动前：生产目录现有文件": "Before: current production file",
  "diff {0} / {1}": "diff {0} / {1}",
  "部分内容已截断": "Partly truncated",
  "配置补丁（值已脱敏）": "Config patch (values redacted)",
  "试跑：通过": "Trial: passed",
  "试跑：未通过或未知": "Trial: not passed or unknown",
  "未执行的阶段：": "Stages not run: ",
  "暂存正文不可读": "Staged contents are unreadable",
  "原文件过大、是符号链接或不可读": "The original file is too large, a symlink, or unreadable",
  "超出 64 KB 展示预算，未展示": "Not shown: over the 64 KB display budget",
  "与改动前相同": "Identical to the original",
  "该文件 diff 已按展示预算截断": "This file's diff was cut at the display budget",
  "运行维护": "Operations",
  "设置与运行维护": "Settings and operations",
  "进入会话": "Open conversation",
  "与 Agent 对话并处理工作": "Talk to the Agent and get work done",
  "管理已配置的任务与执行记录": "Manage configured tasks and execution history",
  "配置模型、Agent 和插件": "Configure models, Agents, and plugins",
  "文件管理": "File manager",
  "配置读取失败。": "Could not load configuration.",
  "此分类暂时无法编辑。": "This category is currently unavailable for editing.",
  "。草稿已保留。": ". Your draft is preserved.",
  "打开文件管理": "Open file manager",
  "配置字段定义不可用，请在文件管理中查看配置。": "Setting definitions are unavailable. Open the file manager to view the configuration.",
  "账号": "Account",
  "任务详情": "Task details",
  "当前判断由其他服务提供，请到设置中调整。": "Another service handles these decisions. You can change it in settings.",
  "投递目标": "Destination",
  "请选择账号": "Select an account",
  "父容器与话题（可选）": "Parent and thread (optional)",
  "投递目标保持不变。": "The destination stays the same.",
  "目标详情": "Destination details",
  "当前没有管理员任务。": "No administrator tasks yet.",
  "查看记录": "View history",
  "查看全文": "Read full message",
  "此消息已不可用，或 Host 尚不支持读取全文。": "This message is unavailable, or the Host does not support full messages yet.",
  "消息正文读取失败。": "Could not read the message.",
  "（无文字内容）": "(No text content)",
  "最近结果：": "Latest result:",
  "搜索定时任务": "Search scheduled tasks",
  "搜索任务内容或名称…": "Search task content or name…",
  "任务状态": "Task status",
  "已暂停或停止": "Paused or stopped",
  "AI 定时任务": "AI tasks",
  "定时任务": "Scheduled tasks",
  "自定义执行时间": "Custom schedule",
  "任务内容": "Task content",
  "创建时间": "Created",
  "最近执行": "Last run",
  "插件定时任务": "Plugin tasks",
  "会话分支还没准备好，请检查 Agent 配置。": "Session branches are not ready. Check the Agent configuration.",
  "切换对话": "Choose conversation",
  "当前对话": "Current conversation",
  "记录视图": "History view",
  "对话": "Conversation",
  "会话分支": "Session branches",
  "选择一个对话": "Choose a conversation",
  "从这里继续": "Continue from here",
  "从“聊天账号”选择联系人、群组或频道。": "Choose a contact, group, or channel from Chat accounts.",
  "查看聊天记录": "View chat history",
  "聊天记录响应格式不正确。": "The chat history response is invalid.",
  "聊天记录读取失败。": "Could not read chat history.",
  "尚无可读取的聊天记录。": "No saved chat history is available.",
  "尚无可读取的聊天记录，或当前 Host 尚不支持此功能。": "No chat history is available, or this Host does not support it yet.",
  "此会话对应多个频道或话题，无法准确读取。": "This conversation matches multiple channels or topics and cannot be selected accurately.",
  "聊天记录暂不可用，请稍后重试。": "Chat history is temporarily unavailable. Try again later.",
  "会话标识或分页参数无效。": "The conversation or page cursor is invalid.",
  "当前身份无权读取聊天记录。": "Your current account cannot read chat history.",
  "聊天记录读取失败（HTTP {0}）。": "Could not read chat history (HTTP {0}).",
  "加载更早记录": "Load earlier messages",
  "当前记录中没有聊天消息。": "There are no chat messages in these records.",
  "消息已撤回": "A message was recalled",
  "已撤回": "Recalled",
  "请连接 Host 后读取功能。": "Connect to a Host to view features.",
  "连接身份已变化，请重新读取。": "The connection identity changed. Reload the data.",
  "当前机器人": "Bot",
  "会话详情": "Conversation details",
  "暂无可继续的消息": "No messages to continue from",
  "从这条消息继续": "Continue from this message",
  "后续 AI 对话将从这条消息继续。": "Future AI conversation will continue from this message.",

  "输入会话标识": "Enter a conversation ID",
  "保存全部修改": "Save all changes",
  "此项暂不支持表单编辑。": "A form is not available for this setting.",
  "演示模式": "Demo mode",
  "连接自己的 Host 后管理设置。": "Connect your Host to manage settings.",

  "只读": "Read-only",
  "调整 AI 启用状态、工具执行和排队方式。": "Configure AI availability, tool execution and message queueing.",
  "会话与上下文": "Sessions and context",
  "管理会话保存、历史内容和上下文使用。": "Manage saved sessions, history and context usage.",
  "记忆与知识": "Memory and knowledge",
  "管理机器人记忆和知识检索。": "Manage bot memory and knowledge retrieval.",
  "图片与感知": "Images and perception",
  "设置多模态识别、图片生成和图片存储。": "Configure multimodal perception, image generation and image storage.",
  "外部服务": "External services",
  "管理 Agent 使用的 MCP 和 GitHub 服务。": "Manage MCP and GitHub services used by agents.",
  "回复与访问": "Replies and access",
  "设置机器人何时回复，以及谁可以使用 AI。": "Configure when the bot replies and who can use AI.",
  "用量与审计": "Usage and audit",
  "管理 AI 用量限制和审计记录。": "Manage AI usage limits and audit records.",
  "协作与决策": "Collaboration and decisions",
  "设置 Workroom 协作和决策能力。": "Configure Workroom collaboration and decision capabilities.",
  "其他 AI 设置": "Other AI settings",
  "查看当前 Host 提供的其他 AI 配置字段。": "View other AI configuration fields provided by this Host.",
  "恢复默认": "Restore default",
  "使用默认值": "Using default",
  "已自定义": "Customized",
  "设置分类": "Settings categories",
  "搜索设置": "Search settings",
  "搜索名称或用途…": "Search names or purposes…",
  "内置能力": "Built-in capabilities",
  "已安装与自定义": "Installed and custom",
  "未识别配置": "Unrecognized configuration",
  "没有匹配的设置": "No matching settings",
  "当前没有可配置项目": "No configuration available",
  "换一个名称或用途重新搜索。": "Try another name or purpose.",
  "清除搜索": "Clear search",
  "返回 {0}": "Back to {0}",
  "界面与语言": "Language",
  "设置机器人使用的语言。": "Set the language used by the bot.",
  "菜单入口": "Menu entry",
  "设置用户打开机器人菜单的关键词。": "Set the keyword users send to open the bot menu.",
  "菜单样式": "Menu appearance",
  "设置机器人菜单的展示方式。": "Set how the bot menu is presented.",
  "运行日志": "Runtime logs",
  "调整运行日志的详细程度。": "Choose how much detail runtime logs include.",
  "连接与访问": "Connections and access",
  "管理 Console 和 HTTP 服务的连接与访问设置。": "Manage connections and access for Console and the HTTP service.",
  "数据存储": "Data storage",
  "管理机器人使用的数据库连接。": "Manage the database connection used by the bot.",
  "对话与执行": "Conversation and execution",
  "设置助手任务和主动服务。": "Configure assistant tasks and proactive services.",
  "语音": "Speech",
  "管理语音识别和语音合成。": "Manage speech recognition and synthesis.",
  "图片渲染": "Image rendering",
  "设置 HTML 内容转为图片的方式。": "Configure how HTML content is rendered as images.",
  "配置 Host 提供的 MCP 服务。": "Configure MCP services provided by the Host.",
  "Agent 互联": "Agent connections",
  "配置 Host 提供的 Agent 互联服务。": "Configure agent connection services provided by the Host.",
  "通用设置": "General",
  "管理机器人的基础运行设置。": "Manage the bot’s basic runtime settings.",
  "连接模型服务并管理可用模型。": "Connect model services and manage available models.",
  "Agent 预设": "Agent presets",
  "组合模型、角色和能力，设置不同助手的工作方式。": "Combine models, roles and capabilities to configure how each assistant works.",
  "按能力查看插件，需要调整时再打开具体设置。": "Browse plugins by capability and open their settings when needed.",
  "模型服务": "Model services",
  "设置模型服务商、连接凭据和可用模型。": "Configure model providers, connection credentials and available models.",
  "为已有 Agent 配置模型、名称与可用服务。": "Configure models, names and available services for existing agents.",
  "项目插件": "Project plugin",
  "管理当前项目根插件的业务设置。": "Manage the business settings of the project’s root plugin.",
  "已保存的配置项；Host 尚未提供可编辑路径。": "A saved configuration item without a Host-provided editable path.",
  "查看此插件实例的配置。": "View the configuration of this plugin instance.",
  "加载中…": "Loading…",
  "从侧栏选择一个页面，或安装注册控制台路由的插件。": "Choose a page from the sidebar, or install a plugin that provides Console pages.",
  "Demo 构建缺少 VITE_API_BASE / VITE_API_TOKEN，无法连接 demo-api。": "The demo build is missing VITE_API_BASE / VITE_API_TOKEN and cannot connect to demo-api.",
  "自定义会话": "Custom conversation",
  "选择对话": "Choose a conversation",
  "从最近对话选择，或浏览渠道会话。": "Select a recent conversation or browse channel conversations.",
  "浏览渠道会话": "Browse channel conversations",
  "还没有最近对话": "No recent conversations",
  "进入“聊天账号”，选择联系人、群组或频道，再打开 Agent 轨迹。": "Open Chat accounts, select a contact, group or channel, then open its Agent activity.",
  "选择会话": "Select conversation",
  "高级：使用会话标识": "Advanced: use a conversation identifier",
  "会话标识": "Conversation identifier",
  "请输入完整标识：平台:渠道:private|group|channel:会话。": "Enter the full identifier: platform:endpoint:private|group|channel:conversation.",
  "打开 {0}": "Open {0}",
  "打开 Console 快速跳转": "Open Console quick navigation",
  "搜索页面或执行动作": "Find a page or action",
  "搜索与动作": "Search and actions",
  "搜索 Console 页面或执行快捷动作": "Search Console pages or run a shortcut",
  "搜索页面或动作，例如“错误日志”“组件预览”…": "Search pages or actions, such as “error logs” or “component preview”…",
  "搜索 Console 页面或快捷动作": "Search Console pages or shortcuts",
  "动作": "Action",
  "当前": "Current",
  "没有匹配的功能": "No matching features",
  "试试“Agent”“日志”“群组”或“配置”": "Try “Agent”, “logs”, “groups” or “configuration”",
  "选择": "Select",
  "打开": "Open",
  "关闭": "Close",
  "state\u0004关闭": "Off",
  " 个入口": " entries",
  "使用说明 · ": "Getting started · ",
  "上一步": "Previous",
  "下一步": "Next",
  "跳过": "Skip",
  "开始体验": "Get started",
  "只读核对确认：当前代的包与配置语义一致；业务功能仍需独立验证。": "Read-only verification confirms that the active package and configuration agree. Business behavior still requires separate verification.",
  "应用证据暂无法确认，请重新读取或查看日志；这不表示配置保存失败，也不能判定应用失败。": "Application status cannot be confirmed yet. Reload the evidence or inspect the logs. This does not mean saving or applying failed.",
  "原应用申请结果尚未确认；请先只读核对，勿重复申请。": "The previous apply request is still unconfirmed. Verify its status without submitting it again.",
  "无法读取会话中的待确认申请记录；当前暂停申请应用，请恢复会话存储后重新打开配置页。": "The pending request could not be read from session storage. Applying is paused; restore session storage and reopen configuration.",
  "应用已保存的插件配置？": "Apply the saved plugin configuration?",
  "{0} · 文件版本 {1}。Host 将申请应用/重启；后续只读状态核对才能确认。": "{0} · File revision {1}. The Host will request application/restart; only a subsequent status check can confirm the result.",
  "申请应用": "Request application",
  "应用回执未确认，正在只读核对；不会重复提交申请。": "The apply receipt is unconfirmed. Checking status without resubmitting the request.",
  "应用结果未知。请恢复连接后重新读取证据或查看日志；勿重复申请。": "Application outcome is unknown. Reconnect and reload the evidence or inspect logs; do not submit the request again.",
  "已核对：实例已停用。": "Verified: the instance is disabled.",
  "已核对：当前代的包与已保存配置语义一致；业务功能仍需独立验证。": "Verified: the active package and saved configuration agree. Business behavior still requires separate verification.",
  "应用结果未确认，请只读核对当前状态，勿重复申请。": "Application outcome is unconfirmed. Check the current status without submitting another request.",
  "尚未提交应用申请；请核对当前证据和浏览器会话存储后重试。": "No apply request was submitted. Check the current evidence and browser session storage before trying again.",
  "配置保存与应用证据": "Configuration save and application evidence",
  "已读取文件版本：": "Loaded file revision: ",
  "未知": "Unknown",
  "有未保存草稿；基于版本 ": "Unsaved draft based on revision ",
  "。保存前不会应用草稿。": ". Drafts are not applied before saving.",
  "文件已保存、当前代配置语义一致、平台就绪和业务验证是不同证据；未确认应用不等于应用失败。": "A saved file, matching active configuration, platform readiness and verified business behavior are separate facts. Unconfirmed application does not mean failure.",
  "正在核对…": "Checking…",
  "读取应用证据": "Read application evidence",
  "应用已保存配置": "Apply saved configuration",
  "查看运行日志": "View runtime logs",
  "证据文件版本：": "Evidence file revision: ",
  "证据与已读取文件版本不一致，或该实例未声明；请刷新文件并核对草稿后重新读取，当前不会申请应用。": "The evidence does not match the loaded file revision, or this instance is not declared. Refresh the file and review your draft before reloading evidence. No apply request will be sent now.",
  "此项不是已声明的插件实例；文件保存不证明 Host 或应用配置已生效，请按实际保存回执处理进程重启。": "This is not a declared plugin instance. Saving the file does not prove that Host or application configuration is active. Follow the actual save receipt for process restart requirements.",
  "字段来源与运行代一致性": "Field sources and active configuration",
  "只解释已保存版本，按需读取；不显示配置值或环境变量展开值，不改配置、不申请应用、不发送消息。": "Read evidence for the saved revision on demand. Configuration and expanded environment values remain hidden. This does not edit, apply or send messages.",
  "有未保存草稿（基于 ": "Unsaved draft (based on ",
  "未知版本": "Unknown version",
  "）；下面解释当前已读取的保存版本，不解释或覆盖草稿。": "). The explanation below covers the loaded saved revision, without explaining or replacing your draft.",
  "正在读取解释…": "Reading explanation…",
  "读取已保存版本解释": "Explain saved revision",
  "查看完整源码": "View complete source",
  "读取时运行代：": "Active generation when read: ",
  "不可用": "Unavailable",
  "。这是一份读取时的证据，不持续跟踪后续热重载。": ". This evidence reflects the read time and does not track later hot reloads.",
  "运行代字段来源：未知（未记录）。值一致不证明来自同一配置来源；敏感或环境引用未比较不等于一致。": "Active field sources are unknown because they were not recorded. Equal values do not prove the same source; sensitive or environment-referenced values that were not compared are not confirmed matches.",
  "暂不能解释：": "Cannot explain yet: ",
  "Host 未提供可证明证据。": "The Host did not provide verifiable evidence.",
  "请使用完整源码并结合运行日志核对。": "Check the complete source together with runtime logs.",
  "此 Schema 没有可展示的静态字段；这不证明业务配置已生效。": "This schema has no static fields to display. This does not prove that business configuration is active.",
  "字段路径": "Field path",
  "已保存候选来源": "Saved candidate source",
  "读取时与运行代比较": "Comparison with active generation at read time",
  "证据版本": "Evidence revision",
  "配置文件版本：": "Configuration file revision: ",
  "项目版本：": "Project revision: ",
  "草稿范围：全部符合插件条件的会话": "Draft scope: all conversations eligible for this plugin",
  "草稿范围：不允许任何会话": "Draft scope: no conversations allowed",
  "草稿范围：仅列表中的 {0} 个精确会话": "Draft scope: only the {0} exact conversations listed",
  "此处只修改配置草稿；保存并应用后才生效。账号、会话类型、ID、父容器和话题共同确定范围。": "This only changes the configuration draft; save and apply it to take effect. Account, conversation type, ID, parent and thread jointly define the scope.",
  "未填写父容器或话题时，只匹配同样不含该身份的会话，不会覆盖所有子频道或回复串。": "Leaving the parent or thread unspecified only matches conversations with the same absent identity. It does not include all child channels or threads.",
  "限定到所选会话（先设为空范围）": "Limit to selected conversations (start with an empty scope)",
  "当前值不是会话列表，原值仍保留。请切换源码修正，或明确设为空范围后重新选择。": "The current value is not a conversation list and has been preserved. Correct it in source view, or explicitly clear the scope before choosing again.",
  "会话 ": "Conversation ",
  "移除此会话": "Remove conversation",
  "添加精确会话": "Add exact conversation",
  "清空范围（不允许任何会话）": "Clear scope (allow no conversations)",
  "恢复覆盖全部…": "Restore all conversations…",
  "此字段最多 ": "This field allows at most ",
  " 个会话；已有草稿不会被自动截断。": " conversations. Existing drafts will not be truncated automatically.",
  "恢复后将删除此范围限制，覆盖全部符合插件条件的会话，包括以后新接入的符合条件会话。确定扩大范围吗？": "Restoring removes this scope restriction and includes every conversation eligible for the plugin, including eligible conversations added later. Expand the scope?",
  "确认恢复全部": "Restore all",
  "保留当前范围": "Keep current scope",
  "当前 Host 没有可选择的账号；请先配置 Endpoint。": "The current Host has no selectable accounts. Configure an endpoint first.",
  "账号列表读取失败": "Could not read accounts",
  "正在读取账号…": "Reading accounts…",
  "读取当前 Host 账号": "Read current Host accounts",
  "仅读取列表，不验证平台或发送消息。": "Reads the list only. Does not verify the platform or send messages.",
  "目标账号": "Target account",
  "请先读取并选择完整账号": "Read and select the complete account first",
  "已配置完整账号（当前列表未核对）": "Complete account configured (not checked against the current list)",
  "（离线）": " (offline)",
  "账号完整身份": "Complete account identity",
  "会话类型": "Conversation type",
  "请选择类型": "Select a type",
  "当前类型不在允许范围：": "Current type is not allowed: ",
  "会话 ID": "Conversation ID",
  "平台实际会话 ID": "Actual platform conversation ID",
  "父容器类型（可选）": "Parent type (optional)",
  "未指定": "Unspecified",
  "（待校验）": " (awaiting validation)",
  "父容器 ID": "Parent container ID",
  "频道所属服务器等实际 ID": "Actual ID, such as the channel's server ID",
  "明确不含父容器": "Explicitly no parent",
  "话题 / 回复串 ID（可选）": "Thread / reply thread ID (optional)",
  "实际话题 ID；不是通配条件": "Actual thread ID, not a wildcard",
  "明确不含话题": "Explicitly no thread",
  "保留会话实际具有的父容器和话题；留空表示未提供该层身份，不会自动填补或推断。没有平台目录时，请手填真实会话 ID，不要把账号昵称当完整身份。": "Preserve the conversation's actual parent and thread. Empty means that level of identity was not provided; it is never inferred. Without a platform directory, enter the real conversation ID, not an account nickname.",
  "草稿待完善：": "Draft needs attention: ",
  " 最终以 Host 校验为准。": " The Host performs final validation.",
  "账号：": "Account: ",
  "完整 ID 见下方详情": "See the complete ID below",
  "尚未选择": "Not selected",
  "会话：": "Conversation: ",
  "尚未选择类型": "Type not selected",
  "尚未填写 ID": "ID not entered",
  "父容器：": "Parent: ",
  "待填写": "Not entered",
  "未提供": "Not provided",
  "话题：": "Thread: ",
  "完整身份草稿": "Complete identity draft",
  "尚未设置": "Not set",
  "{0} 敏感多行文本": "{0} sensitive multiline text",
  "敏感多行文本未展示，未编辑时原样保留。": "Sensitive multiline text is hidden and preserved unless edited.",
  "隐藏敏感文本": "Hide sensitive text",
  "编辑敏感文本": "Edit sensitive text",
  "敏感值未展示，未编辑时原样保留。": "Sensitive value is hidden and preserved unless edited.",
  "编辑敏感 JSON": "Edit sensitive JSON",
  "此字段使用 JSON 值编辑；其他字段继续使用表单。": "Edit this field as JSON; other fields continue to use the form.",
  " 此项可能包含敏感值，请使用环境变量引用。": " This field may contain sensitive values. Use an environment variable reference.",
  "{0} JSON 值": "{0} JSON value",
  "JSON 格式有误；草稿已保留，修正后才能保存。": "Invalid JSON. Your draft has been kept; correct it before saving.",
  "尚未设置；不编辑时保持省略。": "Not set. Leaving it untouched keeps it omitted.",
  "添加对象配置": "Add object configuration",
  "Schema 未声明此保存字段；原值保留，最终由 Host 校验。": "The schema does not declare this saved field. Its original value is preserved; the Host performs final validation.",
  "删除键 ": "Delete key ",
  "当前为空对象，可添加键值。": "This object is empty. Add a key and value.",
  "此项无需配置字段。": "This item requires no configuration fields.",
  "新增字典键": "New dictionary key",
  "键不能为空、不能重复或使用保留名称。": "The key must be nonempty, unique and not reserved.",
  "添加键值": "Add key and value",
  "此位置不在已声明元组中；原值保留，Host 负责校验。": "This position is outside the declared tuple. Its original value is preserved; the Host validates it.",
  "{0} 第 {1} 项": "{0} item {1}",
  "删除此项": "Delete item",
  "添加列表项": "Add list item",
  "撤销修改，恢复原值或默认值": "Undo changes and restore the original or default value",
  "清空（使用声明默认值）": "Clear (use the declared default)",
  "清空（保存时省略此项）": "Clear (omit this field when saving)",
  "建议使用环境变量引用，如 ${API_KEY}": "Use an environment variable reference, e.g. ${API_KEY}",
  "文本，或 ${ENV_NAME} 引用环境变量": "Text, or ${ENV_NAME} for an environment variable",
  "另有 {0} 个保存值不在选项中，将原样保留。": "{0} saved value(s) are not among the options and are kept as-is.",
  "暂无列表项。": "No list items yet.",
  "环境变量引用（原样保留）": "Environment variable reference (preserved)",
  "现有值不在选项中（原样保留）": "Existing value is not in the options (preserved)",
  "必填": "Required",
  "已声明默认值": "Default declared",
  "声明默认值：{0}": "Declared default: {0}",
  "建议填写环境变量引用，如 ": "Use an environment variable reference, such as ",
  "；不要将密钥写入配置。": "; do not store secrets in configuration.",
  "请按任务提供方要求填写；此处不解析环境变量引用。": "Follow the task provider's requirements. Environment references are not expanded here.",
  "此约束不提供额外输入；提交后由 Host 校验，不在此处推断通过。": "This constraint requires no additional input. The Host validates it on submission; this view does not infer success.",
  "所有约束共同适用；各组编辑同一份值，Host 最终校验。": "All constraints apply to the same value. The Host performs final validation.",
  "{0} 约束 {1}": "{0} constraint {1}",
  "请选择": "Select an option",
  "已保存非布尔原值；不操作时保留。可在下方编辑，或明确使用开关替换。": "The saved value is not a boolean and is preserved until edited. Edit it below or explicitly replace it using the switch.",
  "已启用": "Enabled",
  "已禁用": "Disabled",
  "原值已保留": "Original value preserved",
  "尝试调整搜索条件或分类筛选": "Try changing your search or category filter",
  "周下载": "Weekly downloads",
  "月下载": "Monthly downloads",
  "版本数": "Versions",
  "作者": "Author",
  "许可证": "License",
  "最后发布": "Last published",
  "版本": "Version",
  "依赖": "Dependencies",
  "暂无 README": "No README",
  "暂无版本信息": "No version information",
  "最近 20 个版本（共 ": "Latest 20 versions (of ",
  " 个）": ")",
  "无 peer dependencies": "No peer dependencies",
  "安装命令": "Installation command",
  "已复制安装命令": "Installation command copied",
  "复制安装命令": "Copy installation command",
  "核对中…": "Checking…",
  "重新核对安装状态": "Check installation status again",
  "生成补全挂载与配置的计划": "Generate a plan to complete mounting and configuration",
  "继续配置实际实例 ": "Continue configuring the actual instance ",
  "安装计划": "Installation plan",
  "目标包：": "Target package: ",
  "实例名：": "Instance name: ",
  "插件清单：": "Plugin declaration: ",
  "无需修改": "No change needed",
  "将新增挂载": "A mount will be added",
  "配置：": "Configuration: ",
  "将创建配置项": "A configuration entry will be created",
  "重启：": "Restart: ",
  "需要": "Required",
  "不需要": "Not required",
  "安装中…": "Installing…",
  "确认安装": "Confirm installation",
  " 主页": " Homepage",
  " 源码": " Source",
  "检查中…": "Checking…",
  "安装": "Install",
  "当前为 Demo，只能查看市场，安装需完整权限。": "The demo can browse the store only. Installation requires full access.",
  "查看本地插件状态": "View local plugin status",
  "未找到该插件，可能已被移除。": "This plugin was not found and may have been removed.",
  "当前身份无权查看该插件。": "Your identity cannot view this plugin.",
  "插件读取失败（HTTP {0}），请稍后重试。": "Could not read the plugin (HTTP {0}). Try again later.",
  "已重新读取 Host 当前状态，请以安装与应用证据为准。": "Current Host status was reloaded. Use the installation and application evidence to assess the result.",
  "正在提交操作并等待 Host 恢复，核对插件运行状态…": "Submitting the operation and waiting for the Host to recover, then checking plugin status…",
  "操作回执未确认，正在读取 Host 核对结果；请勿重复操作。": "The operation receipt is unconfirmed. Reading Host status to verify; do not repeat the operation.",
  "已核对：实例代内已加载；平台上线与业务功能尚未验证": "Verified: the instance is loaded in the generation. Platform connection and business behavior remain unverified.",
  "已核对：插件已停用": "Verified: the plugin is disabled",
  "等待 Host 恢复或状态变化超时，操作结果尚未确认。当前显示最后一次读取的状态，请刷新核对后再操作。": "Timed out waiting for Host recovery or a status change. The outcome is unconfirmed. Showing the latest read status; refresh and verify before acting again.",
  "检查更新失败（HTTP {0}），请稍后重试。": "Could not check for updates (HTTP {0}). Try again later.",
  "当前已是最新版本": "Already on the latest version",
  "更新 {0}？": "Update {0}?",
  "{0} → {1}，更新后需要重启 Host。": "{0} → {1}. The Host will need a restart after updating.",
  "更新": "Update",
  "已核验磁盘版本 {0}。请完善配置后应用，再核对当前代与业务检查。": "Disk version {0} was verified. Complete configuration and apply it, then check the active generation and business checks.",
  "。更新结果未确认，请刷新核对，勿重复提交。": ". The update outcome is unconfirmed. Refresh and verify; do not submit again.",
  "卸载 {0}？": "Uninstall {0}?",
  "将卸载实例 {0}{1}，其他实例保持不变。Host 会按其他实例占用决定是否移除依赖。需要应用后核对。": "Instance {0}{1} will be uninstalled; other instances are unchanged. The Host decides whether to remove the dependency based on remaining instances. Apply and verify afterward.",
  "卸载": "Uninstall",
  "卸载结果未确认，请刷新核对；不要重复提交。": "The uninstall outcome is unconfirmed. Refresh and verify; do not submit again.",
  "应用插件变更？": "Apply plugin changes?",
  "{0} 当前代 {1}。Host 将申请应用/重启；只有后续状态才能确认成功。": "{0}, current generation {1}. The Host will request application/restart. Only subsequent status can confirm success.",
  "应用回执未确认，正在只读核对当前代；请勿重复提交。": "The apply receipt is unconfirmed. Checking the active generation without submitting another request.",
  "应用结果未知。请恢复连接后刷新核对，不要重复申请。": "Application outcome is unknown. Reconnect, refresh and verify; do not submit another request.",
  "已核对：实例已停用": "Verified: the instance is disabled",
  "已核对：第 {0} 代已应用；业务功能尚需独立验证。": "Verified: generation {0} is applied. Business behavior still requires separate verification.",
  "执行「{0}」？": "Run “{0}”?",
  "范围：{0}。副作用：{1}。批准仅绑定第 {2} 代和当前检查定义。": "Scope: {0}. Side effects: {1}. Approval is bound to generation {2} and the current check definition.",
  "批准执行一次": "Approve one execution",
  "检查「{0}」的执行结果未知：{1}。刷新插件状态不能确认该检查是否执行；请核对日志及外部结果，勿重复执行。": "The outcome of “{0}” is unknown: {1}. Refreshing plugin status cannot confirm whether this check ran. Verify logs and external results; do not run it again.",
  " 返回": " Back",
  "加载失败: ": "Could not load: ",
  "插件不存在": "Plugin does not exist",
  "代内已加载": "Loaded in generation",
  "插件配置": "Plugin configuration",
  "当前连接仅允许查看插件信息。": "This connection can only view plugin information.",
  "在配置页编辑插件设置。": "Edit plugin settings on the configuration page.",
  "相关日志": "Related logs",
  "编辑配置": "Edit configuration",
  "检查「": "The outcome of “",
  "」的结果仍未知。当前插件状态不代表之前的外部操作未发生。": "” is still unknown. Current plugin status does not prove that the previous external operation did not occur.",
  "已核对未知检查的结果？": "Have you verified the unknown check outcome?",
  "请先确认日志和外部结果。继续只解除操作锁定，不会重试检查；如需再次执行，仍须读取新计划并单独批准。": "Verify logs and external results first. Continuing only removes the operation lock; it does not retry the check. Another execution still requires a new plan and separate approval.",
  "已核对，解除锁定": "Verified; unlock",
  "已核对外部结果": "External outcome verified",
  "安装与应用状态": "Installation and application status",
  "刷新状态证据": "Refresh status evidence",
  "插件操作": "Plugin actions",
  "诊断、启停、更新或卸载此插件。": "Diagnose, enable, disable, update or uninstall this plugin.",
  "应用变更": "Apply changes",
  "查看业务检查": "View business checks",
  "诊断": "Diagnose",
  "启用": "Enable",
  "停用": "Disable",
  "刷新核对状态": "Refresh and verify status",
  "业务验证计划": "Business verification plan",
  "第 ": "Generation ",
  " 代业务检查 · 尚未执行": " business check · not executed",
  "插件未提供可执行检查。": "The plugin provides no executable checks.",
  "本地": "Local",
  "平台": "Platform",
  "审阅并批准一次": "Review and approve once",
  "当前代、配置或连接证据已变化，旧检查结果已失效。请重新查看业务检查并验证。": "The active generation, configuration or connection evidence changed. Previous check results are no longer valid. Reload business checks and verify again.",
  "业务验证结果": "Business verification result",
  "已加载能力": "Loaded capabilities",
  "暂无已加载能力": "No loaded capabilities",
  "配置检查通过": "Configuration check passed",
  "需要补充环境变量": "Environment variables required",
  "配置检查未通过": "Configuration check failed",
  "未提供配置检查结果": "No configuration check result provided",
  "插件诊断结果": "Plugin diagnostics",
  "配置错误": "Configuration errors",
  "缺少环境变量": "Missing environment variables",
  "提示": "Guidance",
  "原始诊断数据": "Raw diagnostic data",
  "当前身份无权读取插件列表": "Your identity cannot read the plugin list",
  "插件读取失败（HTTP {0}）": "Could not read plugins (HTTP {0})",
  "额外加载的子插件；项目根插件不计入此列表": "Additional child plugins; the project root plugin is excluded",
  "。以下是上次读取的列表。": ". Showing the previously read list.",
  " 个子插件": " child plugins",
  "个代内已加载": " loaded in generation",
  "搜索插件…": "Search plugins…",
  "应用证据未确认": "Application evidence unconfirmed",
  "当前代 ": "Active generation ",
  "包与配置已应用": "Package and configuration applied",
  "待核对应用": "Application needs verification",
  "业务检查可选": "Business checks available",
  "未提供业务检查": "No business checks provided",
  "状态读取失败：{0}": "Could not read status: {0}",
  "Host 尚未提供状态证据": "The Host has not provided status evidence",
  "无注册功能": "No registered features",
  "没有匹配的插件": "No matching plugins",
  "试试其他名称，或清除筛选。": "Try another name or clear the filter.",
  "暂无子插件": "No child plugins",
  "当前没有额外子插件；项目根插件的命令、组件和适配器仍可运行。": "No additional child plugins are installed. Commands, components and adapters in the project root plugin can still run.",
  "我的消息场景": "My message scenario",
  "[\n  { \"type\": \"text\", \"data\": { \"text\": \"你好，这是一条作者预期消息。\" } }\n]": "[\n  { \"type\": \"text\", \"data\": { \"text\": \"Hello, this is the author's expected message.\" } }\n]",
  "作者预期输出": "Author's expected output",
  "输出 JSON 无效": "Invalid output JSON",
  "父容器类型和 ID 必须同时填写": "Parent type and ID must be provided together",
  "测试角色": "Test roles",
  "独立测试配置": "Independent test configuration",
  "最终 payload 断言": "Final payload assertion",
  "场景格式无效": "Invalid scenario format",
  "导入失败": "Import failed",
  "消息场景试验台": "Message scenario lab",
  "先预览作者预期消息，再导出可在独立测试项目显式运行的回归。": "Preview the author's expected message, then export a regression to run explicitly in an independent test project.",
  "本地只读预览，不执行插件": "Local read-only preview; plugins are not executed",
  "不读取当前 Host 配置，不发送或重放消息，不运行组件、业务工具或 Shotium，不注册交互。账号、发送者及角色都是你提供的测试场景；示例身份不代表真实登录。": "This does not read current Host configuration, send or replay messages, execute components, business tools or Shotium, or register interactions. Accounts, senders and roles are supplied test identities; example identities do not represent real logins.",
  "导出不等于执行通过；合成端点回归、浏览器外观与真实平台投递是不同证据。此页不保存草稿，离开前可导出场景 JSON；请勿填写凭据。": "Exporting does not prove execution passed. Synthetic endpoint regressions, browser appearance and real platform delivery are separate evidence. Drafts are not saved here; export scenario JSON before leaving. Do not enter credentials.",
  "导入已有场景 JSON": "Import existing scenario JSON",
  "导入场景 JSON": "Import scenario JSON",
  "读取本地场景": "Read local scenario",
  "来源与输入": "Source and input",
  "场景名称": "Scenario name",
  "来源适配器标识": "Source adapter identifier",
  "来源账号完整 ID": "Complete source account ID",
  "完整账号身份由你明确填写，昵称、裸账号 ID 不会自动补成真实 Endpoint。原始身份仅保留来源，不会成为执行/发送目标。": "Enter the complete account identity explicitly. Nicknames and bare account IDs are not expanded into real endpoints. Original identity only records the source and never becomes an execution or delivery target.",
  "来源会话类型": "Source conversation type",
  "来源会话 ID": "Source conversation ID",
  "来源父容器类型": "Source parent type",
  "不提供": "Not provided",
  "来源父容器 ID": "Source parent ID",
  "来源话题 / 回复串 ID": "Source thread / reply thread ID",
  "kind、ID、父容器和话题均原样保留；未填写不代表通配。": "Kind, ID, parent and thread are preserved exactly. An omitted value is not a wildcard.",
  "发送者 ID": "Sender ID",
  "发送者名称（可选）": "Sender name (optional)",
  "提供发送者名称（允许为空）": "Provide sender name (empty allowed)",
  "明确提供测试角色": "Explicitly provide test roles",
  "测试角色 JSON 数组（[] 明确空角色）": "Test roles JSON array ([] means explicitly no roles)",
  "未提供角色；与明确的空角色数组 [] 保持区别。": "Roles are not provided. This differs from an explicit empty role array [].",
  "未来入站文本": "Future inbound text",
  "仅为未来 PluginTestKit.receive 的输入，不会在此页派发。": "Used only as input to a future PluginTestKit.receive call; it is not dispatched here.",
  "填写原生 JSON Segment[]；不接受 JSX / TSX 源码、函数、组件调用或 raw。预览不会推断实际插件输出。": "Enter native JSON Segment[]. JSX/TSX source, functions, component calls and raw content are not accepted. Preview does not infer actual plugin output.",
  "作者预期输出 JSON": "Author's expected output JSON",
  "测试能力配置": "Test capabilities",
  "这是合成端点能力声明，不自动代表任何真实平台；图片引擎未启用，不提供虚假的图片/native 成功状态。": "These are synthetic endpoint capabilities, not an automatic claim about any real platform. The image engine is disabled; no artificial image/native success is reported.",
  "显式回归设置": "Explicit regression settings",
  "可只导出场景 JSON。可执行文件必须有独立测试配置、合成账号映射及你明确编写的最终断言。没有远程运行按钮。": "You can export scenario JSON alone. Executable files require an independent test configuration, synthetic account mapping and your explicitly authored final assertion. There is no remote Run button.",
  "我提供独立测试配置与账号映射": "I provide an independent test configuration and account mapping",
  "合成账号别名": "Synthetic account alias",
  "来源账号 ": "Source account ",
  " → 合成别名 ": " → Synthetic alias ",
  "。执行使用新的测试 Endpoint，完整来源不会冒认为真实账号。": ". Execution uses a new test endpoint; the complete source identity is never impersonated as a real account.",
  "独立测试配置 JSON": "Independent test configuration JSON",
  "我单独编写最终派发与投递断言": "I write the final dispatch and delivery assertions separately",
  "预期派发状态": "Expected dispatch status",
  "指令已执行": "Command executed",
  "权限拒绝": "Permission denied",
  "未匹配指令": "No command matched",
  "准入限制（需支持此状态的 Runtime）": "Admission limited (requires Runtime support for this status)",
  "最终 payload 数组 JSON": "Final payload array JSON",
  "每项是一条最终 payload（字符串或原生消息段数组）；[] 明确断言没有投递。首版要求全部输出投递到来源会话映射后的合成账号，跨会话主动发送请另写测试。不会把上方浏览器预览自动复制为断言。": "Each item is a final payload (a string or native segment array); [] explicitly asserts no delivery. This version requires every output to target the synthetic account mapped from the source conversation. Write separate tests for proactive cross-conversation sends. The browser preview is never copied into assertions automatically.",
  "运行时必须显式指定 ZHIN_SCENARIO_FIXTURE_ROOT 的绝对路径。测试项目内的依赖、插件和 config 由开发者准备；不会自动安装、读取当前生产配置或执行。": "Set ZHIN_SCENARIO_FIXTURE_ROOT to an absolute path when running. The developer prepares dependencies, plugins and configuration in the test project. Nothing is automatically installed, read from current production configuration or executed.",
  "PluginTestKit 不是安全沙箱：插件 import/setup 可访问文件、网络或启动适配器。只运行可信、无生产凭据的独立测试项目。": "PluginTestKit is not a security sandbox. Plugin import/setup can access files or networks or start adapters. Only run trusted independent test projects without production credentials.",
  "场景尚不完整：": "Scenario incomplete: ",
  "导出场景 JSON": "Export scenario JSON",
  "导出回归文件": "Export regression file",
  "导出运行说明": "Export run instructions",
  "完整场景与身份": "Complete scenario and identities",
  "作者预期消息预览": "Author's expected message preview",
  "预期消息外观": "Expected message appearance",
  "文字直接显示；Markdown 子集可读展示；HTML 源文与媒体占位不等于平台渲染结果。按钮不可操作，不产生网络请求。": "Text is shown directly and a Markdown subset is displayed readably. HTML source and media placeholders are not platform rendering results. Buttons are inactive and no network requests are made.",
  "作者预期没有输出。": "The author expects no output.",
  "（已禁用）": " (disabled)",
  "Markdown 子集预览": "Markdown subset preview",
  "代码": "Code",
  "投递账号": "Delivery account",
  "账号完整 ID": "Complete account ID",
  "会话": "Conversation",
  "父容器": "Parent container",
  "话题": "Thread",
  "此操作不修改任务参数。": "This action does not change task parameters.",
  "管理员任务 · ": "Administrator task · ",
  "最近执行：": "Last execution: ",
  "投递结果不确定，请先到实际目标核实；此任务不能恢复或重试。取消也无法撤回可能已在途的发送。": "Delivery outcome is uncertain. Verify the actual target first. This task cannot be resumed or retried; cancellation cannot recall a send that may already be in flight.",
  "完整目标与任务身份": "Complete target and task identity",
  "当前 Host 尚不支持管理员任务中心，请更新 Host。": "This Host does not support the administrator task center yet. Update the Host.",
  "需要 full scope 才能查看和管理管理员任务。": "Full scope is required to view and manage administrator tasks.",
  "任务读取失败（HTTP {0}），请检查 Host 后刷新。": "Could not read tasks (HTTP {0}). Check the Host and refresh.",
  "原操作已由持久确认记录核实，任务 ID：{0}。这是任务变更确认，不是平台消息投递确认。": "The original operation was verified by a durable confirmation record. Task ID: {0}. This confirms the task change, not platform message delivery.",
  "用途目录暂不可用；可直接选择当前已加载的任务提供方，或到插件市场查看。": "The use-case directory is unavailable. Select a currently loaded task provider directly, or browse the plugin store.",
  "账号目录读取失败。只能选择 Host 返回的完整 Endpoint，不能用本地账号名猜测。": "Could not read the account directory. Only complete endpoints returned by the Host can be selected; local account names cannot be used to guess identities.",
  "确认修改管理员任务": "Confirm administrator task changes",
  "确认创建管理员任务": "Confirm administrator task creation",
  "正在编辑该管理员任务；修改不会改变原始投递目标。": "Editing this administrator task. Its original delivery target will remain unchanged.",
  "确认{0}管理员任务": "Confirm {0} administrator task",
  "浏览器无法保留操作身份，本次没有提交。请允许会话存储后再试。": "The browser cannot retain the operation identity, so nothing was submitted. Allow session storage and try again.",
  "操作已提交，正在等待 Host 回执。请勿重复操作。": "Operation submitted; awaiting the Host receipt. Do not repeat it.",
  "运行代或任务修订已变化，草稿已保留。请先刷新核对，再明确采用最新版本；未自动重发。{0}": "The generation or task revision changed. Your draft is preserved. Refresh and verify, then explicitly adopt the latest revision. Nothing was resubmitted automatically. {0}",
  "当前身份没有任务管理权限，操作未获准。": "Your identity lacks task-management permission. The operation was not authorized.",
  "Host 拒绝此任务操作，请检查提供方、参数和当前状态。": "The Host rejected this task operation. Check the provider, parameters and current state.",
  "操作回执不确定，请先只读刷新核对，勿再次提交。": "The operation receipt is uncertain. Refresh to verify without writing; do not submit again.",
  "Host 回执不完整，操作结果不确定，请只读核对。": "The Host receipt is incomplete and the outcome is uncertain. Verify without writing.",
  "回执没有匹配本操作的确认，结果仍不确定，请只读核对。": "The receipt contains no confirmation matching this operation. Its outcome remains uncertain; verify without writing.",
  "管理员任务操作已确认。列表反映任务事实，不代表未来消息已成功投递。": "The administrator task operation is confirmed. The list reflects task state, not successful future delivery.",
  "任务中心": "Task center",
  "管理员任务": "Administrator tasks",
  "任务视图": "Task views",
  "管理员任务、定时提醒、助手任务和执行记录集中在这里。": "Administrator tasks, scheduled reminders, assistant tasks and execution history live here.",
  "管理员任务、定时提醒、助手任务与执行记录": "Administrator tasks, scheduled reminders, assistant tasks and execution history",
  "从用途创建管理员任务；聊天中创建的个人任务仍归原用户，本页不会导入。": "Create administrator tasks by use case. Personal tasks created in chat remain owned by their users and are not imported here.",
  "刷新核对": "Refresh and verify",
  "Demo 仅展示；创建、修改、暂停、恢复和取消均已禁用。": "Demo is view-only. Creation, editing, pausing, resuming and cancellation are disabled.",
  "保留操作 ID：": "Retained operation ID: ",
  "等待当前操作回执。": "Waiting for the current operation receipt.",
  "结果尚未确认，写操作已锁定。请只读核对任务与目标会话；没有匹配的持久确认不能视为未执行。": "The outcome is unconfirmed and writes are locked. Verify the task and target conversation without writing. Absence of a matching durable confirmation does not mean it did not execute.",
  "连接身份已变化，请确认当前 Host 与账号确实有权核对原操作。不会用其他 Host 的结果冒认。": "The connection identity changed. Confirm that the current Host and account are authorized to verify the original operation. Another Host's result will not be treated as its confirmation.",
  "确认以当前身份只读核对原操作": "Use the current identity to verify the original operation without writing",
  "请连接 Host 后读取任务。": "Connect to the Host to read tasks.",
  "正在读取任务提供方…": "Reading task providers…",
  "按用途开始": "Start with a use case",
  "插件包：": "Plugin package: ",
  "（可选中复制）": " (select to copy)",
  "到市场查看安装计划": "View installation plan in store",
  "开始群欢迎配置流程": "Start group-welcome setup",
  "配置 ": "Configure ",
  "尚无该软件包已加载的任务提供方；安装后还需配置、应用并回到此页刷新。": "No task provider from this package is loaded. After installing, configure and apply it, then return here and refresh.",
  "尚无可用的管理员任务提供方。请安装并启用相应用途插件，再返回刷新。": "No administrator task providers are available. Install and enable a plugin for the use case, then return and refresh.",
  "前往插件市场": "Open plugin store",
  "选择用途": "Choose use case",
  "任务用途": "Task use case",
  "请选择用途提供方": "Choose a use-case provider",
  "此处创建的是管理员任务，由具有管理权限的人员维护；聊天个人提醒仍由原用户管理。": "Tasks created here are administrator tasks maintained by authorized administrators. Personal reminders created in chat remain managed by their users.",
  "修改任务参数": "Edit task parameters",
  "配置管理员任务": "Configure administrator task",
  "草稿基于旧运行代或旧修订，不能直接提交；刷新不会为旧草稿背书。": "This draft is based on an old generation or revision and cannot be submitted directly. Refreshing does not validate an old draft.",
  "精确投递目标": "Exact delivery target",
  "读取账号列表": "Read account list",
  "请选择 Host 返回的账号": "Select an account returned by the Host",
  "平台原始会话 ID": "Original platform conversation ID",
  "父容器类型": "Parent type",
  "无父容器": "No parent",
  "channel（服务器/工作区）": "channel (server/workspace)",
  "父容器原始 ID（如有）": "Original parent ID (if present)",
  "话题 ID": "Thread ID",
  "话题 / thread ID（如有）": "Thread ID (if present)",
  "目录查询并非所有平台都支持；请按平台身份明确填写，不会推测父容器或话题，不会测试发送。": "Not every platform supports directory queries. Enter explicit platform identities. No parent or thread is inferred, and no test message is sent.",
  "修改任务保留原始目标；取消任务也无法撤回在途发送。": "Editing preserves the original target. Cancellation cannot recall an in-flight send.",
  "投递目标预览": "Delivery target preview",
  "完整目标身份": "Complete target identity",
  "核对修改": "Review changes",
  "核对并创建": "Review and create",
  "已明确采用当前版本，请重新核对全部参数、目标与副作用后提交。": "You explicitly adopted the current revision. Review all parameters, targets and side effects again before submitting.",
  "采用当前版本，保留草稿": "Adopt current revision; keep draft",
  "清空并重新配置": "Clear and configure again",
  "为此用途创建新任务": "Create a new task for this use case",
  "{0} · 管理员任务": "{0} · Administrator tasks",
  "请选择用途查看任务": "Choose a use case to view tasks",
  "当前没有管理员任务；这不代表聊天用户没有个人任务。": "No administrator tasks exist. This does not mean chat users have no personal tasks.",
  "操作：": "Action: ",
  "取消无法撤回已经在途或结果不确定的发送，请先核对目标会话。": "Cancellation cannot recall sends that are already in flight or have uncertain outcomes. Verify the target conversation first.",
  "未来外部影响": "Future external effects",
  "提供方未声明影响说明；这不等于没有外部副作用。": "The provider declared no effect description. This does not mean there are no external side effects.",
  "完整身份与参数": "Complete identity and parameters",
  "返回检查": "Back to review",
  "确认一次提交": "Confirm one submission",
  "请连接具有管理权限的 Host 后配置群欢迎。Demo 不读取或修改此配置。": "Connect to a Host with management permission to configure group welcome. The demo does not read or modify this configuration.",
  "无法读取 Host 用途与实例目录，请核对连接和管理权限后刷新。": "Could not read the Host use-case and instance directories. Check your connection and management permissions, then refresh.",
  "目录读取失败": "Could not read directory",
  "配置新成员欢迎": "Configure new-member welcome",
  "选择实例、限定范围、核对应用，再到真实群完成人工验证。": "Choose an instance, limit the scope and verify application, then manually verify in a real group.",
  "返回用途目录": "Back to use-case directory",
  "1 · 选择明确实例": "1 · Choose a specific instance",
  "刷新用途与实例": "Refresh use cases and instances",
  "Host 用途指定的插件包：": "Plugin package specified by the Host use case: ",
  "群欢迎实例": "Group-welcome instance",
  "请选择实例（不会默认选择同包实例）": "Select an instance (instances of the same package are not selected automatically)",
  "已加载": "Loaded",
  "尚无该包的可管理实例，请先审阅安装计划。": "No manageable instance of this package exists. Review its installation plan first.",
  "返回的实例不在当前 Host 的可管理目录中，请刷新或重新选择，不按包名猜测。": "The returned instance is outside the current Host's manageable directory. Refresh or select again; identity is not inferred from the package name.",
  "查看此用途的插件与安装计划": "View this use case's plugin and installation plan",
  "2 · 在原配置表单选择范围": "2 · Choose scope in the existing configuration form",
  "当前实例：": "Current instance: ",
  "。填写 welcomeMessage；建议先明确设为空范围，再添加希望欢迎的群。这里只提供引导，不自动修改任何值。": ". Fill in welcomeMessage. Start with an explicitly empty scope, then add the groups to welcome. This page only guides you; it changes no values automatically.",
  "省略 welcomeConversations 表示所有符合条件的群；空列表表示全部关闭。账号、父容器和话题都参与精确匹配，其他实例不受本次配置限制。": "Omitting welcomeConversations includes all eligible groups; an empty list disables all welcome messages. Account, parent and thread participate in exact matching. Other instances are unaffected by this configuration.",
  "打开此实例原配置表单": "Open this instance's configuration form",
  "3 · 核对保存与当前运行代": "3 · Verify the saved and active configuration",
  "保存只确认文件版本。应用继续使用插件详情的原有确认与状态核对；本页不会申请重启或重复保存。": "Saving only confirms a file revision. Applying still uses the existing confirmation and status checks in plugin details. This page does not request restarts or save again.",
  "打开详情并核对应用": "Open details and verify application",
  "重新读取应用证据": "Read application evidence again",
  "证据读取失败，不能沿用旧确认。": "Evidence could not be read; previous confirmation cannot be reused.",
  "正在只读核对当前实例与运行代…": "Checking the current instance and generation without writing…",
  "当前代配置语义已匹配；业务尚未由机器验证。": "The active configuration matches semantically. Business behavior has not been machine-verified.",
  "当前实例尚未满足已应用条件，请在详情处理后重新核对。": "This instance does not yet meet the applied conditions. Address them in details, then verify again.",
  "欢迎文案：": "Welcome text: ",
  "含环境引用，当前证据无法确认展开后是否非空": "Contains environment references; current evidence cannot confirm nonempty expanded content",
  "已填写（不在此页展示正文）": "Provided (content is not displayed here)",
  "空文案，欢迎已关闭": "Empty text; welcome messages are disabled",
  "。范围：": ". Scope: ",
  "含环境引用，展开范围未读取，不能由文件判断实际会话": "Contains environment references; the expanded scope was not read, so the file cannot establish actual conversations",
  "全部符合事件条件的群": "All groups matching event conditions",
  "空列表，不欢迎任何群": "Empty list; no groups are welcomed",
  "仅 {0} 个精确会话": "Only {0} exact conversations",
  "查看当前文件的精确范围（非草稿）": "View the saved file's exact scope (not the draft)",
  "文件 revision：": "File revision: ",
  "项目 revision：": "Project revision: ",
  "运行代：": "Generation: ",
  "尚未发布": "Not published yet",
  "4 · 在测试群人工核对": "4 · Manually verify in a test group",
  "选择实际测试群，由成员真实加入后核对该实例的欢迎。此操作可能向群发消息，请先与群成员约定。普通测试发送不能代替成员加入链路。": "Choose the actual test group and verify this instance's welcome after a real member joins. This may send a message to the group; agree with its members first. A normal test send cannot replace the member-join path.",
  "尚不能记录：请核对已应用状态、非空欢迎文案、非空范围，以及测试群完整身份是否在精确范围中。": "Cannot record yet. Verify application, nonempty welcome text and scope, and that the complete test-group identity falls within the exact scope.",
  "我已在上述完整会话观察真实成员加入，并核对该实例按预期欢迎。此为人工观察与归因，系统未自动识别发出欢迎的实例。": "I observed a real member join in the complete conversation above and verified that this instance welcomed them as expected. This is manual observation and attribution; the system did not automatically identify the sending instance.",
  "证据或目标已变化，未记录确认；请重新核对当前状态与实际群结果。": "The evidence or target changed. No confirmation was recorded. Recheck current status and the actual group result.",
  "只读核对后记录人工确认": "Verify read-only, then record manual confirmation",
  "人工确认 · ": "Manual confirmation · ",
  "。这是当时的人工观察记录，不是平台自动验收，也不保证持续可用。配置、实例、运行代、完整测试目标或连接身份变化后失效；重读失败不保留确认。": ". This records a human observation at that time, not automated platform acceptance or continued availability. It expires when configuration, instance, generation, complete test target or connection identity changes. A failed reread does not retain confirmation.",
  "记录仅保留在本页内存，离开或刷新页面后丢失。后台每 10 秒只读核对；核对存在间隔，不承诺实时有效。投递结果不确定时先看原群与日志，不自动重发。": "This record lives only in page memory and is lost on navigation or refresh. Background read-only checks run every 10 seconds, so validity is not guaranteed in real time. For uncertain delivery, inspect the original group and logs; sends are not retried automatically.",
  "到账号与会话核对": "Verify in accounts and conversations",
  "查看相关日志": "View related logs",
  "重新开始本用途": "Restart this use case",
  "最新配置与本地草稿不同，请核对后决定是否放弃修改。": "The latest configuration differs from your local draft. Review it before deciding whether to discard changes.",
  "连接已恢复，本地草稿已保留。": "Connection restored; local draft preserved.",
  "已核对最新配置，发布成功。": "Latest configuration verified; publication succeeded.",
  "消息出口配置不可发布：{0}": "Message egress configuration cannot be published: {0}",
  "配置已发布，本地还有新的修改。": "Configuration published. Newer local changes remain.",
  "配置已发布。": "Configuration published.",
  "Workroom 配置": "Workroom setup",
  "配置协作空间、成员和消息渠道。": "Configure collaboration spaces, members and message channels.",
  "任务看板": "Task board",
  "发布中": "Publishing",
  "发布目录": "Publish directory",
  "Demo 只读展示目录；发布仅在私有 full 模式开放。": "The demo displays the directory read-only. Publication is available only in private full mode.",
  "未能确认发布结果。本地草稿已保留，请刷新并核对最新配置。": "Publication outcome could not be confirmed. Your local draft was kept; refresh and verify the latest configuration.",
  "Workroom 目录未就绪": "Workroom directory is not ready",
  "尚未取得目录，暂不能新建、编辑或发布。请先在 Host 安装并配置可选 Workroom Catalog 服务及 Agent，再刷新；无需重建本地草稿。": "The directory has not been loaded, so creation, editing and publication are unavailable. Install and configure the optional Workroom Catalog service and Agent on the Host, then refresh. Your local draft does not need to be recreated.",
  "刷新失败，以下是上次成功加载的目录；本地修改仍保留，恢复目录连接前暂停编辑和发布。": "Refresh failed. Showing the last successfully loaded directory. Local edits are preserved; editing and publication are paused until the directory connection recovers.",
  "放弃未发布修改": "Discard unpublished changes",
  "Endpoint 列表暂不可用；Catalog 仍可查看和编辑，已有消息出口会保持原值。发布时 Runtime 仍会执行最终校验。": "The endpoint list is unavailable. The catalog remains viewable and editable, and existing message egress values are preserved. Runtime still performs final validation on publication.",
  "Workroom Catalog 摘要": "Workroom catalog summary",
  "{0} 个已启用": "{0} enabled",
  "一个 Endpoint 可服务多个 Workroom": "One endpoint can serve multiple Workrooms",
  "来自当前 Agent generation": "From the active Agent generation",
  "尚未配置 Workroom": "No Workrooms configured",
  "创建第一个 Project，将协作空间绑定到 Orchestrator Agent。": "Create your first project and bind a collaboration space to an Orchestrator Agent.",
  "新建 Workroom": "New Workroom",
  "载入最新配置？": "Load the latest configuration?",
  "载入成功后将替换本地未发布修改；读取失败时会保留草稿。": "Successful loading replaces local unpublished changes. Failed reads keep your draft.",
  "放弃修改并载入": "Discard changes and load",
  "名称": "Name",
  "协作项目名称": "Collaboration project name",
  "查看任务": "View tasks",
  "删除 {0}": "Delete {0}",
  "说明": "Description",
  "这个 Workroom 负责什么？": "What is this Workroom responsible for?",
  "主协作空间": "Main collaboration space",
  "负责人标识": "Owner identifiers",
  "每行一位": "One per line",
  "成员": "Member",
  "选择参与项目的 Agent 和角色。": "Choose the Agents and roles participating in this project.",
  "选择 Agent": "Choose Agent",
  "删除成员 {0}": "Remove member {0}",
  "任务执行入口": "Task execution entry",
  "本机执行，或精确路由到远程 Agent Endpoint。": "Execute locally or route precisely to a remote Agent endpoint.",
  "添加成员": "Add member",
  "执行与消息渠道": "Execution and messaging channels",
  "尚未配置主空间": "Main space not configured",
  "消息出口投影": "Message egress mapping",
  "选择该 Agent 在主协作空间发言时使用的 Bot 身份。": "Choose the bot identity this Agent uses when speaking in the main collaboration space.",
  "需要修正": "Needs correction",
  "独立出口": "Separate egress",
  "继承主空间": "Inherit main space",
  "通过 {0}:{1} 投影": "Map through {0}:{1}",
  "继承 {0}": "Inherit {0}",
  "继承主空间 Endpoint · ": "Inherit main-space endpoint · ",
  "（Endpoint 已失效）": " (endpoint no longer valid)",
  "（当前值）": " (current value)",
  " · 已由 {0} 使用": " · Used by {0}",
  "选择已配置 Endpoint": "Choose a configured endpoint",
  "选择 Orchestrator": "Choose Orchestrator",
  "未配置独立 Sponsor 控制空间。": "No separate Sponsor control space configured.",
  "规划与披露配置": "Planning and disclosure configuration",
  "检查任务规划与模型数据处理权限，查看待处理项并显式初始化所需能力。": "Check task planning and model data-processing permissions, review pending items and explicitly initialize the required capabilities.",
  "可以提交任务": "Work submission is available",
  "需要配置": "Configuration required",
  "重新检查": "Check again",
  "初始化披露能力": "Initialize disclosure capabilities",
  "补齐编排能力": "Complete orchestration capabilities",
  "初始化编排能力": "Initialize orchestration capabilities",
  "规划与披露能力门禁": "Planning and disclosure capability gates",
  "项目目录": "Project directory",
  "Workroom 已登记": "Workroom registered",
  "项目授权": "Project authorization",
  "已授权": "Authorized",
  "尚未授权": "Not authorized yet",
  "能力配置": "Capability configuration",
  "已激活": "Activated",
  "尚未激活": "Not activated yet",
  "任务规划": "Task planning",
  "已配置": "Configured",
  "待配置": "Needs configuration",
  "数据处理权限": "Data-processing permissions",
  "Host 版本待升级": "Host update required",
  "处理契约已配置": "Processing contract configured",
  "处理方契约待配置": "Processor contract needs configuration",
  "Workroom 编排已就绪": "Workroom orchestration is ready",
  "Workroom 编排尚未就绪": "Workroom orchestration is not ready",
  " 个 Agent · ": " Agents · ",
  " 个工具 · ": " tools · ",
  " 个技能": " skills",
  "查看配置身份与版本标识": "View configuration identity and revision identifiers",
  "未绑定": "Not bound",
  "需要处理": "Needs attention",
  "初始化中": "Initializing",
  "规划权限已确认": "Planning permissions confirmed",
  "任务规划会使用已确认的能力与数据处理权限；后续能力变化不会自动扩大已有运行的权限。": "Task planning uses confirmed capabilities and data-processing permissions. Later capability changes do not automatically broaden existing runs' permissions.",
  "首次配置所需 YAML": "YAML for initial configuration",
  "保存配置并重启服务，再使用拥有项目授权的身份登录。": "Save configuration and restart the service, then sign in with project-authorized credentials.",
  "使用 Sponsor Token 登录，并把对应 principal 加入 Project sponsors。": "Sign in with a Sponsor token and add its principal to the project's sponsors.",
  "模型处理方披露契约": "Model processor disclosure contract",
  "按真实合同填写数据处理策略；外部模型服务必须禁止训练后才能初始化。": "Set data-processing policies according to the actual contract. External model services must prohibit training before initialization.",
  "占位符必须按 Provider 合同和账号策略填写。OpenRouter 还需在 Privacy/Guardrail 中启用 ZDR 并关闭 data collection；YAML 不会替你修改第三方账号策略。": "Fill placeholders according to the provider contract and account policies. OpenRouter additionally requires ZDR enabled and data collection disabled in Privacy/Guardrail. YAML does not change third-party account settings for you.",
  "查看 YAML 配置示例": "View YAML configuration example",
  "复制": "Copy",
  "请输入 Workroom Project ID": "Enter a Workroom project ID",
  "Workroom 任务看板": "Workroom task board",
  "查看项目运行、任务分配与阻塞情况；规划和权限初始化需要显式确认。": "View project runs, task assignments and blockers. Planning and permission initialization require explicit confirmation.",
  "配置 Workrooms": "Configure Workrooms",
  "填写 Workroom 配置中的 Project ID": "Enter the project ID from Workroom configuration",
  "查询": "Query",
  "最近查询的 Project": "Recently queried projects",
  "Workroom 摘要": "Workroom summary",
  "运行": "Runs",
  "{0} 个仍在运行": "{0} still running",
  "任务": "Tasks",
  "总任务数": "Total tasks",
  "阻塞运行": "Blocked runs",
  "打开运行记录查看原因": "Open run records to inspect the cause",
  "执行分配": "Assignments",
  "执行、审核与集成": "Execution, review and integration",
  "无法读取 Workroom Run": "Could not read Workroom run",
  "无法读取此项目的运行记录。请检查连接与项目授权。": "Could not read this project's run records. Check the connection and project authorization.",
  "Run 时间线": "Run timeline",
  "选择一条运行，查看任务状态、执行分配与阻塞项。": "Select a run to view task status, assignments and blockers.",
  "这个 Project 还没有 Run": "This project has no runs yet",
  "WorkroomKernel 创建首个 Run 后会出现在这里。": "The first run will appear here after WorkroomKernel creates it.",
  "选择一个 Run": "Select a run",
  "右侧将展示 Kernel 的 Task、Assignment、Blocker 与交付引用。": "The Kernel's tasks, assignments, blockers and delivery references will appear on the right.",
  "选择要查看的 Workroom": "Choose a Workroom to view",
  "打开「配置 Workrooms」，在已配置项目上点击「查看任务」，或填写其 Project ID 查询。这里只展示你有权限访问的项目。": "Open Configure Workrooms and click View tasks on a configured project, or enter its project ID. Only projects you can access are displayed.",
  "查看项目任务、审批与执行记录。": "View project tasks, approvals and execution records.",
  "查看公开目录": "View public directory",
  "任务详情需要项目授权": "Task details require project authorization",
  "演示模式不提供任务详情。可查看项目目录。": "Task details are unavailable in demo mode. You can browse the project directory.",
  "运行详情": "Run details",
  "已请求取消": "Cancellation requested",
  "未请求取消": "Cancellation not requested",
  "当前账号仅可查看任务状态，无法查看任务内容与证据。": "Your account can only view task status, not task content or evidence.",
  "运行标识与版本": "Run identifier and revision",
  "任务 · ": "Tasks · ",
  "任务 ": "Task ",
  "必需": "Required",
  "可选": "Optional",
  " 个阻塞项 · ": " blockers · ",
  "已有执行分配": "Execution assigned",
  "未分配执行": "Execution not assigned",
  "任务技术标识": "Task technical identifiers",
  "尚无任务": "No tasks yet",
  "执行分配 · ": "Assignments · ",
  "执行分配 ": "Assignment ",
  "执行分配技术标识": "Assignment technical identifiers",
  "尚无执行分配": "No assignments yet",
  "阻塞项": "Blockers",
  "截止时间 ": "Deadline ",
  "允许动作：": "Allowed actions: ",
  "阻塞项技术标识": "Blocker technical identifiers",
  "当前没有阻塞项": "No current blockers",
  "Reviewer 等待：": "Waiting for reviewers: ",
  " · Sponsor 等待：": " · Waiting for sponsors: ",
  "（此接口仅提供计数）": " (this endpoint provides counts only)",
  "固定值未展示；当前原值保持不变。": "The fixed value is hidden. The original value remains unchanged.",
  "当前：": "Current: ",
  "未设置": "Not set",
  "；固定值：": "; fixed value: ",
  "使用固定值": "Use fixed value",
  "敏感原值未展示": "Sensitive original value hidden",
  "设为 null": "Set to null",
  "数字或 ${ENV_NAME}": "Number or ${ENV_NAME}",
  "填写数字": "Enter a number",
  "当前为环境变量引用，展开值未读取。": "This is an environment variable reference. The expanded value was not read.",
  "当前保存值不在选项中": "The saved value is not in the options",
  "未选择替换时会原样保留；可明确选择新值，或打开完整源码编辑。保存仍需 Host 校验。": "It remains unchanged until explicitly replaced. Choose a new value or edit the complete source. Saving still requires Host validation.",
  "；以 Host 校验结果为准。": "; the Host performs final validation.",
  "连接身份已变化，请登录当前 Host 后重新读取配置。": "The connection identity changed. Sign in to the current Host and reload configuration.",
  "Host 字段定义已变化或不可用，请刷新或打开完整源码": "The Host field definition changed or is unavailable. Refresh it or open the complete source.",
  "{0} 文件版本：{1}": "{0} File revision: {1}",
  "保存失败，草稿已保留": "Save failed; draft preserved",
  "正在读取插件配置和字段定义…": "Reading plugin configuration and field definitions…",
  "配置读取失败，尚未加载的配置不会被当作空值。": "Configuration could not be read. Unloaded values are not treated as empty.",
  "重试读取": "Retry reading",
  "打开完整源码": "Open complete source",
  "配置 Schema 不可用": "Configuration schema unavailable",
  "Host 无法提供此配置的字段定义，不能伪造表单。": "The Host cannot provide field definitions for this configuration, so a form cannot be generated.",
  "Host 尚未提供此配置的 Schema。可选择完整源码编辑。": "The Host has not provided a schema for this configuration. You can edit the complete source instead.",
  "进入配置源码页": "Open configuration source",
  "配置 · ": "Configuration · ",
  "{0} 项": "{0} items",
  "先完成必填项；已有值和声明默认值会保留。Host 负责最终校验，保存使用读取时的版本，冲突时保留草稿。": "Complete required fields first. Existing values and declared defaults are preserved. The Host performs final validation. Saving uses the loaded revision; conflicts preserve your draft.",
  "此项源码有格式错误，草稿已保留；请修正后再切回表单。": "This item's source is invalid and your draft has been kept. Correct it before switching back to the form.",
  "表单": "Form",
  "字段 JSON 草稿有格式错误，请修正后切换。": "A field's JSON draft is invalid. Correct it before switching.",
  "此项源码": "Item source",
  "用途与必填配置": "Use case and required configuration",
  "最小必填配置": "Required configuration",
  "全部配置": "All configuration",
  "已显示本用途相关字段；不代表这些字段必填。其他字段与已有值仍完整保留，保存继续使用同一配置对象与版本。": "Showing fields relevant to this use case does not make them required. Other fields and existing values are preserved. Saving uses the same configuration object and revision.",
  "尚未填写必填配置：": "Required configuration not yet provided: ",
  "。必填是字段存在性提示，格式以 Host 校验结果为准。": ". Required-field guidance checks presence; the Host validates the format.",
  "当前没有缺少的必填项；仍需校验环境变量和字段格式。": "No required fields are missing. Environment variables and field formats still need validation.",
  "。草稿已保留；请刷新最新版本后确认修改。": ". Your draft was kept. Refresh the latest revision before confirming changes.",
  "缺少环境变量：": "Missing environment variables: ",
  "配置环境变量": "Configure environment variables",
  "后重新校验。": " and validate again.",
  "有字段 JSON 草稿格式错误，修正后才能保存。": "A field's JSON draft is invalid. Correct it before saving.",
  "此项 JSON 与表单共用当前草稿，切换无需保存。完整文件源码基于已保存版本，与此项草稿独立；保存仍使用草稿原版本。": "This item's JSON and form share the same draft; no save is needed to switch. Complete file source uses the saved revision independently of this draft. Saving still uses the draft's original revision.",
  "{0} 此项源码": "{0} item source",
  "JSON 格式错误，当前草稿已保留。": "Invalid JSON. The current draft was kept.",
  "此项无需配置。": "This item requires no configuration.",
  "其他字段": "Other fields",
  "撤销草稿": "Discard draft",
  "刷新版本（保留草稿）": "Refresh revision (keep draft)",
  "校验配置": "Validate configuration",
  "保存配置": "Save configuration",
  "切换到暗色模式": "Switch to dark mode",
  "切换到亮色模式": "Switch to light mode",
  "切换主题": "Switch theme",
  "处理中...": "Processing…",
  "暂无数据": "No data",
  "重试": "Retry",
  "关闭通知": "Dismiss notification",
  "跳到主要内容": "Skip to main content",
  "关闭菜单": "Close menu",
  "零安装 Sandbox": "Sandbox · no installation",
  "Bot 工作台": "Bot workspace",
  "打开菜单": "Open menu",
  "切换侧边栏": "Toggle sidebar",
  "主导航": "Main navigation",
  "收起侧边栏": "Collapse sidebar",
  "展开侧边栏": "Expand sidebar",
  "实时事件已连接": "Live events connected",
  "实时事件未连接": "Live events disconnected",
  "当前位置": "Current location",
  "在线 Demo": "Online demo",
  "首页": "Home",
  "Console 实时事件已连接": "Console live events connected",
  "Console 实时事件未连接": "Console live events disconnected",
  "实时": "Live",
  "离线": "Offline",
  "使用说明": "Getting started",
  "部署": "Deploy",
  "部署到本机": "Deploy locally",
  "接 QQ Bot": "Connect a QQ bot",
  "退出登录": "Sign out",
  "状态未确认：{0}": "Status unconfirmed: {0}",
  "Host 未提供安装与当前代证据，请刷新状态。": "The Host did not provide installation and active-generation evidence. Refresh the status.",
  "插件应用证据": "Plugin application evidence",
  "已设为停用": "Set to disabled",
  "当前代：": "Active generation: ",
  "未发布": "Not published",
  "依赖包：": "Dependency package: ",
  "已安装 {0}": "Installed {0}",
  "未安装": "Not installed",
  "实例声明：": "Instance declaration: ",
  "已保存": "Saved",
  "未保存": "Not saved",
  "包与配置一致": "Package and configuration match",
  "尚未确认应用": "Application not yet confirmed",
  "依赖检查：": "Dependency check: ",
  "通过": "Passed",
  "失败": "Failed",
  "尚未检查": "Not checked",
  "就绪证据：": "Readiness evidence: ",
  "已就绪": "Ready",
  "等待就绪": "Waiting for readiness",
  "降级": "Degraded",
  "未知（未确认平台上线）": "Unknown (platform connection not confirmed)",
  "业务验证：": "Business verification: ",
  "可手动选择检查": "Checks can be selected manually",
  "未提供检查": "No checks provided",
  "尚无可读取 schema，仅已检查环境引用；完整校验需 Runtime 预检。": "No readable schema is available. Only environment references were checked; full validation requires a Runtime preflight.",
  "安装、应用与平台就绪不代表业务功能已经验证。": "Installation, application and platform readiness do not prove that business behavior has been verified.",
  "插件详情": "Plugin details",
  "查看配置": "View configuration",
  "配置此实例": "Configure this instance",
  "群欢迎用途上下文读取失败，请返回用途页重新核对。": "Could not load group-welcome context. Return to the use-case page and check again.",
  "用途读取失败": "Could not load use case",
  "群欢迎 · 当前实例 ": "Group welcome · current instance ",
  "本用途关注 welcomeMessage 与 welcomeConversations。建议先明确设为空范围，再选择精确群。只修改你需要的草稿，其他字段仍由原表单完整保留。": "This use case focuses on welcomeMessage and welcomeConversations. Start with an explicitly empty scope, then choose exact groups. Edit only the draft fields you need; the existing form preserves all others.",
  "省略范围会覆盖所有符合条件的群；空列表关闭全部欢迎。保存后仍需在详情核对应用，不能将草稿当成生效配置。": "Omitting the scope includes all eligible groups; an empty list disables all welcome messages. After saving, check application status in details. A draft is not active configuration.",
  "继续使用下方原有“应用变更”与状态核对。完成后返回用途页，选择完整测试群进行真实成员加入的人工核验；应用不等于平台业务验证。": "Continue with the existing Apply changes and status checks below. Then return to the use-case page and choose a complete test group for manual verification using a real member join. Application is not platform business verification.",
  "返回群欢迎流程": "Return to group-welcome setup",
  "保存后到详情核对应用": "After saving, check application in details",
  "会话标识不完整，请检查平台、渠道、类型与会话。": "The conversation identifier is incomplete. Check the platform, endpoint, type and conversation.",
  "未找到活跃会话：{0}": "No active conversation found: {0}",
  "聊天记录还没准备好：请先安装并配置 AI 机器人；收发消息不受影响。": "Chat history is not ready. Install and configure the AI assistant first; sending and receiving messages are unaffected.",
  "切换失败 (HTTP {0})": "Switch failed (HTTP {0})",
  "已切换至消息 #{0}": "Switched to message #{0}",
  "sessionKey 格式不正确：「{0}」。应为 platform:endpointId:scope:sceneId（如 icqq:75318:private:userA）": "Invalid sessionKey: “{0}”. Expected platform:endpointId:scope:sceneId (for example icqq:75318:private:userA).",
  "聊天记录": "Chat history",
  "按聊天账号和会话查看机器人和大家聊过什么（Demo 只读）。": "View conversations by account and chat (read-only in demo).",
  "按聊天账号和会话查看机器人和大家聊过什么，也可以选一段继续往下聊。": "View conversations by account and chat, or choose a point to continue from.",
  "聊天记录需要先装好并配置 AI 机器人；只用聊天账号收发消息的项目不需要开启。": "Chat history requires an installed and configured AI assistant. Projects that only send and receive messages do not need it.",
  "查看分支": "View branches",
  "活跃叶节点:": "Active leaf:",
  "默认（最后一条）": "Default (latest message)",
  "暂无分支点": "No branch points",
  "当前活跃": "Currently active",
  "根消息": "Root message",
  "承接消息 #{0}": "Continues from message #{0}",
  "当前路径": "Current path",
  "其他分支": "Other branches",
  "（无预览）": "(no preview)",
  "切换活跃叶节点": "Change active leaf",
  "将活跃路径切换至消息 #": "Switch the active path to message #",
  "（分支 #": " (branch #",
  "）？ 后续 AI 对话将从该用户消息点继续。": ")? Future AI conversations will continue from that user message.",
  "取消": "Cancel",
  "确认切换": "Confirm switch",
  "渠道入口": "Channel connections",
  "{0} / {1} 个 Endpoint 在线": "{0} / {1} endpoints online",
  "Agent 绑定": "Agent bindings",
  "未安装或装配 Agent": "Agent is not installed or assembled",
  "{0} 个 Agent 配置绑定": "{0} configured Agent bindings",
  "尚未配置模型与 Agent": "Models and Agents are not configured yet",
  "工具目录": "Tool directory",
  "{0} 个工具已注册": "{0} tools registered",
  "当前没有可调用工具": "No tools currently callable",
  "MCP 连接": "MCP connections",
  "{0} / {1} 个服务已连接": "{0} / {1} services connected",
  "未配置 MCP 服务": "No MCP services configured",
  "机器人状态": "Bot status",
  "检查 Agent 配置与渠道状态，选择下一步操作。": "Check Agent configuration and channel status, then choose your next step.",
  "刷新": "Refresh",
  "Agent 就绪状态": "Agent readiness",
  "当前状态未确认": "Current status unconfirmed",
  "配置与渠道已齐备": "Configuration and channels are in place",
  "继续完成 Agent 配置": "Finish Agent configuration",
  "本次读取未完成，下方可能保留上次数据。请先重试读取。": "The current read did not complete. Previous data may still be displayed below. Retry reading first.",
  "可以打开会话验证模型连接与实际对话结果。": "Open a conversation to verify the model connection and actual replies.",
  "先处理下列缺项，再通过真实会话确认收发与模型连接。": "Address the missing items below, then verify messaging and the model connection in a real conversation.",
  "待完成配置": "Configuration to complete",
  "安装并装配可选 Agent 能力 →": "Install and assemble optional Agent capabilities →",
  "配置模型与 Agent 绑定 →": "Configure models and Agent bindings →",
  "连接一个机器人渠道 →": "Connect a bot channel →",
  "打开聊天记录": "Open chat history",
  "配置 Agent": "Configure Agent",
  "连接渠道": "Connect a channel",
  "状态说明": "About this status",
  "此处展示已发现的配置与渠道状态；模型连接及实际对话结果需在对应会话中验证。选择下方 Agent 查看模型与 MCP 服务，或从最近对话检查分支。": "This shows discovered configuration and channel status. Verify model connections and actual replies in the relevant conversation. Select an Agent below to inspect models and MCP services, or review branches in recent chats.",
  "工具": "Tools",
  "在线渠道": "Online channels",
  "Agent 配置绑定": "Configured Agent bindings",
  "每个绑定展示已配置的 Provider、模型和已声明的 MCP 服务；声明不代表 Agent 已启用或 MCP 已连接。": "Each binding shows its configured provider, model and declared MCP services. A declaration does not prove that the Agent is enabled or MCP is connected.",
  "能力目录": "Capability directory",
  "默认 Provider": "Default provider",
  "默认模型": "Default model",
  "未声明 MCP 服务": "No MCP services declared",
  "查看 {0} 详情": "View {0} details",
  "尚未发现 Agent 绑定": "No Agent bindings found",
  "IM 核心可独立使用；需要 AI 时先安装 @zhin.js/agent、zod、ai 和所选 Provider，再配置模型。": "The IM core works on its own. For AI, install @zhin.js/agent, zod, ai and your chosen provider, then configure a model.",
  "Agent 是可选能力，IM 核心可独立使用。需要 AI 时安装 @zhin.js/agent、zod、ai 和所选 Provider，然后配置模型与 Agent。": "Agent is optional; the IM core works independently. For AI, install @zhin.js/agent, zod, ai and your chosen provider, then configure models and Agents.",
  "打开配置": "Open configuration",
  "能力链路": "Capability flow",
  "最近的 Agent 对话": "Recent Agent conversations",
  "全部渠道": "All channels",
  "最近还没有打开过 Agent 对话": "No Agent conversations opened recently",
  "前往渠道会话，选择一个对话后点击分支图标即可开始。": "Open a channel conversation and click its branch icon to begin.",
  "Agent 快捷入口": "Agent shortcuts",
  "查看输入与来源": "Inspect inputs and sources",
  "MCP 服务": "MCP services",
  "检查连接健康度": "Check connection health",
  "继续最近上下文": "Continue recent context",
  "Workroom 看板": "Workroom board",
  "按 Project 查看 Run、Task 与 Assignment": "View runs, tasks and assignments by project",
  "群聊插话": "Group participation",
  "没人 @ 机器人的时候，它要不要自己在群里接话。": "Whether the bot may join a group conversation without being mentioned.",
  "群聊插话状态": "Group participation status",
  "当前账号没有查看群聊插话的权限，请联系管理员开通。": "Your account cannot view group participation. Ask an administrator for access.",
  "现在：": "Now: ",
  "范围：": "Scope: ",
  "下面是最近 24 小时的情况。重启机器人后会重新计数。": "These figures cover the past 24 hours. Restarting the bot resets the counts.",
  "刷新失败，下面是上次读到的数据。": "Refresh failed. Showing the last successfully read data.",
  "最近的记录": "Recent records",
  "最近 24 小时还没有记录。": "No records in the past 24 hours.",
  "设置": "Settings",
  "暂时不能在这里修改设置。只有管理员账号可以修改。": "Settings cannot be changed here with this account. Administrator access is required.",
  "错误详情": "Error details",
  "保存失败：{0}": "Save failed: {0}",
  "改完需要重启机器人才会生效。冷却时间等更细的调整，请到「高级 → 配置」里改。": "Restart the bot to apply changes. For cooldowns and other detailed options, open Advanced → Configuration.",
  "机器人要不要自己接话？": "Allow the bot to join conversations on its own?",
  "关闭后会清空下面的群列表，以后重新打开时要再填一次。": "Turning this off clears the group list below. You will need to enter it again when re-enabling.",
  "在哪些群里？": "In which groups?",
  "所有群": "All groups",
  "只在这些群": "Only these groups",
  "群列表": "Group list",
  "每行一个，写成「平台:群号」，例如\nqq:123456": "One per line, as platform:groupId. For example:\nqq:123456",
  "每个群每小时最多插话几次": "Maximum contributions per group per hour",
  "正在保存…": "Saving…",
  "保存": "Save",
  "助手任务": "Assistant tasks",
  "以下为上次读取的任务。": "Showing the last successfully read tasks.",
  "助手未启用": "Assistant not enabled",
  "启用助手后，可在这里查看任务。": "Enable the assistant to view tasks here.",
  "搜索助手任务": "Search assistant tasks",
  "搜索名称或编号…": "Search by name or ID…",
  "助手任务状态": "Assistant task status",
  "全部状态": "All statuses",
  "已暂停": "Paused",
  "执行失败": "Execution failed",
  "事件接收 ": "Event reception ",
  "未启用": "Not enabled",
  "没有匹配的任务": "No matching tasks",
  "暂无任务": "No tasks",
  "清除筛选": "Clear filters",
  "执行成功": "Execution succeeded",
  "已跳过": "Skipped",
  "任务详情": "Task details",
  "编号：": "ID: ",
  "创建时间：": "Created: ",
  "下次执行：": "Next run: ",
  "原始数据": "Raw data",
  "权限目录读取失败，请刷新。": "Could not read the permission directory. Refresh to retry.",
  "权限说明读取失败，请重试。": "Could not read the permission explanation. Try again.",
  "命令权限说明": "Command permissions",
  "查看规则为什么匹配。这里只做说明与假设检查，不执行命令，也不向平台查询或验证权限。": "Understand why rules match. This is explanatory and hypothetical only: it does not execute commands or query or verify platform permissions.",
  "返回命令目录": "Back to command directory",
  "需要连接当前 Host 并使用 full scope Token；演示模式不能读取权限说明。": "Connect to the current Host with a full-scope token. Permission explanations are unavailable in demo mode.",
  "选择当前运行代的命令": "Choose a command from the active generation",
  "搜索权限命令": "Search commands for permissions",
  "搜索命令或插件实例": "Search commands or plugin instances",
  "读取目录": "Read directory",
  "正在读取当前命令目录…": "Reading the current command directory…",
  "运行代 ": "Generation ",
  " · 共 ": " · Total ",
  " 项 · 第 ": " items · Page ",
  " 页": "",
  "当前筛选没有命令。": "No commands match the current filter.",
  "上一页": "Previous page",
  "下一页": "Next page",
  "permit 数组中的条件必须全部满足；同一项括号内的逗号表示任选一个。平台和自定义 checker 均不会执行。": "Every condition in the permit array must be satisfied. Comma-separated values within parentheses are alternatives. Platform and custom checkers are not executed.",
  "使用假设会话和身份检查内置条件": "Check built-in conditions with a hypothetical conversation and identity",
  "提供假设会话与账号（可选）": "Provide a hypothetical conversation and account (optional)",
  "假设发送者 ID（可选）": "Hypothetical sender ID (optional)",
  "假设角色（逗号分隔，可选）": "Hypothetical roles (comma-separated, optional)",
  "例如 admin、trusted；留空表示未知": "For example admin, trusted; empty means unknown",
  "这里的身份完全由你假设，未向平台核实。留空角色不会被当作已知管理员，也不能据此获得执行权限。": "These identities are hypothetical and have not been verified with the platform. Empty roles do not imply administrator access and cannot grant execution permission.",
  "读取中…": "Reading…",
  "检查假设条件": "Check hypothetical conditions",
  "重新查看规则": "Review rules again",
  "条件说明": "Condition explanation",
  "正在读取规则说明…": "Reading rule explanation…",
  "。此结果不代表已授权或可执行。": ". This result does not authorize execution.",
  "当前存在": "Currently present",
  "当前缺失": "Currently missing",
  "未核实": "Not verified",
  " · 运行代 ": " · Generation ",
  "Adapter 约束 · ": "Adapter constraint · ",
  "没有声明 permit 限制；这不等于已获得平台执行权限。": "No permit restriction is declared. This does not grant platform execution permission.",
  "本次假设会话": "Hypothetical conversation",
  "选择命令查看规则；修改假设后需要重新检查，不沿用旧结果。": "Choose a command to view its rules. After changing the hypothetical identity, run the check again; previous results are not reused.",
  "配置保存失败，草稿已保留。请查看页面中的技术详情。": "Configuration could not be saved. Your draft is preserved. See the technical details on this page.",
  "已刷新": "Refreshed",
  "刷新失败": "Refresh failed",
  "配置": "Configuration",
  "加载配置中...": "Loading configuration…",
  "默认按字段定义编辑，每项配置均可切换表单与源码。": "Edit fields using their schema. Each configuration item can switch between form and source views.",
  "。文件保存不代表当前运行已应用。": ". Saving the file does not mean the active runtime has applied it.",
  "配置保存失败，当前草稿已保留。请检查内容后重新保存，或撤销本次修改。": "Configuration could not be saved. Your draft is preserved. Review it and save again, or discard these changes.",
  "技术详情": "Technical details",
  "筛选配置项": "Filter configuration items",
  "搜索配置项或插件实例…": "Search configuration items or plugin instances…",
  "插件声明": "Plugin declarations",
  "完整源码": "Complete source",
  "插件实例与启停声明": "Plugin instance and enablement declarations",
  "configVersion、plugins 和 disable_plugins 决定配置版本、插件挂载与启停。通过插件管理创建或调整实例；业务参数在对应配置项中编辑。": "configVersion, plugins and disable_plugins define the configuration version, mounted instances and enablement. Create or change instances in plugin management; edit business parameters in their configuration items.",
  "管理插件实例": "Manage plugin instances",
  "当前插件声明（只读）": "Current plugin declarations (read-only)",
  "完整源码基于已保存配置；各项表单中尚未保存的草稿仍会保留。编辑单项时可在该项内切换源码，与表单共用草稿。": "Complete source reflects the saved configuration; unsaved form drafts are retained. An item's source and form share the same draft.",
  "{0} 配置源码": "{0} configuration source",
  "保存中...": "Saving…",
  "撤销": "Discard",
  "有未保存的更改；草稿绑定开始编辑时的版本，刷新不会覆盖或自动合并草稿。冲突后请核对最新源码再重新编辑。": "Unsaved changes are bound to the revision at the start of editing. Refreshing does not replace or merge your draft. After a conflict, review the latest source before editing again.",
  "Demo 不读取 Host 原始配置；完整配置工作台仅在私有 full 模式开放": "The demo does not read raw Host configuration. The complete configuration workspace is available only in private full mode.",
  "原始 YAML 可能包含 Token、密钥与基础设施信息，因此公开 Demo 不请求、不缓存，也不渲染配置内容。": "Raw YAML may contain tokens, secrets and infrastructure information. The public demo neither requests nor caches or displays configuration content.",
  "配置数据已隔离": "Configuration data is isolated",
  "部署 Console full 模式后，可使用表单和 YAML 两种方式管理配置。": "Deploy Console in full mode to manage configuration with forms or YAML.",
  "无法校验表达式，请检查连接后重试。": "Could not validate the expression. Check the connection and try again.",
  " 重试": " Retry",
  "定时提醒": "Scheduled reminders",
  "管理持久化和内存定时任务": "Manage persistent and in-memory scheduled tasks",
  "调度日志": "Scheduler logs",
  " 刷新": " Refresh",
  " 新建任务": " New task",
  "当前实例尚未启用持久化 AI 调度，暂不能创建、暂停或删除任务。已有插件注册的任务仍可在下方查看。 如需定时 AI 任务，请在运行实例中安装并配置 Agent 及持久化调度引擎，再刷新本页。": "Persistent AI scheduling is not enabled on this instance, so tasks cannot be created, paused or deleted here. Plugin-registered tasks remain visible below. To use scheduled AI tasks, install and configure Agent and the persistent scheduler, then refresh.",
  "持久化任务": "Persistent tasks",
  "暂无持久化定时任务": "No persistent scheduled tasks",
  "Demo 仅展示实例中已存在的任务": "The demo only shows tasks already present on the instance",
  "点击「新建任务」添加一个定时 AI 任务": "Click New task to add a scheduled AI task",
  "启用持久化 AI 调度后可在这里管理任务": "Enable persistent AI scheduling to manage tasks here",
  "创建于 ": "Created ",
  "暂停": "Pause",
  "恢复": "Resume",
  "删除": "Delete",
  "任务 ID": "Task ID",
  "复制 ID": "Copy ID",
  "复制失败，请手动选择任务 ID 复制。": "Copy failed. Select and copy the task ID manually.",
  "Cron 表达式": "Cron expression",
  "状态: ": "Status: ",
  "运行中": "Running",
  "创建于: ": "Created: ",
  "内存任务（插件注册）": "In-memory tasks (registered by plugins)",
  "暂无插件注册的内存定时任务": "No plugin-registered in-memory tasks",
  "已停止": "Stopped",
  "插件: ": "Plugin: ",
  "下次执行: ": "Next run: ",
  "所属插件": "Owning plugin",
  "新建定时任务": "New scheduled task",
  "创建一个持久化定时任务，到点时会将 Prompt 发送给 AI 执行。": "Create a persistent scheduled task that sends the prompt to AI when triggered.",
  "标签（可选）": "Label (optional)",
  "例如：每日摘要": "For example: daily summary",
  "秒 分 时 日 月 周，例如：0 0 9 * * *": "Second minute hour day month weekday, for example: 0 0 9 * * *",
  "6 字段格式：秒(0-59) 分(0-59) 时(0-23) 日(1-31) 月(1-12) 周(0-7)": "6 fields: second (0–59), minute (0–59), hour (0–23), day (1–31), month (1–12), weekday (0–7)",
  "表达式校验通过": "Expression is valid",
  "表达式无效：{0}": "Invalid expression: {0}",
  "正在校验表达式…": "Validating expression…",
  "触发时发送给 AI 的指令...": "Instructions to send to AI when triggered…",
  "创建中...": "Creating…",
  "创建": "Create",
  "确认删除": "Confirm deletion",
  "确定要删除任务「": "Delete the task “",
  "」吗？此操作不可撤销。": "”? This cannot be undone.",
  "删除中...": "Deleting…",
  "无法读取 Host 状态": "Could not read Host status",
  "Host 返回了无效状态": "The Host returned an invalid status",
  "Host 响应超时，请检查连接或服务状态": "The Host timed out. Check the connection or service status.",
  "渠道": "Channels",
  "{0} 个在线连接": "{0} connections online",
  "等待 Host 状态": "Waiting for Host status",
  "命令": "Commands",
  "可被消息直接调用": "Callable directly from messages",
  "状态暂时不可读": "Status is temporarily unreadable",
  "可选能力：需要 AI 时安装并配置 Agent": "Optional: install and configure Agent when you need AI",
  "模型与会话绑定": "Model and conversation bindings",
  "安装 Agent 后可用": "Available after installing Agent",
  "供 Agent 按需调用": "Available to Agent on demand",
  "未启用或尚未接线": "Not enabled or connected yet",
  "{0} 个连接正常": "{0} connections healthy",
  "子插件": "Child plugins",
  "{0} 个子插件正在运行": "{0} child plugins running",
  "Host 暂时不可达": "Host temporarily unreachable",
  "控制面仍可继续使用；恢复连接后会自动刷新运行状态。": "The control interface remains available. Runtime status refreshes automatically when the connection recovers.",
  "还没有连接渠道": "No channels connected yet",
  "先用 Sandbox 验证，再接入真实平台。": "Verify with Sandbox first, then connect a real platform.",
  "{0} 个渠道离线": "{0} channels offline",
  "检查凭据、网络和适配器日志。": "Check credentials, network connectivity and adapter logs.",
  "历史错误 {0} 条": "{0} recorded errors",
  "打开错误日志": "Open error logs",
  "历史警告 {0} 条": "{0} recorded warnings",
  "打开警告日志": "Open warning logs",
  "日志状态暂时不可读": "Log status is temporarily unreadable",
  "尚无法确认是否有运行错误，请打开日志页检查读取详情。": "Runtime errors cannot be confirmed yet. Open Logs to inspect read details.",
  "重启请求已发送，连接将在服务恢复后自动重连": "Restart requested. The connection will reconnect automatically when the service recovers.",
  "重启请求未能发送": "Could not send the restart request",
  "正在加载工作台": "Loading workspace",
  "Host 连接需要恢复": "Host connection needs recovery",
  "所有核心服务运行正常": "All core services are running normally",
  "有事项需要处理": "Some items need attention",
  "Host 暂时不可达，": "The Host is temporarily unreachable; ",
  "控制面仍可继续使用": "the control interface remains available",
  "运行概览": "Overview",
  "{0} 个字段 · 已设置 {1}": "{0} fields · {1} set",
  "已设置 {0}": "{0} set",
  "全部展开": "Expand all",
  "全部折叠": "Collapse all",
  "有未保存的修改": "Unsaved changes",
  "上次执行失败": "Last run failed",
  "上次执行成功": "Last run succeeded",
  "上次已跳过": "Last run skipped",
  "执行详情 →": "Run details →",
  "这些任务在「定时提醒」里创建、暂停和删除；这里查看执行状态与原始数据。": "Create, pause and delete these tasks in Scheduled reminders; this page shows their run status and raw data.",
  "去定时提醒": "Open scheduled reminders",
  "不接话": "Stayed quiet",
  "想接话": "Wanted to reply",
  "未判断": "Not judged",
  "群": "Group",
  "记录": "Records",
  "最近一次": "Latest",
  "逐条记录（{0}）": "All records ({0})",
  "选择项目": "Choose a project",
  "已配置的 Workroom 项目，选一个查看任务。": "Configured Workroom projects. Pick one to see its tasks.",
  "还没有读取到已配置的项目，可以按 Project ID 查询。": "No configured projects were found. You can look one up by Project ID.",
  "已配置的 Workroom 项目": "Configured Workroom projects",
  "已停用": "Disabled",
  "按 Project ID 查询": "Look up by Project ID",
  "在上方选择一个已配置的项目；还没有项目时，先打开「配置 Workrooms」创建。": "Choose a configured project above. If there are none yet, create one in Configure Workrooms.",
  "刚刚": "just now",
  "{0} 分钟前": "{0} min ago",
  "{0} 小时前": "{0} h ago",
  "{0} 天前": "{0} days ago",
  "{0} 轮": "{0} turns",
  "按最近 Agent 活动排序，选一个查看完整对话。": "Sorted by recent Agent activity. Pick one to see the full conversation.",
  "发送目标的聊天账号不存在或已改名。请确认该账号仍在“聊天账号”中在线，或修改任务的发送目标。": "The chat account this task sends to no longer exists or was renamed. Check that it is still online under Chat accounts, or change the task's target.",
  "执行超时。请检查模型服务与网络，稍后会按计划重试。": "The run timed out. Check the model service and network; it will retry on schedule.",
  "模型服务限流。请降低频率或检查 Provider 额度。": "The model service is rate limiting. Lower the frequency or check the provider quota.",
  "模型服务鉴权失败。请检查 Provider 的 API Key 配置。": "The model service rejected the credentials. Check the provider API key.",
  "查看聊天账号 →": "View chat accounts →",
  "每 {0} 秒": "Every {0} seconds",
  "每秒": "Every second",
  "每分钟": "Every minute",
  "每 {0} 分钟": "Every {0} minutes",
  "每小时第 {0} 分": "Hourly at minute {0}",
  "每 {0} 小时": "Every {0} hours",
  "每天 {0}": "Daily at {0}",
  "每{0} {1}": "Every {0} at {1}",
  "周日": "Sunday",
  "周一": "Monday",
  "周二": "Tuesday",
  "周三": "Wednesday",
  "周四": "Thursday",
  "周五": "Friday",
  "周六": "Saturday",
  "{0} 秒后": "in {0}s",
  "{0} 分钟后": "in {0} min",
  "{0} 小时后": "in {0} h",
  "{0} 天后": "in {0} days",
  "频率": "Schedule",
  "下次执行": "Next run",
  "插件": "Plugin",
  "可以对话，但有服务未连接": "Ready to chat, but some services are disconnected",
  "{0} 个 MCP 服务未连接，检查服务地址与凭据 →": "{0} MCP services disconnected — check their address and credentials →",
  "{0} 个 MCP 服务未连接": "{0} MCP services disconnected",
  "Agent 暂时无法调用这些服务提供的工具。": "Agents cannot use the tools these services provide right now.",
  "{0} 个未连接": "{0} disconnected",
  "配置项": "Configuration items",
  "共 {0} 个账号": "{0} accounts",
  "{0} 个在线": "{0} online",
  "暂无待处理": "Nothing pending",
  "页面导航、配置入口和能力目录保持可用。重新连接后，渠道、Agent 与运行状态会在这里恢复。": "Navigation, configuration entry points and capability directories remain available. Channel, Agent and runtime status will return here after reconnection.",
  "这里优先汇总需要处理的渠道、日志和 Agent 状态，再提供能力目录与下一步操作。": "Review channel, log and Agent issues first, then explore available capabilities and next steps.",
  "进入会话": "Open conversation",
  "重新连接": "Reconnect",
  "刷新工作台": "Refresh workspace",
  "重启服务": "Restart service",
  "重启": "Restart",
  "还没有用量数据": "No usage data yet",
  "运行子插件": "Running child plugins",
  "可用命令": "Available commands",
  "持续运行": "Uptime",
  "部分状态未能更新": "Some status data could not be updated",
  "运行状态当前不可用": "Runtime status is currently unavailable",
  " · 上次更新 {0}": " · Last updated {0}",
  "状态与日志": "Status and logs",
  " 项": " items",
  "渠道在线": "Channels online",
  "暂无警告或错误日志": "No warning or error logs",
  "等待运行状态": "Waiting for runtime status",
  "当前实例的能力": "Capabilities on this instance",
  "打开能力中心": "Open capability explorer",
  "常用操作": "Common actions",
  "连接和管理会话": "Connect and manage conversations",
  "查看好友、群组、统一收件箱并直接收发消息。": "Browse friends, groups and the unified inbox, and send or receive messages.",
  "查看 Workroom 任务": "View Workroom tasks",
  "从市场添加能力": "Add capabilities from the store",
  "调整运行配置": "Adjust runtime configuration",
  "检查运行日志": "Inspect runtime logs",
  "重启 Zhin 服务": "Restart Zhin service",
  "所有连接将断开，进行中的对话可能被中止。通过 zhin runtime start 启动的前台和 daemon 服务会自动重新启动；--once 模式不会自动恢复。若使用自定义启动器，请确认其重启机制。": "All connections will close and active conversations may be interrupted. Foreground and daemon services started with zhin runtime start restart automatically; --once does not recover automatically. If using a custom launcher, check its restart behavior.",
  "正在重启": "Restarting",
  "确认重启": "Confirm restart",
  "表": "table",
  "集合": "collection",
  "桶": "bucket",
  "数据库": "Database",
  "浏览 {0} 中的数据（Demo 只读）。": "Browse data in {0} (read-only in demo).",
  "浏览和管理 {0} 中的数据；左栏选择对象，右侧查看与编辑。": "Browse and manage data in {0}. Select an object on the left to view and edit it.",
  "数据库信息": "Database information",
  "数据表": "Tables",
  "数据库对象尚未读取成功": "Database objects have not been read successfully",
  "等待读取数据库对象": "Waiting to read database objects",
  " 列": " columns",
  "删除{0} {1}": "Delete {0} {1}",
  "返回{0}列表": "Back to {0} list",
  "返回": "Back",
  "数据库对象尚未读取成功，请先重试或使用有权限的身份连接。": "Database objects have not been read successfully. Retry or connect with an authorized identity.",
  "在左侧选择一个{0}{1}": "Select a {0}{1} on the left",
  "删除{0}": "Delete {0}",
  "确定要删除{0} \"{1}\" 吗？此操作不可撤销！": "Delete {0} “{1}”? This cannot be undone.",
  "编辑不能修改 _id。": "The _id cannot be changed while editing.",
  "添加成功": "Added successfully",
  "更新成功": "Updated successfully",
  "删除成功": "Deleted successfully",
  "添加文档": "Add document",
  "共 ": "Total ",
  " 条 · 第 ": " records · Page ",
  "暂无文档": "No documents",
  "查看完整 JSON": "View complete JSON",
  "编辑记录": "Edit record",
  "编辑": "Edit",
  "删除记录": "Delete record",
  "编辑文档": "Edit document",
  "删除文档": "Delete document",
  "确定要删除这条文档吗？": "Delete this document?",
  "Key 不能为空。": "Key cannot be empty.",
  " 个键": " keys",
  "键值表，宽表可在此区域内左右滑动": "Key-value table; scroll horizontally within this area for wide content",
  "操作": "Actions",
  "编辑键值": "Edit key-value pair",
  "Value (JSON 或纯文本)": "Value (JSON or plain text)",
  "该 Key 已存在，请取消并编辑已有键值。": "This key already exists. Cancel and edit the existing value instead.",
  "删除键值": "Delete key-value pair",
  "确定要删除键 \"{0}\" 吗？": "Delete the key “{0}”?",
  "记录已不存在或主键已改变。当前输入已保留，请取消后刷新列表。": "The record no longer exists or its primary key changed. Your input is preserved; cancel and refresh the list.",
  "未确认更新结果。当前输入已保留，请取消后刷新列表核对。": "The update outcome is unconfirmed. Your input is preserved; cancel and refresh the list to verify.",
  "记录已保存，但列表刷新失败。请重试读取列表。": "The record was saved, but refreshing the list failed. Retry reading the list.",
  "表数据": "Table data",
  "当前显示上次加载的数据。": "Showing previously loaded data.",
  "添加": "Add",
  "正在加载第 {0} 页…": "Loading page {0}…",
  "共 {0} 条 · 第 {1}/{2} 页{3}": "{0} records · Page {1}/{2}{3}",
  "未加载": "Not loaded",
  "此表未声明主键，暂不支持编辑或删除记录。": "This table declares no primary key, so editing and deleting records are unavailable.",
  "数据表，宽表可在此区域内左右滑动": "Data table; scroll horizontally within this area for wide content",
  "按 {0} {1}排列（当前页）": "Sort by {0} {1} (current page)",
  "排序当前页": "Sort current page",
  "正在加载表数据": "Loading table data",
  "数据未加载": "Data not loaded",
  "添加记录": "Add record",
  "将删除 {0} 中 {1} 的记录。此操作无法撤销。": "Delete the record {1} from {0}? This cannot be undone.",
  "消息操作": "Message actions",
  "引用": "Quote",
  "转发": "Forward",
  "复制摘要": "Copy summary",
  "历史方向未记录": "Historical direction was not recorded",
  "暂无消息": "No messages",
  "暂无会话": "No conversations",
  "返回聊天账号": "Back to chat accounts",
  "状态未知": "Unknown state",
  "在线": "Online",
  "搜索会话": "Search conversations",
  "搜索会话名称或 ID": "Search conversation name or ID",
  "无匹配「": "No matches for “",
  "测试连接": "Test connection",
  "刷新列表": "Refresh list",
  "图片": "Image",
  "[图片]": "[Image]",
  "打开原图": "Open original image",
  "视频": "Video",
  "[视频]": "[Video]",
  "视频消息": "Video message",
  "打开视频": "Open video",
  "[语音]": "[Audio]",
  "暂停语音": "Pause voice message",
  "播放语音": "Play voice message",
  "语音消息": "Voice message",
  "文件": "File",
  "打开文件": "Open file",
  "引用消息": "Quoted message",
  "转发消息": "Forwarded message",
  "原消息摘要不可用": "Original message summary unavailable",
  "转发内容摘要不可用": "Forwarded content summary unavailable",
  "未识别消息类型：": "Unrecognized message type: ",
  "表情": "Emoji",
  "表情 {0}": "Emoji {0}",
  "私聊": "Private chat",
  "群聊": "Group chat",
  "频道": "Channel",
  " · 父容器 {0}": " · Parent {0}",
  " · 话题 {0}": " · Thread {0}",
  "消息处理诊断": "Message processing diagnostics",
  "本会话最近诊断": "Recent diagnostics for this conversation",
  "当前 Host 尚不支持消息诊断，请更新 Host 后重试；这不表示消息没有问题。": "This Host does not support message diagnostics yet. Update the Host and try again; this does not mean the message has no issue.",
  "当前身份无权读取消息诊断，需要 full scope。": "Your identity cannot read message diagnostics. Full scope is required.",
  "登录已失效，请重新连接 Host。": "Your login expired. Reconnect to the Host.",
  "Host 的 IM 消息诊断尚未就绪，请确认运行时已启动后刷新。": "Host IM diagnostics are not ready. Confirm the runtime has started, then refresh.",
  "诊断读取失败（HTTP {0}），请检查 Host 状态后刷新。": "Could not read diagnostics (HTTP {0}). Check Host status and refresh.",
  "诊断读取失败，请检查连接后刷新。": "Could not read diagnostics. Check the connection and refresh.",
  "Demo 不开放消息诊断": "Message diagnostics are unavailable in demo mode",
  "请先连接 Host": "Connect to a Host first",
  "诊断这条入站消息": "Diagnose this inbound message",
  "最近诊断": "Recent diagnostics",
  "只读查看实际处理阶段，不发送或重放消息。": "Read actual processing stages without sending or replaying messages.",
  " 可从会话顶部查看“最近诊断”。": " You can view Recent diagnostics at the top of the conversation.",
  "按原始完整会话与平台消息 ID 查询": "Query by the original complete conversation identity and platform message ID",
  "按当前完整会话查询最近 50 条记录": "Read the latest 50 records for the current complete conversation identity",
  "正在读取处理记录…": "Reading processing records…",
  "没有找到该范围的近期记录。": "No recent records found for this scope.",
  "入站处理已结束": "Inbound processing ended",
  "命中指令：": "Matched command: ",
  " · 入站处理结束不等于业务、Agent 或平台投递已完成。": " · Completion of inbound processing does not mean business work, Agent work or platform delivery has completed.",
  "步骤或投递超过保留上限，记录不完整，请结合日志排查。": "Some stages or deliveries exceeded the retention limit. This record is incomplete; inspect the logs as well.",
  "实际处理步骤": "Actual processing stages",
  "实际投递记录": "Actual delivery records",
  "投递 ": "Delivery ",
  "结果不确定": "Outcome uncertain",
  "实际目标：": "Actual target: ",
  "仅表示平台已受理，不保证客户端显示或接收者已读。": "This only means the platform accepted the message. It does not guarantee client display or that the recipient read it.",
  "错误代码": "Error code",
  "实际目标身份": "Actual target identity",
  "对应问题的处理方法": "Guidance for this issue",
  "查看处理方法": "View guidance",
  "记录身份与版本": "Record identity and revision",
  "出站内容投影诊断": "Outbound projection diagnostics",
  "目标预览渲染诊断": "Target preview rendering diagnostics",
  "实际发送渲染诊断": "Actual delivery rendering diagnostics",
  "消息 ID：": "Message ID: ",
  "出站投影": "Outbound projection",
  "目标预览": "Target preview",
  "传给 Endpoint": "Passed to endpoint",
  "空内容": "Empty content",
  "降级原因：": "Fallback reason: ",
  "未发生格式降级": "No format fallback",
  "诊断不可用：": "Diagnostics unavailable: ",
  "仅记录内容转换结果，不能据此证明 Endpoint 已发送或平台已接收。": "This only records content conversion. It does not prove that the endpoint sent the message or the platform received it.",
  "最终发送链路记录；平台客户端显示可能不同。": "Recorded by the final sending pipeline. Platform client display may differ.",
  "系统": "System",
  "请求": "Requests",
  "好友/群邀请": "Friend / group invitations",
  "通知": "Notifications",
  "群管/撤回等": "Moderation, recalls and more",
  "参数无效": "Invalid parameters",
  "删除好友": "Delete friend",
  "确定删除好友「{0}」？此操作不可撤销。": "Delete the friend “{0}”? This cannot be undone.",
  "踢出群成员": "Remove group member",
  "确定将「{0}」踢出群聊？": "Remove “{0}” from this group?",
  "禁言成员": "Mute member",
  "确定禁言「{0}」？": "Mute “{0}”?",
  "设为管理员": "Make administrator",
  "确定将「{0}」设为群管理员？": "Make “{0}” a group administrator?",
  "确定": "Confirm",
  "图片链接": "Image link",
  "视频链接": "Video link",
  "音频链接": "Audio link",
  "本地图片": "Local image",
  "本地文件": "Local file",
  "引用 {0}: {1}": "Quote {0}: {1}",
  "转发 {0}: {1}": "Forward {0}: {1}",
  " 会话列表": " conversations",
  "查看 Agent 对话轨迹": "View Agent conversation activity",
  "加载更早消息": "Load earlier messages",
  "消息历史读取失败：": "Could not read message history: ",
  "暂无消息，对方发送的消息会显示在此处": "No messages yet. Incoming messages will appear here.",
  "Demo 仅读消息记录，不提供消息编辑器。": "The demo only reads message records; it has no message composer.",
  "引用 {0}": "Quote {0}",
  "转发 {0}": "Forward {0}",
  "Markdown 模式": "Markdown mode",
  "插入 QQ 表情段": "Insert a QQ emoji segment",
  "选择本地图片（插入为 data URL）": "Choose a local image (insert as a data URL)",
  "图片文件": "Image file",
  "选择本地文件（插入为 data URL 文件段）": "Choose a local file (insert as a data URL file segment)",
  "音频": "Audio",
  "图片 URL 或 base64://…": "Image URL or base64://…",
  "视频直链 URL": "Direct video URL",
  "音频直链 URL": "Direct audio URL",
  "插入": "Insert",
  "本地附件": "Local attachment",
  "URL 附件": "URL attachment",
  "移除附件": "Remove attachment",
  "Markdown 消息：支持标题、列表、引用、代码块…": "Markdown message: headings, lists, quotes, code blocks…",
  "文字消息；也可手写 [@名称]、[face:id]、[image:URL]、[video:URL]、[audio:URL]": "Text message; you can also type [@name], [face:id], [image:URL], [video:URL] or [audio:URL]",
  "Enter 发送 · Shift+Enter 换行 · 当前模式：": "Enter to send · Shift+Enter for a new line · Mode: ",
  "普通文本": "Plain text",
  " · 待发送 ": " · Ready to send ",
  " 个消息段": " message segments",
  "待处理": "Pending",
  "历史": "History",
  "操作失败：": "Operation failed: ",
  "正在读取待处理请求…": "Reading pending requests…",
  "请求读取失败：": "Could not read requests: ",
  "此渠道未提供请求管理，且未启用请求收件箱": "This channel provides no request management and the request inbox is not enabled",
  "暂无未处理请求": "No pending requests",
  "来自 ": "From ",
  "同意": "Accept",
  "拒绝": "Reject",
  "标记已处理": "Mark as handled",
  "未启用统一收件箱，无历史记录": "Unified inbox is not enabled; no history is available",
  "暂无请求历史": "No request history",
  "已处理": "Handled",
  "加载更多": "Load more",
  "没有更多记录": "No more records",
  "未读": "Unread",
  "正在读取通知…": "Reading notifications…",
  "通知读取失败：": "Could not read notifications: ",
  "此实例未启用通知收件箱": "The notification inbox is not enabled on this instance",
  "暂无未读通知": "No unread notifications",
  "已读": "Read",
  "暂无通知历史": "No notification history",
  "选择会话或查看请求 / 通知": "Choose a conversation, or view requests and notifications",
  "在左侧选择好友、群或频道查看消息并发送内容；也可以查看请求与通知。": "Select a friend, group or channel on the left to view messages and send content. You can also view requests and notifications.",
  "群成员与管理": "Group members and moderation",
  "仅 ICQQ 群聊": "ICQQ group chats only",
  "加载成员": "Load members",
  "搜索成员": "Search members",
  "搜索成员昵称、ID 或角色": "Search member nickname, ID or role",
  "全部 {0}": "All {0}",
  "群主 {0}": "Owners {0}",
  "管理 {0}": "Administrators {0}",
  "成员 {0}": "Members {0}",
  "正在加载成员": "Loading members",
  "暂无匹配成员": "No matching members",
  "踢": "Remove",
  "禁言": "Mute",
  "管理": "Admin",
  "好友列表：{0}": "Friends: {0}",
  "群列表：{0}": "Groups: {0}",
  "频道列表：{0}": "Channels: {0}",
  "已删除好友「{0}」": "Deleted friend “{0}”",
  "删除好友失败": "Could not delete friend",
  "测试失败：{0}": "Test failed: {0}",
  "聊天账号": "Chat accounts",
  "看看机器人登录的聊天账号是否在线，点进去查看会话、好友申请和通知。": "Check whether your bot accounts are online. Open an account to view conversations, friend requests and notifications.",
  "加载失败：{0}": "Could not load: {0}",
  "适配器:": "Adapter:",
  "运行状态": "Runtime status",
  "适配器类型": "Adapter type",
  "连接状态": "Connection status",
  "已连接": "Connected",
  "未连接": "Disconnected",
  " 条待处理": " pending",
  "点击进入管理": "Open management",
  "暂无渠道": "No channels",
  "请先配置平台适配器及机器人账号，然后启动 Host。": "Configure a platform adapter and bot account, then start the Host.",
  "环境变量文件": "Environment variable file",
  "已保存，需重启生效": "Saved; restart required",
  "保存失败；未保存修改已保留，请重试。": "Save failed. Unsaved changes were kept; try again.",
  "加载中...": "Loading…",
  "文件不存在": "File does not exist",
  "文件不存在，保存后将自动创建": "The file does not exist and will be created when you save",
  "未保存修改只在本标签页内保留；切换页面或文件可恢复，刷新前请保存。": "Unsaved changes are kept only in this browser tab. They survive page or file navigation; save before refreshing.",
  "{0} 环境变量{1}": "{0} environment variables{1}",
  "显示敏感值并编辑": "Reveal sensitive values and edit",
  "隐藏敏感值": "Hide sensitive values",
  "Demo 只读 · 敏感值始终遮罩": "Demo is read-only · sensitive values remain hidden",
  "有未保存的更改": "Unsaved changes",
  "放弃未保存的修改？": "Discard unsaved changes?",
  "将恢复 {0} 上次保存的内容。": "Restore the last saved content of {0}.",
  "放弃修改": "Discard changes",
  "继续编辑": "Keep editing",
  "环境变量": "Environment variables",
  "加载文件列表…": "Loading file list…",
  "查看 .env / .env.* 中的键值；Demo 只读且敏感值不可揭示。": "View keys and values in .env / .env.*. The demo is read-only and never reveals sensitive values.",
  "敏感值默认隐藏，保存后需重启生效。": "Sensitive values are hidden by default. Restart after saving to apply changes.",
  "环境变量文件列表": "Environment variable files",
  "新": "New",
  "格式 ": "Format ",
  "，支持带引号的多行值。": ", including quoted multiline values.",
  "文件内容（只读）": "File contents (read-only)",
  "文件内容编辑器": "File contents editor",
  "文件内容": "File contents",
  "保存失败，未保存修改已保留。请重试。": "Save failed. Unsaved changes were kept; try again.",
  "关闭文件": "Close file",
  "已恢复本标签页内的未保存修改。刷新或关闭标签页前请保存。": "Unsaved changes in this tab were restored. Save before refreshing or closing the tab.",
  "撤销更改": "Discard changes",
  "Demo 只读 · {0} 行": "Demo is read-only · {0} lines",
  "{0} 行 · Ctrl+S 保存": "{0} lines · Ctrl+S to save",
  "项目文件": "Project files",
  "浏览工作空间中的配置文件和源代码（Demo 只读）": "Browse configuration and source files in the workspace (read-only in demo)",
  "浏览和编辑工作空间中的配置文件和源代码": "Browse and edit configuration and source files in the workspace",
  "切换页面会保留本标签页内的未保存修改；刷新或关闭标签页前请保存。文件列表刷新不会重新加载编辑内容。": "Page navigation preserves unsaved changes in this tab. Save before refreshing or closing the tab. Refreshing the file list does not reload editor content.",
  "文件列表": "File list",
  "文件浏览器": "File browser",
  "文件列表尚未读取成功": "File list has not been read successfully",
  "等待读取文件列表": "Waiting to read the file list",
  "暂无文件": "No files",
  "文件列表尚未读取成功，请先重试或使用有权限的身份连接。": "The file list has not been read successfully. Retry or connect with an authorized identity.",
  "选择左侧文件查看内容": "Select a file on the left to view it",
  "选择左侧文件开始编辑": "Select a file on the left to start editing",
  "将放弃 {0} 的修改{1}。": "Discard changes to {0}{1}.",
  "放弃并切换": "Discard and switch",
  "放弃并关闭": "Discard and close",
  "组件": "Components",
  "个组件": " components",
  "项": " items",
  "查看权限说明": "View permission explanation",
  "组件详情": "Component details",
  "命令目录": "Command directory",
  "未命名命令": "Unnamed command",
  "没有提供命令说明": "No command description provided",
  " 参数": " parameters",
  "无参数": "No parameters",
  " 权限": " permissions",
  "中间件执行管线": "Middleware pipeline",
  "组件画廊": "Component gallery",
  "查看 {0} 组件详情": "View {0} component details",
  "未命名组件": "Unnamed component",
  "Endpoint 状态": "Endpoint status",
  "未命名 Endpoint": "Unnamed endpoint",
  "Agent 关系": "Agent relationships",
  "未命名工具": "Unnamed tool",
  "没有提供工具说明": "No tool description provided",
  "提示词片段目录": "Prompt fragment directory",
  "未限制": "Unrestricted",
  "{0} 上限": "{0} limit",
  "未命名片段": "Unnamed fragment",
  "全平台": "All platforms",
  "未命名 MCP": "Unnamed MCP",
  "连接不可用": "Connection unavailable",
  "能力详情": "Capability details",
  "查看机器人状态": "View bot status",
  "管理 Endpoints": "Manage endpoints",
  "示例参数": "Example parameters",
  "当前 Host 没有提供可预览的 Endpoint 标识": "The current Host provided no endpoint identifiers for preview",
  "请选择目标 Endpoint": "Select a target endpoint",
  "{0} 预览": "{0} preview",
  "目标预览：{0} / {1} · {2} {3}{4}{5}": "Target preview: {0} / {1} · {2} {3}{4}{5}",
  "作者 HTML / 消息预览": "Author HTML / message preview",
  " · 代次 ": " · Generation ",
  "此连接不支持组件渲染": "This connection does not support component rendering",
  "加载中": "Loading",
  "无法预览：": "Cannot preview: ",
  "重试预览": "Retry preview",
  "按目标 Endpoint 预览": "Preview for a target endpoint",
  "不会发送消息或注册按钮回调；不运行出站中间件。实际发送记录是最终诊断依据。": "No messages are sent, button callbacks registered or outbound middleware executed. Actual send records remain the final diagnostic evidence.",
  "加载 Endpoint": "Load endpoints",
  "目标会话 ID": "Target conversation ID",
  "父级（可选）": "Parent (optional)",
  "无": "None",
  "频道 / 服务器": "Channel / server",
  "父级 ID": "Parent ID",
  "父级 ID（填写父级类型时必填）": "Parent ID (required when a parent type is selected)",
  "线程 ID": "Thread ID",
  "线程 ID（可选）": "Thread ID (optional)",
  "作者预览": "Author preview",
  "组件未渲染内容": "Component rendered no content",
  "数组": "Array",
  "对象": "Object",
  "复制失败，请展开 JSON 原文后手动复制。": "Copy failed. Expand the raw JSON and copy it manually.",
  "JSON 数据": "JSON data",
  "已复制": "Copied",
  "复制 JSON": "Copy JSON",
  "查看 JSON 原文": "View raw JSON",
  "运行时能力": "Runtime capabilities",
  "Agent 绑定仅表示配置关系，不代表已启用。": "Agent bindings represent configuration relationships only, not enablement.",
  "请结合连接状态判断服务是否可用。": "Check connection status to determine service availability.",
  "运行时能力分类": "Runtime capability categories",
  "筛选名称、来源或描述…": "Filter by name, source or description…",
  "筛选{0}": "Filter {0}",
  "筛选": "Filter",
  "共 {0} 条 · 第 {1}/{2} 页": "{0} records · Page {1}/{2}",
  "技术信息": "Technical information",
  "Zhin.js 控制台": "Zhin.js Console",
  "配置 Remote Console：API 地址与 Bearer Token": "Connect Remote Console using an API address and Bearer token",
  "已保存的连接": "Saved connections",
  "选择 Host 快速填入…": "Choose a Host to fill in…",
  "删除此保存": "Delete saved connection",
  "API Base URL（如 http://127.0.0.1:8086）": "API Base URL (for example http://127.0.0.1:8086)",
  "API Token（须手动输入，勿通过 URL 传递）": "API token (enter manually; never pass it in the URL)",
  "保存登录信息，下次可快速选择": "Save login details for quick selection next time",
  "验证中...": "Verifying…",
  "快速连接": "Quick connect",
  "连接": "Connect",
  "填写 Bot 启动日志中的 Host 地址。使用本地地址时，请确保 Host 的 corsOrigins 允许当前 Console 来源。": "Enter the Host address from your bot's startup logs. For a local address, ensure the Host's corsOrigins allows this Console origin.",
  "日志诊断工作台": "Log diagnostics workspace",
  "总日志": "Total logs",
  "搜索日志消息或来源": "Search log messages or sources",
  "搜索消息、来源…": "Search messages or sources…",
  "日志级别": "Log level",
  "所有级别": "All levels",
  "跟随最新": "Follow latest",
  "来源：{0}": "Source: {0}",
  "来源筛选": "Filter by source",
  "日志维护操作": "Log maintenance actions",
  "维护": "Maintenance",
  "日志维护": "Log maintenance",
  "清理 7 天前的日志": "Delete logs older than 7 days",
  "仅保留最近 5000 条": "Keep only the latest 5,000 records",
  "清空全部日志": "Clear all logs",
  "来源聚合": "Sources",
  "全部历史来源（按级别与搜索筛选）": "All historical sources (filtered by level and search)",
  "全部来源": "All sources",
  "当前来源：": "Current source: ",
  " · 清除": " · Clear",
  "未标注来源": "Source not recorded",
  "历史事件": "Historical events",
  "本页 ": "This page: ",
  " 条": " records",
  "正在读取日志历史…": "Reading log history…",
  "当前筛选没有日志": "No logs match the current filter",
  "日志到达后会自动出现在此处。": "New logs will appear here automatically.",
  "日志历史分页": "Log history pagination",
  "第 {0} / {1} 页 · 筛选结果 {2} 条": "Page {0} / {1} · {2} matching records",
  "分页总数暂时未知": "Total page count is currently unknown",
  "每页日志条数": "Logs per page",
  "每页 ": "Per page: ",
  "事件 Inspector": "Event inspector",
  "选择一条事件": "Select an event",
  "完整时间、来源与诊断动作会显示在这里。": "The full timestamp, source and diagnostic actions will appear here.",
  "事件详情": "Event details",
  "关闭事件详情": "Close event details",
  "所选事件不在当前页或当前筛选中；下方保留该事件快照。": "The selected event is outside the current page or filter. Its snapshot is retained below.",
  "技术字段": "Technical fields",
  "复制事件": "Copy event",
  "仅看此来源": "Filter to this source",
  "在能力目录中搜索来源名称": "Search this source in the capability directory",
  "浏览器拒绝了剪贴板访问，请展开原始事件后手动复制。": "The browser denied clipboard access. Expand the raw event and copy it manually.",
  "原始事件": "Raw event",
  "当前 Host 不支持日志历史分页。请更新 Host 后重试；旧版仅支持最近日志的接口不能提供完整历史。": "The current Host does not support paginated log history. Update the Host and retry. The older recent-logs endpoint cannot provide complete history.",
  "日志": "Logs",
  "日志统计暂时不可读 (HTTP {0})": "Log statistics are temporarily unreadable (HTTP {0})",
  "日志统计响应无效": "Invalid log statistics response",
  "日志统计": "Log statistics",
  "清空失败": "Could not clear logs",
  "日志已清空": "Logs cleared",
  "清理失败": "Cleanup failed",
  "成功清理 {0} 条日志": "Deleted {0} log records",
  "实时查看与筛选系统运行日志（Demo 只读）。": "View and filter runtime logs in real time (read-only in demo).",
  "查看历史与实时日志，定位运行异常。": "Inspect historical and live logs to diagnose runtime issues.",
  "此操作不可撤销，确定要清空全部日志吗？": "Clear all logs? This cannot be undone.",
  "清空": "Clear",
  "清理旧日志": "Delete old logs",
  "确定清理 {0} 天前的日志吗？匹配的日志会永久删除，操作不可撤销。": "Delete logs older than {0} days? Matching logs will be permanently removed. This cannot be undone.",
  "确定只保留最近 {0} 条日志吗？其余日志会永久删除，操作不可撤销。": "Keep only the latest {0} log records? All others will be permanently removed. This cannot be undone.",
  "清理": "Delete",
  "连接身份已变化，请在原 Host 核对；不会向新连接继续操作。": "The connection identity changed. Verify with the original Host; this operation will not continue on the new connection.",
  "搜索失败": "Search failed",
  "数据格式错误": "Invalid data format",
  "加载插件详情失败": "Could not load plugin details",
  "注册表返回的包身份或 latest 版本无效": "The registry returned an invalid package identity or latest version",
  "无法读取 Host 用途目录，未自动选择任何插件。": "Could not read the Host use-case directory. No plugin was selected automatically.",
  "安装计划返回了不同包，请重新核验": "The installation plan returned a different package. Verify it again.",
  "安装已提交，结果正在核对；请勿重复安装。": "Installation was submitted and its result is being checked. Do not install again.",
  "安装步骤已完成。请按当前状态完善配置、申请应用并选择业务检查；尚未证明功能可用。": "Installation steps completed. Follow the current status to configure, request application and choose a business check. The feature is not yet proven usable.",
  "复制失败，请选中安装命令手动复制。": "Copy failed. Select and copy the installation command manually.",
  "群欢迎用途 · Host 指定包 {0}。这里只打开详情；请自行审阅版本与原安装计划，尚未执行安装。": "Group-welcome use case · Host-selected package {0}. This only opens details; review its version and installation plan yourself. Nothing has been installed.",
  "正在读取 Host 的群欢迎用途；不会按 URL 包名猜测插件。": "Reading the Host's group-welcome use case. The plugin will not be guessed from the package name in the URL.",
  "返回群欢迎流程并选择实例": "Return to group-welcome setup and choose an instance",
  "插件市场": "Plugin store",
  "探索 Zhin.js 生态中的插件。列表为发现索引，打开详情后核验注册表 latest。": "Explore the Zhin.js plugin ecosystem. The list is a discovery index; opening details verifies the registry's latest version.",
  "检查更新": "Check for updates",
  "有 ": "There are ",
  " 个插件的本地版本与注册表 latest 不同：": " plugins whose local versions differ from the registry's latest: ",
  " 更多": " more",
  "搜索插件名称、描述...": "Search plugin names or descriptions…",
  "仅 @zhin.js": "Only @zhin.js",
  " 个插件": " plugins",
  "，第 {0}/{1} 页": ", page {0}/{1}",
  "包属于 @zhin.js 命名空间，不表示安全审计或兼容性保证": "The @zhin.js namespace does not guarantee a security audit or compatibility",
  "索引": "Index",
  "暂无描述": "No description",
  "/月": "/month",
  "未找到插件": "No plugins found",
  "界面语言": "Interface language",
  "简体中文": "Simplified Chinese",
  "English": "English",
  "确认 Host 已启动、API Base 与 corsOrigins 一致。": "Check that the Host is running and API Base matches corsOrigins.",
  "搜索结果": "Search results",
  "最近访问": "Recently visited",
  "数字": "Number",
  "整数": "Integer",
  "开关": "Toggle",
  "键值表": "Dictionary",
  "列表": "List",
  "固定列表": "Tuple",
  "空值": "Null",
  "JSON 值": "JSON value",
  "Host 未提供完整保存回执，请刷新核对；不要自动重试。": "The Host did not return a complete save receipt. Refresh to verify; do not retry automatically.",
  "配置已保存；Host 配置变化需要重启进程，尚未确认生效。": "Configuration saved. Host changes require a process restart; application is not yet confirmed.",
  "配置已保存；当前运行是否一致须另行核对。": "Configuration saved. Verify the running configuration separately.",
  "配置已保存；Host 未提供重启判断，请另行核对运行证据。": "Configuration saved. The Host did not report whether a restart is needed; check runtime evidence.",
  "应用申请缺少可核对的版本证据": "The apply request has no verifiable version evidence.",
  "无法保留待确认申请，请恢复浏览器会话存储后再申请": "The pending request could not be retained. Restore browser session storage before applying.",
  "Host 返回的字段解释格式或版本不正确；请刷新已保存配置后重新读取。": "The field explanation format or version is invalid. Refresh the saved configuration and read it again.",
  "字段解释不属于当前已保存版本；请刷新配置并重新读取，草稿不会被覆盖。": "The explanation belongs to another saved version. Refresh and read it again; your draft will be preserved.",
  "暂时无法读取字段解释。请核对当前 Host 的 full 权限和版本，或刷新配置后重试；这不表示配置保存或应用失败。": "Field explanations are temporarily unavailable. Check full permissions and the Host version, or refresh and retry. This does not indicate a save or apply failure.",
  "目标尚不是完整对象，请填写目标并交由 Host 校验。": "The target is not a complete object yet. Fill it in and let the Host validate it.",
  "请选择此字段允许的会话类型。": "Choose a conversation type allowed by this field.",
  "父容器类型和 ID 必须同时填写；没有父容器时请明确移除。": "Parent type and ID must be provided together. Explicitly remove the parent if there is none.",
  "话题 ID 不能为空；没有话题时请明确移除。": "Thread ID cannot be empty. Explicitly remove it if there is no thread.",
  "目标身份不完整，以 Host 校验为准。": "Target identity is incomplete; Host validation is authoritative.",
  "请输入数字": "Enter a number",
  "请输入有效数字": "Enter a valid number",
  "须为整数": "Must be an integer",
  "不能小于 {0}": "Must be at least {0}",
  "不能大于 {0}": "Must be at most {0}",
  "{0}：Host 未提供可编辑的字段定义": "{0}: the Host did not provide an editable field definition",
  "{0}：{1} 需要源码编辑": "{0}: {1} requires source editing",
  "{0}：对象字段尚未由 Host 投影": "{0}: object fields have not been projected by the Host",
  "{0}：列表缺少元素定义": "{0}: list item definition is missing",
  "配置未通过 Host 校验，请根据字段提示修改。": "Host validation failed. Update the highlighted fields.",
  "字段格式已通过校验，但环境变量尚未配置，不能完成最小配置。": "Field validation passed, but required environment variables are not configured.",
  "Host 校验通过，可以保存配置。": "Host validation passed. You can save the configuration.",
  "配置源码必须是键值对象": "Configuration source must be a key-value object",
  "Host 未提供配置路径，请刷新或打开完整源码": "The Host did not provide a configuration path. Refresh or open the complete source.",
  "Host 配置路径无效，请刷新或打开完整源码": "The Host configuration path is invalid. Refresh or open the complete source.",
  "配置父节点不是对象，请打开完整源码确认结构": "The parent configuration node is not an object. Open the complete source to inspect its structure.",
  "字段定义读取失败": "Failed to read field definitions",
  "Host 未提供此插件的正式配置路径，请刷新或打开完整源码；表单不会猜测保存位置。": "The Host did not provide this plugin's configuration path. Refresh or open the complete source; the form will not guess where to save.",
  "配置读取失败": "Failed to read configuration",
  "配置快照不属于当前连接，请刷新后重试": "This configuration snapshot belongs to another connection. Refresh and retry.",
  "草稿属于旧连接，请重新读取当前 Host 配置": "The draft belongs to an old connection. Read the current Host configuration again.",
  "Host 配置路径未知，请刷新后重试": "The Host configuration path is unknown. Refresh and retry.",
  "连接身份已变化，请在当前 Host 重新读取配置": "The connection identity changed. Read configuration from the current Host again.",
  "配置读取已过期，请在当前 Host 重新读取": "This configuration read has expired. Read it from the current Host again.",
  "读取失败": "Read failed",
  "配置版本未知，请先刷新": "The configuration version is unknown. Refresh first.",
  "配置属于旧连接，请在当前 Host 重新读取后保存": "This configuration belongs to an old connection. Read the current Host configuration before saving.",
  "保存结果属于旧连接或已被替代，请到原 Host 核实；当前页面不会重试": "The save result belongs to an old connection or was superseded. Verify on the original Host; this page will not retry.",
  "Host 未确认配置保存成功": "The Host did not confirm a successful save.",
  "配置版本未知，请先在当前 Host 刷新": "The configuration version is unknown. Refresh from the current Host first.",
  "其他": "Other",
  "无法读取 {0}": "Unable to read {0}",
  "群聊插话状态格式不正确。": "Invalid group participation status.",
  "群聊插话记录格式不正确。": "Invalid group participation record.",
  "只观察": "Observe only",
  "主动参与": "Participate proactively",
  "还没有选群": "No groups selected",
  "{0} 个群": "{0} groups",
  "接了话": "Joined the conversation",
  "想接话但没开口": "Would have joined, but stayed silent",
  "决定不接话": "Chose to stay silent",
  "没有判断": "No assessment",
  "请至少填一个群，或者选择「所有群」。": "Enter at least one group, or choose All groups.",
  "群的写法是「平台:群号」，例如 qq:123456。这些需要改一下：{0}": "Use platform:group-id, such as qq:123456. Update these entries: {0}",
  "每小时最多插话次数要在 1 到 {0} 之间。": "The hourly participation limit must be between 1 and {0}.",
  "保存结果格式不正确，请刷新后再看一下设置是否已保存。": "Invalid save response. Refresh to check whether the settings were saved.",
  "设置刚刚在别处被改过。已经载入最新的设置，请确认后再保存一次。": "Settings were changed elsewhere. The latest settings are loaded; review and save again.",
  "这些设置没有通过检查，没有保存。请检查后再试。": "Validation failed. Settings were not saved. Review and retry.",
  "保存失败，请稍后再试。": "Save failed. Try again later.",
  "助手任务响应格式不正确。": "Invalid assistant task response.",
  "助手任务字段格式不正确。": "Invalid assistant task fields.",
  "配置版本未知，请先读取配置后编辑": "The configuration version is unknown. Read it before editing.",
  "草稿版本未知，请撤销并重新读取配置": "The draft version is unknown. Discard it and read the configuration again.",
  "{0} 格式有误，请检查括号、引号和缩进。": "Invalid {0} format. Check brackets, quotes and indentation.",
  "配置须为键值对象，不能是空内容、数组或单个值。": "Configuration must be a key-value object, not empty content, an array or a scalar.",
  "请检查表达式。": "Check the expression.",
  "需要 6 个字段（秒 分 时 日 月 周），当前为 {0} 个。": "Expected 6 fields (second minute hour day month weekday); received {0}.",
  "字段没有有效取值，请检查范围": "The field has no valid values. Check its range.",
  "字段格式无效": "Invalid field format",
  "步长无效": "Invalid step",
  "范围格式无效": "Invalid range format",
  "字段取值无效": "Invalid field value",
  "{0} 天 {1} 小时": "{0} d {1} h",
  "{0} 小时 {1} 分钟": "{0} h {1} min",
  "{0} 分钟": "{0} min",
  "此文档缺少有效 _id，无法安全编辑或删除。": "This document has no valid _id and cannot be safely edited or deleted.",
  "文档必须是 JSON 对象。": "The document must be a JSON object.",
  "该 Key 已存在，请通过编辑修改它。": "This key already exists. Use Edit to modify it.",
  "数组 · {0} 项": "Array · {0} items",
  "对象 · {0} 个字段": "Object · {0} fields",
  "无其他字段": "No other fields",
  "另 {0} 个字段": "{0} more fields",
  "数据表未声明主键，无法安全定位记录。": "The table has no declared primary key; the record cannot be safely identified.",
  "记录缺少主键，无法安全定位。": "The record has no primary key and cannot be safely identified.",
  "此字段不能为 null。": "This field cannot be null.",
  "请输入安全范围内的整数。": "Enter an integer within the safe range.",
  "请输入有效数字。": "Enter a valid number.",
  "请输入 true、false、0 或 1。": "Enter true, false, 0 or 1.",
  "请输入有效的 JSON。": "Enter valid JSON.",
  "请输入有效日期，如 2026-10-08 或 ISO 日期时间。": "Enter a valid date, such as 2026-10-08 or an ISO date-time.",
  "主键或唯一字段已存在，请修改后重试。": "The primary key or a unique field already exists. Update it and retry.",
  "保存失败，当前输入已保留。请检查详情后重试。": "Save failed. Your input is preserved. Check the details before retrying.",
  "我": "Me",
  "[空消息]": "[Empty message]",
  "[表情]": "[Emoji]",
  "[文件] {0}": "[File] {0}",
  "[引用] {0}": "[Reply] {0}",
  "[转发消息]": "[Forwarded messages]",
  "群聊 {0}": "Group {0}",
  "频道 {0}": "Channel {0}",
  "部分会话未能读取，当前显示已获取的会话。": "Some conversations could not be loaded. Showing those already retrieved.",
  "会话列表读取失败，请重试。": "Failed to read conversations. Try again.",
  "渠道离线，暂未获取到会话。": "The endpoint is offline. Conversations are unavailable.",
  "暂无会话。": "No conversations.",
  "尚未获取到会话。": "Conversations have not been retrieved yet.",
  "当前显示历史会话。": "Showing conversation history.",
  "昨天": "Yesterday",
  "Host 未提供当前 Endpoint 的完整标识": "The Host did not provide the current Endpoint's complete identity.",
  "历史记录响应格式不正确。": "Invalid history response.",
  "历史记录可用状态不一致。": "Inconsistent history availability.",
  "历史记录信息格式不正确。": "Invalid history information.",
  "请求历史信息格式不正确。": "Invalid request history.",
  "通知历史信息格式不正确。": "Invalid notice history.",
  "消息历史信息格式不正确。": "Invalid message history.",
  "消息历史方向格式不正确。": "Invalid message direction in history.",
  "消息历史会话标识格式不正确。": "Invalid conversation identity in message history.",
  "群主": "Owner",
  "仅支持方向明确的入站消息；历史方向未知时无法查询。": "Only messages confirmed as inbound are supported. History with an unknown direction cannot be queried.",
  "该消息没有 Host 提供的完整会话身份，无法精确查询。请等待新的入站消息。": "This message has no complete Host-provided conversation identity. Wait for a new inbound message.",
  "该消息缺少平台消息 ID，无法精确查询；不会使用正文或本地记录 ID 猜测。": "This message has no platform message ID. Its content or local record ID will not be used to guess the identity.",
  "请选择明确的会话。": "Select a specific conversation.",
  "父容器身份无效，无法精确查询。": "Invalid parent identity; an exact query is unavailable.",
  "尚未获得 Host 提供的完整 Endpoint 和会话身份，无法查询。": "The Host has not provided a complete Endpoint and conversation identity.",
  "缺少精确消息身份": "Exact message identity is missing",
  "指令准入诊断格式无效。": "Invalid command admission diagnostics.",
  "消息诊断响应格式无效，请刷新或更新 Host。": "Invalid message diagnostics response. Refresh or update the Host.",
  "消息诊断身份或字段无效，未展示可能属于其他会话的记录。": "Invalid diagnostic identity or fields. Records that may belong to another conversation were not displayed.",
  "诊断步骤格式无效。": "Invalid diagnostic step.",
  "投递诊断格式无效。": "Invalid delivery diagnostics.",
  "未识别的状态": "Unrecognized status",
  "消息已交给 Agent；请在 Agent 运行记录查看后续工具、审批和回复。这里不代表 Agent 已完成。": "The message was handed to the Agent. Check Agent runs for subsequent tools, approvals and replies. This does not mean the Agent has finished.",
  "入站处理仍在进行，可稍后手动刷新；不会重放消息。": "Inbound processing is still running. Refresh manually later; the message will not be replayed.",
  "本次指令处于冷却期；记录产生时剩余约 {0} 秒。不会自动重放。": "The command was on cooldown, with approximately {0} seconds remaining when recorded. It will not be replayed automatically.",
  "本次指令处于冷却期；请等待冷却结束后再决定是否执行。不会自动重放。": "The command is on cooldown. Wait before deciding to run it again; it will not be replayed automatically.",
  "同一指令、发送者和完整会话已有执行占用并发额度；完成时间未知。请查看原执行，不要连续重复触发。": "An execution for this command, sender and exact conversation already occupies the concurrency limit. Check the original execution instead of repeatedly triggering it.",
  "当前指令准入容量已满；本次未进入指令业务执行，请结合 Host 状态排查。不会自动重放。": "Command admission capacity is full. This request did not enter business execution. Check Host status; it will not be replayed automatically.",
  "本次缺少可信的完整会话或发送者身份，无法应用指令准入策略；请检查适配器入站身份，不要伪造身份补齐。": "Trusted conversation or sender identity is incomplete. Check adapter inbound identity; do not invent identity fields to bypass admission.",
  "本次未获得有效的指令执行上下文或准入服务；请核对当前运行代与 Host 状态。不会自动重放。": "No valid execution context or admission service was available. Check the current generation and Host status. No automatic replay will occur.",
  "请检查该指令的权限规则与发送者在目标会话中的真实角色。": "Check this command's permission rules and the sender's actual roles in the target conversation.",
  "请查看该指令的帮助，核对参数和输入格式。": "Check the command help, parameters and input format.",
  "请核对本账号的指令前缀；前缀未匹配也可能继续走普通聊天链路。": "Check the command prefix for this account. A prefix mismatch may still continue through ordinary chat processing.",
  "入站中间件执行失败，请检查对应插件与 Host 日志；诊断不记录消息正文和原始异常。": "Inbound middleware failed. Check the plugin and Host logs; diagnostics contain no message body or raw exception.",
  "中间件链尚未结束，异常也可能来自下游处理；请结合此时刻的 Host 日志定位对应插件。": "The middleware chain has not completed; a downstream handler may have failed. Check Host logs at this timestamp.",
  "消息事件处理器尚未结束，请检查相应 handler 插件和 Host 日志。": "Message event handlers have not completed. Check the relevant handler plugin and Host logs.",
  "出站中间件执行失败，请检查审核或改写插件的日志与配置。": "Outbound middleware failed. Check logs and configuration for moderation or rewriting plugins.",
  "投递结果不确定，请先到实际目标会话核实，避免重复发送。本面板不会自动重试。": "Delivery is uncertain. Verify in the actual conversation before sending again. This panel will not retry automatically.",
  "有投递未被平台受理，请检查实际目标、Endpoint 连接与目标支持的消息能力。": "Some deliveries were not accepted by the platform. Check the target, Endpoint connection and supported message capabilities.",
  "入站处理失败，请结合此时刻的 Host 日志检查插件；不要直接重发可能产生副作用的操作。": "Inbound processing failed. Check plugin logs at this timestamp; do not resend operations that may have side effects.",
  "此记录没有关联投递；链路可能未产生回复，或后续工作在独立任务中继续。": "No delivery is associated with this record. The chain may not have produced a reply, or further work may run in a separate task.",
  "待处理请求响应格式不正确。": "Invalid pending request response.",
  "待处理请求信息格式不正确。": "Invalid pending request information.",
  "渲染诊断格式无效": "Invalid rendering diagnostics",
  "加载群成员失败": "Failed to load group members",
  "群管理操作失败": "Group management operation failed",
  "发送到 {0} 失败": "Failed to send to {0}",
  "渠道列表响应格式不正确。": "Invalid endpoint list response.",
  "渠道信息响应格式不正确。": "Invalid endpoint information response.",
  "渠道待办数量响应格式不正确。": "Invalid endpoint pending-count response.",
  "未命名能力": "Unnamed capability",
  "是": "Yes",
  "否": "No",
  "没有匹配“{0}”的{1}": "No {1} match “{0}”",
  "当前筛选没有匹配项；清除筛选后查看已注册的能力。": "No items match the current filter. Clear it to see registered capabilities.",
  "当前页没有能力条目": "No capabilities on this page",
  "能力目录仍有记录，请返回上一页或刷新列表。": "The catalog still contains records. Return to the previous page or refresh.",
  "当前 generation 没有{0}": "No {0} in the current generation",
  "这里展示 Runtime 已实际注册的能力；配置存在但尚未发布的内容不会出现。": "Only capabilities actually registered in the Runtime appear here. Unpublished configuration does not appear.",
  "目标 Endpoint 列表格式无效": "Invalid target Endpoint list",
  "请选择 Host 提供的 Endpoint 标识": "Select an Endpoint identity provided by the Host",
  "请选择会话类型并填写会话 ID": "Select a conversation type and enter its ID",
  "父级类型和 ID 必须同时填写": "Parent type and ID must be provided together",
  "父级类型无效": "Invalid parent type",
  "组件预览响应格式无效": "Invalid component preview response",
  "Host 未返回目标渲染诊断": "The Host did not return target rendering diagnostics",
  "Host 不支持日志历史分页": "The Host does not support paginated log history",
  "日志历史分页响应无效": "Invalid log history page response",
  "日志数据源暂不可用：{0}": "Log source temporarily unavailable: {0}",
  "安装状态已变化，不能沿用补全计划，请重新核对": "Installation state changed. Read the current state before creating a new completion plan.",
  "补全计划的包或实例身份已变化": "The completion plan's package or instance identity changed.",
  "已核对：{0} 普通依赖已安装，不包含 Plugin 契约，不会挂载到 Runtime；无需重复安装。": "Verified: {0} is installed as an ordinary dependency without a Plugin contract. It will not mount in the Runtime; no reinstall is needed.",
  "已核对：{0} 包可解析且实例声明已保存。应用与业务功能请在插件详情核对；无需重复安装。": "Verified: {0} resolves and its instance declaration is saved. Check application and business behavior in plugin details; no reinstall is needed.",
  "安装提交结果仍未确认。当前包版本 {0}，目标 {1}；实例{2}。旧安装计划已失效，请核对日志，勿重复提交。": "The installation result is still unconfirmed. Current version: {0}; target: {1}; instance: {2}. The old plan has expired. Check logs; do not resubmit.",
  "安装提交结果未知，当前无法读取 Host 安装状态。旧安装计划已失效；恢复连接后请重新核对，勿重复提交。": "Installation outcome is unknown and Host state cannot currently be read. The old plan has expired. Reconnect and verify before resubmitting.",
  "权限说明响应无效，请刷新目录或更新 Host。": "Invalid permission explanation response. Refresh the catalog or update the Host.",
  "请先从当前运行代目录选择命令。": "Select a command from the current generation's catalog first.",
  "请填写完整的假设账号与会话身份。": "Enter complete hypothetical account and conversation identities.",
  "假设身份过长，请精简后重试。": "The hypothetical identity is too long. Shorten it and retry.",
  "填写假设角色时，请同时提供发送者 ID。": "Provide a sender ID when specifying hypothetical roles.",
  "条件符合": "Condition met",
  "条件不符": "Condition not met",
  "缺少依据": "Insufficient evidence",
  "未评估": "Not evaluated",
  "未识别": "Unrecognized",
  "当前 Host 尚不支持权限说明，或命令已移除；请更新 Host 并刷新目录。": "This Host does not support permission explanations, or the command was removed. Update the Host and refresh the catalog.",
  "运行代已变化，请刷新命令目录并重新检查。": "The generation changed. Refresh the command catalog and check again.",
  "需要当前 Host 有效的 full scope Token，不能使用演示权限。": "A valid full-scope Token for this Host is required; demo access is insufficient.",
  "假设身份或会话格式不完整，请检查填写内容。": "The hypothetical identity or conversation is incomplete. Check the input.",
  "权限说明读取失败，请检查 Host 后重试。": "Failed to read permission explanations. Check the Host and retry.",
  "插件详情响应格式不正确": "Invalid plugin detail response",
  "插件能力响应格式不正确": "Invalid plugin capability response",
  "插件能力摘要格式不正确": "Invalid plugin capability summary",
  "版本查询响应格式不正确。": "Invalid version query response.",
  "未获取到此插件的版本信息，请稍后重试。": "Version information is unavailable for this plugin. Try again later.",
  "插件列表格式无效": "Invalid plugin list",
  "插件信息格式无效": "Invalid plugin information",
  "插件能力格式无效": "Invalid plugin capabilities",
  "插件状态证据格式或实例身份不正确": "Invalid plugin state evidence or instance identity",
  "状态未确认": "State not confirmed",
  "验证计划已变化，请刷新当前状态和验证计划": "The verification plan changed. Refresh the current state and plan.",
  "业务检查描述不完整": "Incomplete business-check description",
  "未知业务检查": "Unknown business check",
  "业务验证结果未确认，请核对日志；勿自动重复执行": "Business verification is unconfirmed. Check logs; do not execute it again automatically.",
  "尚未执行业务检查": "Business check has not run",
  "检查执行后当前代已变化，此结果不能证明当前插件可用": "The generation changed after the check. This result cannot establish current plugin availability.",
  "当前插件未配置该业务检查": "This business check is not configured for the current plugin",
  "业务检查未通过": "Business check failed",
  "本地业务检查通过；尚未验证平台投递": "Local business check passed; platform delivery is unverified",
  "所选平台业务检查通过": "Business check for the selected platform passed",
  "操作计划缺少项目版本，请重新读取计划后确认": "The operation plan has no project revision. Read it again before confirming.",
  "安装请求与批准的包身份不一致": "The installation request does not match the approved package identity",
  "插件未满足应用条件，请先完善配置或处理依赖问题": "The plugin is not ready to apply. Complete configuration or resolve dependencies first.",
  "{0}必须是非空文本，且不超过 {1} 字符": "{0} must be nonempty text of at most {1} characters",
  "{0}格式无效或包含不支持的字段": "{0} is invalid or contains unsupported fields",
  "场景过大或嵌套超过上限": "The scenario is too large or too deeply nested",
  "场景仅支持有限数字": "Only finite numbers are supported in scenarios",
  "单项文本超过 32000 字符": "A text value exceeds 32,000 characters",
  "场景仅支持 JSON，不支持函数、组件、流或对象实例": "Scenarios support JSON only, not functions, components, streams or object instances",
  "场景包含不安全的对象键": "The scenario contains unsafe object keys",
  "场景超过 96KB 字符上限": "The scenario exceeds the 96 KB character limit",
  "来源会话": "Source conversation",
  "完整账号身份": "Complete account identity",
  "适配器标识": "Adapter identity",
  "会话类型必须为 private、group 或 channel": "Conversation type must be private, group or channel",
  "父容器类型无效": "Invalid parent container type",
  "预期输出须为最多 64 项的原生 Segment 数组": "Expected output must be an array of at most 64 native Segments",
  "消息段": "Message segment",
  "仅支持原生 JSON 消息段；不支持组件调用、raw、JSX 源码或函数": "Only native JSON segments are supported, not component calls, raw payloads, JSX source or functions",
  "text 段须有 data.text": "A text segment requires data.text",
  "html 段须有 data.html": "An html segment requires data.html",
  "markdown 段须有 data.content 或 data.text": "A markdown segment requires data.content or data.text",
  "场景": "Scenario",
  "不支持的场景版本": "Unsupported scenario version",
  "发送者": "Sender",
  "发送者名称须为文本": "Sender name must be text",
  "角色须为最多 32 项的非空文本数组；不填与 [] 含义不同": "Roles must be an array of at most 32 nonempty strings; omission and [] have different meanings",
  "未来入站文本须不超过 16000 字符": "Future inbound text must not exceed 16,000 characters",
  "请选择明确的测试能力配置": "Select an explicit test capability profile",
  "测试项目配置": "Test project configuration",
  "合成账号别名须为小写英文、数字或连字符，以字母开头": "The synthetic account alias must start with a lowercase letter and contain only lowercase letters, digits or hyphens",
  "须明确提供 configVersion: 2 的独立测试配置": "Explicitly provide an isolated test configuration with configVersion: 2",
  "回归断言": "Regression assertions",
  "须明确选择预期派发状态": "Explicitly select the expected dispatch status",
  "须明确提供最终 payload 数组；[] 明确断言没有投递，最多 32 条": "Explicitly provide the final payload array, up to 32 entries. [] asserts that no delivery occurs.",
  "场景 JSON 超过上限": "Scenario JSON exceeds the size limit",
  "场景 JSON 无效": "Invalid scenario JSON",
  "明确独立测试配置与来源账号到合成账号的映射": "Specify isolated test configuration and the source-to-synthetic account mapping",
  "明确派发状态及最终 payload 断言（不是浏览器预览推断）": "Specify dispatch status and final payload assertions independently of browser preview",
  "填写用于真实 receive 的入站文本": "Enter inbound text for a real receive call",
  "暂不能导出可执行回归：{0}": "Executable regression export is unavailable: {0}",
  "# {0}\n\n此文件由 Console 生成，尚未证明你的插件通过测试。scenario.json 中的 preview 是作者预期外观；assertions 是作者单独填写的最终派发/投递断言。\n\n## 显式运行\n\n准备独立、可信的测试项目及它实际需要的依赖和插件，安装开发依赖 @zhin.js/testing、@zhin.js/plugin-runtime、@zhin.js/adapter 与 tsx；导出不会自动安装或运行。将这三个文件放进该测试项目中，再执行：\n\nZHIN_SCENARIO_FIXTURE_ROOT=/absolute/path/to/test-app node --conditions=development --import tsx --test scenario.test.mjs\n\n必须显式提供绝对路径，无 cwd 或生产配置回退。测试配置来自 scenario.fixture.config，账号 {1} 显式映射为合成别名 {2}；kind/id/parent/thread 和发送者完整保留。首版断言所有最终投递均指向该原会话的合成账号映射，跨会话主动发送应另写测试。\n\nPluginTestKit 运行真实模块 import/setup/指令/中间件并记录合成端点最终载荷；它不是安全沙箱。独立数据目录与无凭据配置不能阻止代码访问宿主文件或联网。只运行可信 fixture，勿挂载真实适配器、生产配置、数据库或凭据；不要在生产 Host 运行此文件。limited 断言需要支持该准入状态的 Runtime。角色是测试假设，非平台权限证明；HTML direct/native 仅表示测试能力，不证明真实平台外观或投递。\n\n## 证据边界\n\n导出 ≠ 执行通过；合成端点 Runtime 回归 ≠ 浏览器截图 ≠ 真实平台发送。检查失败时核对明确断言，不要自动重放生产消息。\n": "# {0}\n\nGenerated by Console. This file does not establish that your plugin passes tests. preview in scenario.json is the author's intended appearance; assertions separately defines the expected dispatch and delivery results.\n\n## Run explicitly\n\nPrepare an isolated, trusted test project with its actual dependencies and plugins. Install development dependencies @zhin.js/testing, @zhin.js/plugin-runtime, @zhin.js/adapter and tsx. Export does not install or run anything. Place the three files in that project and run:\n\nZHIN_SCENARIO_FIXTURE_ROOT=/absolute/path/to/test-app node --conditions=development --import tsx --test scenario.test.mjs\n\nAn absolute path is required; there is no cwd or production-configuration fallback. Configuration comes from scenario.fixture.config. Account {1} maps explicitly to synthetic alias {2}; kind/id/parent/thread and sender identity are preserved. This version asserts that every final delivery targets the synthetic mapping of the original conversation. Write separate tests for proactive sends to other conversations.\n\nPluginTestKit imports real modules and runs setup, commands and middleware while recording final synthetic-endpoint payloads. It is not a security sandbox. Isolated data directories and credential-free configuration do not prevent host filesystem or network access. Run trusted fixtures only. Do not mount real adapters, production configuration, databases or credentials; do not run this file in a production Host. A limited assertion requires Runtime admission support. Roles are test assumptions, not evidence of platform permissions. HTML direct/native capabilities do not prove actual platform appearance or delivery.\n\n## Evidence boundary\n\nExport does not mean execution passed. Synthetic-endpoint Runtime regression, browser screenshots and actual platform sends are separate evidence. Check explicit assertions on failure; never automatically replay production messages.\n",
  "测试能力配置无效": "Invalid test capability profile",
  "提及用户": "Mention user",
  "链接（仅文本，不打开）": "Link (text only, not opened)",
  "表情：{0}": "Emoji: {0}",
  "Markdown 可读预览；该测试端点的最终文本需回归断言核对": "Readable Markdown preview; verify final endpoint text with regression assertions",
  "Markdown 子集预览（不等于平台原生外观）": "Markdown subset preview (not the platform's native appearance)",
  "HTML：此测试端点要求降为文本；此处不运行 Host 转换": "HTML: this test endpoint requires text fallback; Host conversion does not run here",
  "HTML 源文（未调用 Shotium / 组件渲染）": "HTML source (no Shotium or component rendering)",
  "按钮文本占位；最终编号/回调不在预览中生成": "Button text placeholder; final numbering and callbacks are not generated in preview",
  "按钮展示，不注册交互": "Button display only; no interaction is registered",
  "按钮": "Button",
  "交互已禁用": "Interaction disabled",
  "{0} 消息段": "{0} segment",
  "安全占位：不读取本地媒体、不请求远程资源、不执行操作": "Safe placeholder: no local media access, remote resource requests or operations",
  "Markdown 超过 32000 字符": "Markdown exceeds 32,000 characters",
  "代码围栏未闭合，按源码展示": "Unclosed code fence; showing source",
  "超出支持子集，安全源码展示；不加载 HTML 或媒体": "Outside the supported subset; showing safe source without loading HTML or media",
  "{0} JSON 无效，请补全后再导出。": "Invalid {0} JSON. Complete it before exporting.",
  "任务快照格式无效，未显示可能不完整的任务。": "Invalid task snapshot. Potentially incomplete tasks were not displayed.",
  "管理员任务字段或目标无效，未与聊天用户任务混合。": "Invalid administrator task fields or target. They were not mixed with chat-user tasks.",
  "任务操作确认格式无效。": "Invalid task operation receipt.",
  "任务提供方响应格式无效。": "Invalid task provider response.",
  "任务提供方字段无效。": "Invalid task provider fields.",
  "用途目录格式无效。": "Invalid use-case catalog.",
  "用途目录字段无效。": "Invalid use-case catalog fields.",
  "此任务使用复杂参数 Schema，当前工作台无法完整编辑；请使用提供方的正式入口。": "This task uses a complex parameter schema that this workbench cannot fully edit. Use the provider's supported interface.",
  "此任务包含尚不支持的嵌套或复合字段，表单未部分保存。": "This task includes unsupported nested or composite fields. No partial form was saved.",
  "{0}为必填项": "{0} is required",
  "{0}格式不正确": "Invalid {0} format",
  "{0}超出允许范围": "{0} is outside the allowed range",
  "{0}不在允许选项中": "{0} is not an allowed option",
  "{0}内容过短": "{0} is too short",
  "{0}内容过长": "{0} is too long",
  "{0}须为包含 Z 或 ±hh:mm 的完整 ISO 时间": "{0} must be a complete ISO date-time with Z or ±hh:mm",
  "参数含当前 Schema 未声明的字段，未静默删除；请核对草稿或明确重新配置。": "Parameters contain fields not declared by the current schema. They were not silently removed; review the draft or explicitly reconfigure.",
  "提供方未返回具体时间，请查看执行规则与任务详情": "The provider did not return a specific time. Check execution rules and task details.",
  "时间超出可显示范围，请检查任务提供方": "Time is outside the displayable range. Check the task provider.",
  "{0}（提供方时区无效）": "{0} (invalid provider timezone)",
  "{0}年{1}月{2}日 {3}:{4}{5}（{6}）": "{0}-{1}-{2} {3}:{4}{5} ({6})",
  "空列表": "Empty list",
  "空对象": "Empty object",
  "确认后保存管理员任务，后续按提供方的执行规则运行。请核对下方外部影响及投递目标；不会发送测试消息。": "Confirm to save an administrator task, which will run under the provider's rules. Review the external effects and delivery target below. No test message will be sent.",
  "确认后请求暂停后续执行；已经开始的投递无法撤回。": "Confirm to request a pause of future executions. Deliveries already started cannot be recalled.",
  "确认后请求恢复调度，后续执行时间以提供方返回为准。不会重试不确定的投递。": "Confirm to resume scheduling. The provider determines the next execution time. Uncertain deliveries will not be retried.",
  "确认后取消后续执行，无法撤回已经开始或结果不确定的投递。": "Confirm to cancel future executions. Deliveries already started or with an uncertain outcome cannot be recalled.",
  "确认后保存参数修改，投递目标保持不变；后续执行以提供方返回的任务状态为准。": "Confirm to save parameter changes. The delivery target stays the same; subsequent execution follows the state returned by the provider.",
  "请核对目标与操作内容。": "Review the target and operation.",
  "缺少当前代、修订或操作身份，请刷新核对。": "Current generation, revision or operation identity is missing. Refresh to verify.",
  "任务操作无效": "Invalid task operation",
  "该任务当前不允许此操作，请刷新核对。": "This operation is not currently allowed for the task. Refresh to verify.",
  "请提供完整投递目标与参数。": "Provide a complete delivery target and parameters.",
  "无法读取当前应用证据": "Unable to read current application evidence",
  "当前 Host 未提供群欢迎用途，请更新 Host 或使用原插件管理入口。": "This Host does not provide the group-welcome use case. Update the Host or use the original plugin management page.",
  "实例目录身份不完整或重复，请刷新 Host 目录。": "Instance catalog identities are incomplete or duplicated. Refresh the Host catalog.",
  "实例或运行代证据已变化，请重新读取；未执行业务检查。": "Instance or generation evidence changed. Read it again; no business check was run.",
  "配置文件版本或实例路径与应用证据不一致，请重新读取。": "The configuration revision or instance path differs from application evidence. Read it again.",
  "配置源码无法安全读取，请在原配置页核对格式与实例路径。": "Configuration source cannot be safely read. Check the format and instance path on the configuration page.",
  "群欢迎字段不是可识别的配置，请到原配置页核对。": "Group-welcome fields are not recognized. Check them on the configuration page.",
  "已启用的项目至少需要一位负责人": "An enabled project needs at least one owner",
  "负责人标识不能为空或含首尾空格": "Owner identity cannot be empty or have leading/trailing spaces",
  "负责人标识不能重复": "Owner identities must be unique",
  "Endpoint {0} 不在当前 Runtime Endpoint 列表中，请重新选择或改为继承主空间。": "Endpoint {0} is no longer in the Runtime list. Select another or inherit the main space.",
  "Endpoint {0} 同时分配给多个 Agent（{1}），请为每个 Agent 选择独立出口。": "Endpoint {0} is assigned to multiple Agents ({1}). Select a separate outbound route for each Agent.",
  "目录尚未加载": "Catalog not loaded",
  "正在核验目录": "Verifying catalog",
  "刷新失败；保留未发布修改": "Refresh failed; unpublished changes preserved",
  "刷新失败；显示上次加载的目录": "Refresh failed; showing the previously loaded catalog",
  "存在未发布修改": "Unpublished changes",
  "已与持久目录同步": "Synchronized with the persisted catalog",
  "Project ID 不能为空": "Project ID cannot be empty",
  "Project ID 不能重复": "Project ID must be unique",
  "使用 1–64 位小写字母、数字、下划线或连字符，首位为字母或数字": "Use 1–64 lowercase letters, digits, underscores or hyphens; start with a letter or digit",
  "请选择消息渠道": "Select a messaging endpoint",
  "请输入协作空间标识": "Enter a collaboration space identity",
  "请选择协调成员": "Select a coordinating member",
  "当前渠道已不可用，请重新选择": "This endpoint is no longer available. Select another.",
  "仓库格式为 owner/repo": "Use owner/repo for the repository",
  "请选择具有 orchestrator 角色的成员": "Select a member with the orchestrator role",
  "请输入名称": "Enter a name",
  "已启用的项目需要至少一位协调成员": "An enabled project needs at least one coordinating member",
  "请选择 Agent": "Select an Agent",
  "当前 Agent 已不可用，请重新选择": "This Agent is no longer available. Select another.",
  "同一 Agent 的角色不能重复": "Roles for the same Agent must be unique",
  "请输入远程入口标识，不含首尾空格": "Enter a remote entry identity without leading/trailing spaces",
  "此空间已用于其他协作或负责人空间，请使用不同标识。": "This space is already used by another collaboration or owner space. Use a different identity.",
  "此消息出口对应的空间已被其他项目占用。": "The space for this message route is already assigned to another project.",
  "共享负责人空间的项目必须配置相同且非空的负责人集合。": "Projects sharing an owner space must have the same nonempty set of owners.",
  "当前 Host 版本不支持 Workroom 披露状态；请升级 @zhin.js/cli 到最新版并重启 Host。": "This Host does not support Workroom disclosure state. Update @zhin.js/cli and restart the Host.",
  "确认当前 {0} 个 Agent、{1} 个工具、{2} 个技能作为首份能力配置，并发布任务规划与数据处理权限。": "Confirm the current {0} Agents, {1} tools and {2} skills as the initial capability configuration, and publish planning and data-processing permissions.",
  "为当前能力配置发布任务规划与模型数据处理权限。": "Publish task-planning and model data-processing permissions for the current capability configuration.",
  "为当前项目发布模型数据处理权限。": "Publish model data-processing permissions for the current project.",
  "Workroom 列表响应格式不正确": "Invalid Workroom list response",
  "Workroom 运行摘要格式不正确": "Invalid Workroom run summary",
  "Workroom 运行计数格式不正确": "Invalid Workroom run counts",
  "Workroom 详情响应缺少治理投影": "Workroom details are missing the governance projection",
  "服务端返回了无效 JSON": "The server returned invalid JSON",
  "群欢迎配置流程": "Group welcome setup",
  "插件管理": "Plugins",
  "插件市场": "Marketplace",
  "聊天账号详情": "Chat account details",
  "请填写 API Base URL": "Enter an API Base URL",
  "Host 健康检查失败 (HTTP {0})": "Host health check failed (HTTP {0})",
  "无法连接 Host，请确认地址正确、服务已启动，且 CORS 已包含当前 Console 来源": "Unable to connect to the Host. Check the address, running service and CORS allowance for this Console origin.",
  "请填写 API Base URL（如 http://localhost:8086）": "Enter an API Base URL, such as http://localhost:8086",
  "请输入 Token": "Enter a Token",
  "Token 无效，请检查后重试": "Invalid Token. Check it and retry.",
  "验证失败 (HTTP {0})": "Verification failed (HTTP {0})",
  "无法连接到 API，请检查 Base URL 与网络": "Unable to connect to the API. Check the Base URL and network.",
  "ICQQ 需已登录且在线；好友/群/频道列表在连接成功后由 Host 同步。": "ICQQ must be logged in and online. The Host synchronizes friend, group and channel lists after connection.",
  "QQ 官方机器人通过 Endpoint 频道目录拉取子频道。": "The official QQ bot retrieves subchannels through the Endpoint channel catalog.",
  "NapCat 通过 OneBot 好友/群列表拉取会话；频道走 Endpoint 频道目录。": "NapCat retrieves friend/group conversations through OneBot; channels use the Endpoint catalog.",
  "适配器「{0}」通过 Endpoint 频道目录拉取频道；若无数据将尝试从收件箱历史恢复。": "Adapter “{0}” uses the Endpoint channel catalog. If empty, conversations may be recovered from inbox history.",
  "暂无好友会话": "No private conversations",
  "此适配器无私聊列表": "This adapter has no private-conversation list",
  "暂无群聊": "No groups",
  "此适配器无群聊列表": "This adapter has no group list",
  "暂无 QQ 频道子频道": "No QQ subchannels",
  "暂无频道": "No channels",
  "暂无频道会话": "No channel conversations",
  "当前身份无权读取{0}。请使用具备相应权限的身份连接 Host。": "Your identity cannot read {0}. Connect with the required permissions.",
  "{0}读取失败。请检查错误详情后重试。": "Failed to read {0}. Check the error details before retrying.",
  "[demo] 缺少 VITE_API_BASE 或 VITE_API_TOKEN，无法预连 demo-api": "[demo] VITE_API_BASE or VITE_API_TOKEN is missing; demo-api preconnection is unavailable",
  "打开会话": "Open session",
  "机器人是否正常、有什么要处理": "Check bot health and pending work",
  "看看 AI 机器人是否准备好、最近做了什么": "Check whether the AI bot is ready and what it has done recently",
  "按 Project 查看 Workroom Run、Task 与 Assignment": "View Workroom runs, tasks and assignments by project",
  "配置协作空间、Bot Endpoint 与成员 Agent 映射": "Configure collaboration spaces, Bot Endpoints and member Agent mappings",
  "看看机器人和大家聊过什么，并从某段继续聊": "Review bot conversations and continue a session",
  "查看聊天账号、群和好友申请": "View chat accounts and group/friend requests",
  "检查命令、中间件、组件、Endpoint、Agent、工具与 MCP": "Inspect commands, middleware, components, Endpoints, Agents, tools and MCP",
  "查看出错、警告和运行过程": "View errors, warnings and runtime activity",
  "到点自动做事或发提醒": "Run tasks or send reminders on schedule",
  "开关和设置已装的功能": "Enable and configure installed features",
  "找新功能并安装": "Find and install new features",
  "编辑项目配置并查看配置结构": "Edit project configuration and inspect its structure",
  "管理运行环境变量": "Manage runtime environment variables",
  "浏览和编辑项目文件": "Browse and edit project files",
  "检查数据表、记录与持久化状态": "Inspect tables, records and persistence",
  "查看错误日志": "View error logs",
  "快捷动作": "Quick actions",
  "只显示 error 级别的运行日志": "Show error-level runtime logs only",
  "试运行命令": "Inspect commands",
  "打开命令目录并检查参数契约": "Open the command catalog and inspect parameter contracts",
  "预览消息组件": "Preview message components",
  "用真实消息渲染器检查组件输出": "Inspect component output with the actual message renderer",
  "配置 Workroom 关系": "Configure Workroom relationships",
  "管理 Project、协作空间、Bot 与 Agent 映射": "Manage projects, collaboration spaces, Bots and Agent mappings",
  "检查 Agent 工具": "Inspect Agent tools",
  "查看 Tool Schema、来源与可用性": "View tool schemas, sources and availability",
  "零安装体验 Zhin": "Try Zhin without installing",
  "你已连接到官方托管 Demo Host（": "You are connected to the official hosted Demo Host (",
  "），无需 API Base / Token。": "). No API Base or Token is needed.",
  "QQ 群助手 + 可选 @AI": "QQ group assistant + optional @AI",
  "— 先在 Demo 里玩通，再部署到本机或接 QQ。": "— Try the Demo, then deploy locally or connect QQ.",
  "试试 hello 与 card": "Try hello and card",
  "在侧栏打开": "Open",
  "沙盒": "Sandbox",
  "，依次发送：": "from the sidebar and send:",
  "— 命令 Bot 回复": "— command Bot reply",
  "— JSX 状态卡片": "— JSX status card",
  "ai: 你好": "ai: Hello",
  "— Agent 对话（Demo 已启用 Ollama）": "— Agent conversation (Ollama is enabled in the Demo)",
  "下一步（任选）": "Next steps (optional)",
  "部署到本机 · npm create zhin-app": "Deploy locally · npm create zhin-app",
  "接 QQ Bot · ICQQ 适配器": "Connect a QQ Bot · ICQQ adapter",
  "Host 未提供可解释的 Schema。": "The Host did not provide an explainable schema.",
  "Schema 与当前运行代不一致，无法给出可靠解释。": "The schema does not match the current generation; explanations would be unreliable.",
  "此实例使用自定义配置解析，Host 不推测字段来源。": "This instance uses custom configuration parsing. The Host does not infer field origins.",
  "此 Schema 超出首版可证明的静态字段范围。": "This schema exceeds the statically verifiable field scope.",
  "当前没有可证明的实例运行证据。": "No verifiable runtime evidence is currently available for this instance.",
  "字段数量或元数据大小超过解释上限，Host 未截断后冒充完整结果。": "Field count or metadata size exceeds the explanation limit. The Host did not present truncated evidence as complete.",
  "已保存的候选配置未通过解释所需的校验。": "The saved candidate did not pass the validation required for explanations.",
  "配置文件明确设置": "Explicitly set in the configuration file",
  "Schema 声明默认值": "Declared schema default",
  "来源无法证明": "Origin cannot be established",
  "读取时与运行代一致": "Matched the running generation when read",
  "读取时与运行代不同": "Differed from the running generation when read",
  "敏感或环境引用，未比较": "Sensitive or environment reference; not compared",
  "一致性无法证明": "Consistency cannot be established",
  "确认": "Confirm",
  "这个页面暂时无法显示": "This page is temporarily unavailable",
  "页面遇到了异常。你可以重试，或通过侧栏继续使用其他功能。": "The page encountered an error. Retry, or use the sidebar to continue with another feature.",
  "重试当前页面": "Retry this page",
  "返回 Dashboard": "Back to Dashboard",
  "常用": "Common",
  "机器人": "Bots",
  "功能": "Features",
  "高级": "Advanced",
  "机器人只在被 @ 或叫到时说话。": "The bot speaks only when mentioned or called by name.",
  "机器人会判断要不要接话并记下来，但不会真的在群里开口。适合先试一试。": "The bot records whether it would join a conversation, but does not speak. Useful for trying it out.",
  "没人叫它时，机器人觉得合适就会自己接话。": "The bot joins a conversation when appropriate, even when not called.",
  "想接话（只观察，没开口）": "Would have joined (observe only, stayed silent)",
  "这次没有判断": "Not assessed this time",
  "刚插过话，先歇一会儿": "Recently spoke; waiting before joining again",
  "这个小时插话次数已用完": "Hourly participation limit reached",
  "离上次判断太近": "Too soon after the last assessment",
  "群里消息太少": "Insufficient group messages",
  "这次判断没成功": "Assessment failed this time",
  "已保存。需要重启机器人才会生效。": "Saved. Restart the bot to apply these settings.",
  "已保存，马上生效，不用重启。": "Saved and effective immediately. No restart needed.",
  "Agent runtime 未装配": "Agent runtime is not installed",
  "查看完整值": "View complete value",
  "关系型": "Relational",
  "文档型": "Document",
  "键值型": "Key-value",
  "[文件]": "[File]",
  "如何阅读消息诊断": "How to read message diagnostics",
  "确认当前账号的命令前缀": "Check the command prefix for this account",
  "按命令帮助修正输入": "Correct input using command help",
  "核对权限规则与真实身份": "Check permission rules and actual identity",
  "定位中间件或消息处理器问题": "Locate middleware or message-handler problems",
  "查看 Agent 后续运行": "View subsequent Agent activity",
  "检查实际目标与消息能力": "Check the actual target and message capabilities",
  "投递不确定时如何核实": "Verify an uncertain delivery",
  "检查图片和文字降级": "Inspect image and text fallbacks",
  "仅保留最近 15 分钟、最多 500 条进程内记录；重启后清空。未找到不代表消息没有问题。": "Only the latest 15 minutes and at most 500 in-process records are retained; restart clears them. A missing record does not prove there was no problem.",
  "接收消息": "Receive message",
  "来源判断": "Classify origin",
  "指令前缀": "Command prefix",
  "中间件": "Middleware",
  "消息事件处理器": "Message event handlers",
  "分派": "Dispatch",
  "投递": "Delivery",
  "已接收": "Received",
  "人类消息": "Human message",
  "协作成员 Bot": "Collaborating member Bot",
  "其他 Bot": "Other Bot",
  "自身": "Self",
  "来源未分类": "Unclassified origin",
  "已匹配": "Matched",
  "前缀不匹配": "Prefix mismatch",
  "输入为空": "Empty input",
  "指令能力不可用": "Commands unavailable",
  "已开始": "Started",
  "已进入": "Entered",
  "链路已停止": "Chain stopped",
  "返回内容已替换": "Response replaced",
  "本阶段已结束": "Stage completed",
  "参数或格式无效": "Invalid parameters or format",
  "权限未通过": "Permission denied",
  "指令执行受限": "Command execution limited",
  "交互回调": "Interaction callback",
  "指令": "Command",
  "已交给 Agent": "Handed to Agent",
  "自身消息回声": "Self echo",
  "重复消息": "Duplicate message",
  "Bot 来源被拦截": "Bot-origin message blocked",
  "去重检查失败": "Deduplication check failed",
  "平台已受理": "Accepted by platform",
  "不支持": "Unsupported",
  "已拒绝": "Rejected",
  "已拦截": "Blocked",
  "投递结果不确定": "Delivery uncertain",
  "入站处理中": "Processing inbound message",
  "文本": "Text",
  "平台原生内容": "Platform-native content",
  "截图服务不可用": "Screenshot service unavailable",
  "截图渲染失败": "Screenshot rendering failed",
  "目标不支持该媒体": "Target does not support this media",
  "HTML 按文本策略降级": "HTML fell back to text by policy",
  "Markdown 按文本策略降级": "Markdown fell back to text by policy",
  "按钮按文本策略降级": "Buttons fell back to text by policy",
  "已踢出群成员": "Group member removed",
  "已禁言群成员": "Group member muted",
  "已更新管理员权限": "Administrator permissions updated",
  "按用户入口理解命令路由、参数契约与权限边界。": "Understand command routes, parameter contracts and permissions from the user's entry point.",
  "执行管线": "Execution pipeline",
  "按照 Phase 与 Order 查看请求穿过 Runtime 的真实顺序。": "Inspect the actual Runtime sequence by phase and order.",
  "查看组件并预览效果。": "Browse components and preview their appearance.",
  "从适配器视角检查当前连接与运行状态。": "Inspect connections and runtime state from the adapter's perspective.",
  "理解 Agent、模型 Provider、MCP Server 与 Agent File 的组合。": "Understand the relationships between Agents, model providers, MCP servers and Agent files.",
  "检查 Agent 可发现的工具、职责说明与注册来源。": "Inspect discoverable Agent tools, responsibilities and registration sources.",
  "提示词片段": "Prompt sections",
  "查看提示词片段的来源与适用范围。": "Inspect prompt section sources and applicability.",
  "观察外部能力服务的连接健康度与工具供给。": "Observe external capability-service health and available tools.",
  "来源文件": "Source file",
  "参数": "Parameters",
  "别名": "Aliases",
  "权限": "Permissions",
  "阶段": "Phase",
  "目标": "Target",
  "顺序": "Order",
  "适配器": "Adapter",
  "状态": "Status",
  "模型提供方": "Model provider",
  "模型": "Model",
  "Agent 文件": "Agent file",
  "完整名称": "Full name",
  "标题": "Title",
  "层级": "Level",
  "保留策略": "Retention policy",
  "字符上限": "Character limit",
  "适用配置": "Applicable configuration",
  "适用平台": "Applicable platforms",
  "运行代": "Generation",
  "内容字符数": "Content characters",
  "工具数": "Tool count",
  "错误": "Error",
  "全部": "All",
  "服务": "Services",
  "游戏": "Games",
  "特性": "Features",
  "相关度": "Relevance",
  "下载量": "Downloads",
  "最新": "Newest",
  "尚未安装": "Not installed",
  "依赖已安装": "Dependency installed",
  "实例已声明": "Instance declared",
  "需要完善配置": "Configuration required",
  "等待应用": "Awaiting application",
  "当前代已应用": "Applied in current generation",
  "状态降级": "Degraded",
  "纯文本端点（测试能力）": "Plain-text endpoint (test capability)",
  "HTML / Markdown 保留（测试能力）": "Preserve HTML / Markdown (test capability)",
  "等待执行": "Scheduled",
  "执行中": "Running",
  "已完成": "Completed",
  "已取消": "Cancelled",
  "修改": "Edit",
  "Zhin Bot 工作台": "Zhin Bot Workbench",
  "管理 Zhin Bot 的渠道、能力、Agent、自动化与运行状态。": "Manage Zhin Bot endpoints, capabilities, Agents, automation and runtime status.",
  "未知类型": "Unknown type",
  "版本未知": "Unknown version",
  "查看数据": "view data",
  "开始管理": "start managing",
  " · 本页排序": " · Sorted on this page",
  "降序": "Descending",
  "升序": "Ascending",
  "（只读且已遮罩）": "(read-only and masked)",
  "并切换文件": "and switch files",
  "并关闭文件": "and close the file",
  "已声明": "declared",
  "未声明": "not declared",
  "及其配置": "and its configuration",
  "平台（可能产生外部操作）": "Platform (may perform external operations)",
  "插件未声明额外副作用": "The plugin declares no additional side effects",
  "未命名": "Untitled",
"技能助手": "Skills assistant",
"让一个专门的小助手帮机器人挑技能、挑工具、判断要不要接话。": "Let a dedicated assistant help your bot choose skills and tools, and decide when to join a conversation.",
"技能助手状态": "Skills assistant status",
"当前账号没有查看技能助手的权限，请联系管理员开通。": "Your account cannot view the skills assistant. Contact an administrator for access.",
"最近 24 小时帮了 ": "Helped ",
" 次": " times",
"，其中 {0} 次没成功": " · unsuccessful: {0}",
"重启机器人后会重新计数。": "Counters reset when the bot restarts.",
"用了 ": "Used ",
" 次：给出建议 ": " times: suggestions ",
" 次，没有合适的 ": " times, no suitable suggestion ",
"，没成功 {0} 次": " · unsuccessful: {0}",
"平均每次 ": "Average duration: ",
"最近 24 小时还没有用到技能助手。": "The skills assistant has not been used in the past 24 hours.",
"还没有安装技能助手服务。": "The skills assistant service is not installed yet.",
"在机器人所在的电脑上运行 ": "On the computer running your bot, run ",
"，按提示填好密钥，然后重启机器人。": ", enter the key when prompted, then restart the bot.",
"现在用的是另一个服务来做这些判断，这个页面不能修改它。需要调整的话，请到「高级 → 配置」里改。": "Another service currently makes these decisions. This page cannot change it; use Advanced → Configuration.",
" 改完需要重启机器人才会生效。": " Restart the bot after changing these settings.",
"帮机器人挑技能": "Choose skills for the bot",
"根据聊天内容，推荐这次该用哪个技能。": "Suggest which skill to use for the current conversation.",
"帮机器人挑工具": "Choose tools for the bot",
"推荐这次该用哪些工具。": "Suggest which tools to use this time.",
"挑出相关的记忆": "Find relevant memories",
"从机器人记住的内容里挑出和这次对话有关的。": "Pick remembered information relevant to the current conversation.",
"决定交给哪个助手": "Choose an assistant",
"有多个助手时，推荐由谁来处理。": "Suggest who should handle the task when multiple assistants are available.",
"自动通过审批": "Approve operations automatically",
"需要审批的操作，由它判断能不能直接通过。风险较高，建议先「只观察」。": "Decide whether operations requiring approval may proceed. This has higher risk; start with Observe only.",
"判断群里要不要接话": "Decide whether to join a group conversation",
"配合「群聊插话」使用，由它来判断要不要开口。": "Works with Group participation to decide when to speak.",
"正式使用": "Apply suggestions",
"「只观察」会记下它的建议，但不改变机器人的行为，适合先试一试；「正式使用」才会真正按它的建议做。": "Observe only records suggestions without changing bot behavior, making it useful for evaluation. Apply suggestions puts the recommendations into effect.",
"给出了建议": "Suggested an option",
"没有合适的建议": "No suitable suggestion",
"只观察，记下了建议": "Observed and recorded a suggestion",
"这次没成功": "Unsuccessful attempt",
"技能助手状态格式不正确。": "Invalid skills assistant status.",
"技能助手记录格式不正确。": "Invalid skills assistant record.",
"{0} 毫秒": "{0} ms",
"{0} 秒": "{0} s",
"最近 24 小时帮了 {0} 次": "Past 24 hours · Assisted: {0}",
"用了 {0} 次：给出建议 {1} 次，没有合适的 {2} 次": "Calls: {0} · Suggestions: {1} · No suggestion: {2}",
"决策回放": "Decision replay",
"每次回或不回的原因": "Why it replied or stayed quiet",
"机器人每一次回或不回、调没调模型、发没发消息，都记在这里。新的在前，点回合可以看完整过程。": "Every time the bot replies or stays quiet, calls the model or not, and sends a message or not, it is recorded here. Newest first; open a turn to see the whole sequence.",
"当前账号没有查看决策回放的权限，请联系管理员开通。": "This account can't view the decision replay. Ask an administrator for access.",
"平台，如 icqq": "Platform, e.g. icqq",
"会话，如 group:123": "Conversation, e.g. group:123",
"类型": "Type",
"全部类型": "All types",
"结果": "Result",
"全部结果": "All results",
"导出范围": "Export range",
"导出中…": "Exporting…",
"导出 JSON": "Export JSON",
"已导出 {0} 条记录。": "Exported {0} records.",
"回合时间线": "Turn timeline",
"{0} 条记录，从 {1} 到 {2}": "{0} records, from {1} to {2}",
"（太长，只显示前一部分）": " (too long; showing the first part)",
"收起": "Hide",
"最近的决策": "Recent decisions",
"默认保留 14 天（ai.audit.retentionDays 可改）。": "Kept for 14 days by default (change with ai.audit.retentionDays).",
"没有接数据库，只能看到进程内最近 200 条，重启后清空。": "No database is connected, so only the last 200 in-process records are shown, cleared on restart.",
"看这个回合": "View this turn",
"还没有决策记录。": "No decision records yet.",
"决策记录格式不正确。": "The decision records are not in the expected format.",
"导出翻页没有前进，已停止。": "The export stopped because paging did not advance.",
"导出的记录太多，请缩小时间范围或加筛选。": "Too many records to export. Narrow the time range or add filters.",
"最近 1 小时": "Last hour",
"最近 24 小时": "Last 24 hours",
"最近 7 天": "Last 7 days",
"最近 14 天": "Last 14 days",
"收到消息 / 事件": "Message or event received",
"能不能在这里说话": "Allowed to speak here",
"被开关拦下": "Blocked by a switch",
"要不要自己接话": "Whether to chime in",
"没有调用模型": "Model not called",
"调用了模型": "Model called",
"调用工具": "Tool call",
"危险工具被拦下": "Dangerous tool blocked",
"危险工具审批": "Dangerous tool approval",
"发出消息": "Message sent",
"配置变更": "Configuration change",
"开关变更": "Switch change",
"放行": "Allowed",
"稍后": "Deferred",
"出错": "Error",
"未知原因": "Unknown reason",
"机器人在这里被禁言": "The bot is muted here",
"全员禁言中": "Everyone is muted",
"这里限制了机器人发言": "The bot's messages are restricted here",
"紧急停止已打开": "Emergency stop is on",
"机器人整体静音": "The bot is muted everywhere",
"这个会话静音": "This conversation is muted",
"只读模式": "Read-only mode",
"只在被 @ 时回复": "Replies only when @-mentioned",
"判断不需要接话": "Decided not to chime in",
"判断应该接话": "Decided to chime in",
"群里没有新动静": "Nothing new in the group",
"群里有需要处理的动静": "Something in the group needs attention",
"动静太频繁，先缓一缓": "Too many events; waiting a moment",
"处理群动静失败": "Failed to handle a group event",
"有人叫了机器人": "Someone addressed the bot",
"模型正常完成": "Model finished",
"模型调用失败": "Model call failed",
"模型调用被取消": "Model call cancelled",
"有更新的消息，这次作废": "Superseded by a newer message",
"已发送": "Sent",
"决定不发送": "Decided not to send",
"发送失败": "Send failed",
"危险工具没有审批": "Dangerous tool without approval",
"审批超时": "Approval timed out",
"审批被拒绝": "Approval denied",
"轨迹": "Trace",
"此轮用量": "Turn usage",
"模型用量": "Model usage",
"输入": "Input",
"总输入": "Total input",
"非缓存输入": "Non-cached input",
"消息正文未保存": "Message body was not retained",
"输出": "Output",
"缓存读取": "Cache read",
"缓存写入": "Cache write",
"推理": "Reasoning",
"系统提示": "System prompt",
"工具定义": "Tool definitions",
"输出格式": "Output format",
"技能目录": "Skill catalog",
"Agent 目录": "Agent catalog",
"已加载技能": "Loaded skills",
"记忆": "Memory",
"工作区指引": "Workspace instructions",
"历史消息": "History",
"当前输入": "Current input",
"首个请求的上下文（估算）": "First request context (estimated)",
"查看轨迹": "View trace",
"轨迹响应与当前会话不匹配，或格式无效。": "The trace response is invalid or belongs to a different conversation.",
"当前身份无权读取轨迹。": "Your current credentials cannot read traces.",
"记录已不可用，或 Host 尚不支持此功能。": "This record is unavailable, or this Host does not support it yet.",
"轨迹暂不可用，请稍后重试。": "Traces are temporarily unavailable. Try again later.",
"轨迹读取失败，请重试。": "Could not read the trace. Try again.",
"进行中": "In progress",
"达到用量上限": "Usage limit reached",
"未开启正文记录": "Request recording was disabled",
"此请求未记录正文": "Request body was not recorded",
"正文超过记录容量": "Request body exceeded the recording capacity",
"正文记录失败": "Request recording failed",
"正文已过期": "Request body has expired",
"开发者": "Developer",
"其他角色": "Other role",
"消息序列": "Messages",
"无工具定义": "No tool definitions",
"模型请求 {0}": "Model request {0}",
"此回合没有保留模型请求正文。": "No model request bodies were retained for this turn.",
"工具调用": "Tool calls",
"子任务": "Subtask",
"上下文构成": "Context breakdown",
"最近 {0} 个回合": "Latest {0} turns",
"暂无可关联的轨迹": "No associated traces",
"模型未记录": "Model not recorded",
"Token 用量": "Token usage",
"机器人调用模型花了多少 token：按时间、模型和会话拆开看，也能看缓存命中情况。": "How many tokens the bot spends on model calls, by time, model and conversation, including cache hits.",
"当前账号没有查看 Token 用量的权限，请联系管理员开通。": "This account can't view token usage. Ask an administrator for access.",
"时间范围": "Time range",
"今天": "Today",
"近 7 天": "Last 7 days",
"近 30 天": "Last 30 days",
"自定义": "Custom",
"开始时间": "Start time",
"结束时间": "End time",
"统计粒度": "Granularity",
"自动": "Auto",
"小时": "Hour",
"天": "Day",
"按会话筛选，如 icqq:8596238:group:123": "Filter by conversation, e.g. icqq:group:123",
"清除会话": "Clear conversation",
"自定义范围的开始时间必须早于结束时间。": "The start time must be earlier than the end time.",
"总输入 tokens": "Total input tokens",
"输出 tokens": "Output tokens",
"缓存命中率": "Cache hit rate",
"单次调用": "Per call",
"模型调用次数": "Model calls",
"回合数": "Turns",
"这段时间没有模型调用记录。": "No model calls in this period.",
"换一个时间范围或清除会话筛选试试。": "Try another time range or clear the conversation filter.",
"输入 tokens 随时间变化": "Input tokens over time",
"按 provider/model 堆叠；鼠标停在柱子上看具体数值。": "Stacked by provider/model; hover a bar for exact values.",
"缓存命中率随时间变化": "Cache hit rate over time",
"命中率 = 缓存读取 / 输入；没有调用的时段不画点。": "Hit rate = cache read / input; periods without calls have no point.",
"按模型": "By model",
"输入 / 输出 / 缓存读取，按输入从多到少。": "Input / output / cache read, most input first.",
"输入构成": "Input composition",
"历史对话、固定提示词、用户输入各占多少。": "How much comes from history, fixed prompts and user input.",
"用量最高的会话": "Top conversations",
"最多 50 个；点一行只看这个会话。": "Up to 50; click a row to filter to that conversation.",
"平台": "Platform",
"会话 ID": "Conversation ID",
"回合": "Turns",
"调用": "Calls",
"按{0}排序": "Sort by {0}",
"有 {0} 行用量记录无法解析，已忽略。": "{0} usage lines could not be parsed and were ignored.",
"图例": "Legend",
"其他": "Other",
"{0} 次调用": "{0} calls",
"历史": "History",
"固定": "Fixed",
"用户输入": "User input",
"会话": "Conversation",
"筛选": "Filter",
"刷新": "Refresh",
"用量数据格式不正确。": "The usage data has an unexpected format.",
"最近会话未能读取，仅显示本机历史。": "Recent sessions could not be loaded; showing this browser's history only.",
"群名未能读取，暂以群号显示。": "Group names could not be loaded; showing group IDs instead.",
"取消管理员": "Remove admin",
"确定取消「{0}」的群管理员身份？": "Remove group admin rights from \"{0}\"?",
"踢出": "Remove",
"禁言时长（分钟）": "Mute duration (minutes)",
"1 分钟到 30 天（43200 分钟）。": "1 minute to 30 days (43200 minutes).",
"取消管理": "Revoke admin",
"设为管理": "Make admin",
"Workroom": "Workroom"
})
